export default {
  locales: {
    de: "German",
  },
  fatca: "FATCA",
  crs: "CRS",
  acttrader: "ActTrader",
  compairacc: "Konten vergleichen",
  ecnacc: "ECN-KONTO",
  openacc: "Konto eröffnen",
  crypto: "Cyrptocurrencies",
  stock: "Aktien",
  forex: "Forex",
  indices: "Indizes",
  commodities: "Commodities",
  negativebalance: "Schutz vor negativem Saldo",
  minorderdest: "Min.Bestellung Abstand",
  stopout: "Stoppen Sie",
  margincall: "Nachschussforderung",
  yes: "Ja",
  no: "Nein",
  lot: "Los",
  usd: "USD",
  eur: "EUR",
  gbp: "GBP",
  aud: "AUD",
  basecurrency: "Basiswährungen",
  upto: "bis zu",
  mindeposit: "Min. Einzahlung",
  account: "Konto",
  zulu: "zulu",
  zulu_trade: "Zulu-Handel",
  plus: "plus",
  max: "max",
  min: "min",
  leverage: "Hebelwirkung",
  per: "per",
  commission: "Kommission",
  minpip: "min. Kern",
  spreads: "Spreads",
  spread: "Streuen Sie",
  ecn: "ECN",
  keyinfo: "Wichtige Info-Dokumente",
  mifid: "MIFID-Gesetzgebung",
  privacypolicy: "Datenschutzbestimmungen",
  contact: "Kontakt 24/5",
  webtrader: "Web-Trader",
  login: "Anmeldung",
  joinNow: "Jetzt teilnehmen",
  aboutAAAfx: {
    name: "Über AAAFx",
    submenu: {
      why: {
        title: "Warum AAAFx",
        tagline: "Wissen wer wir sind",
      },
      safety: {
        title: "Sicherheit der Mittel",
        tagline: "Wir halten Ihnen den Rücken frei",
      },
      servers: {
        title: "Unsere Server",
        tagline: "Beste Systeme für beste Ergebnisse",
      },
      regulations: {
        title: "Vorschriften und Lizenzen",
        tagline: "Zuverlässiger und sicherer Handel",
      },
      legalDocs: {
        title: "Juristische Dokumente",
        tagline: "Alle rechtlichen Dokumente lesen",
      },
      careers: {
        title: "Karriere",
        tagline: "Werden Sie Mitglied unseres Teams",
      },
      contactUs: {
        title: "Kontaktieren Sie uns",
        tagline: "Wir würden uns freuen, von Ihnen zu hören",
      },
    },
    title:
      "Triple A Experts Investment Services Single Member SA ist in der EU zugelassen und wird von der Hellenic Capital Market Commission (id:2/540/17.2.2010) reguliert. Die eingetragene Adresse lautet Triple A Experts Investment Services Single Member S. A, 580 Vouliagmenis Avenue 16452, Argyroupoli Attica",
  },
  trading: {
    name: "Handel",
    submenu: {
      products: {
        title: "Handelsprodukte",
        tagline: "Handelsinstrumente, die wir anbieten",
      },
      accountTypes: {
        title: "Konten-Typen",
        tagline: "Wählen Sie, was Ihren Anforderungen entspricht",
      },
      tradingConditions: {
        title: "Handelsbedingungen",
        tagline: "Alles zu Ihrem Vorteil",
      },
      depWithdrawal: {
        title: "Einzahlungen & Abhebungen",
        tagline: "Problemlose Geldverwaltung",
      },
    },
  },
  platforms: {
    name: "Plattformen",
    submenu: {
      mt4: {
        title: "MT4",
        tagline: "Beliebteste Handelsplattform",
      },
      mt5: {
        title: "MT5",
        tagline: "Fortschrittlich und multifunktional",
      },
      act: {
        name: "ACT",
        title: "ActTrader",
        tagline: "Einfach zu benutzen und sehr praktisch",
      },
      comparison: {
        title: "Vergleich von Plattformen",
        tagline: "Treffen Sie eine informierte Entscheidung",
      },
    },
  },
  promotions: {
    name: "Werbeaktionen",
    submenu: {
      bonus: {
        title: "Einzahlungsbonus",
        tagline: "Verdoppeln Sie Ihre Gewinnspanne zum Nulltarif",
      },
      refer: {
        title: "Empfehlen & Verdienen",
        tagline: "Laden Sie Ihre Freunde ein und teilen Sie die Vorteile",
      },
      vps: {
        title: "Kostenloser VPS",
        tagline: "Nutzen Sie den kostenlosen Hochgeschwindigkeitshandel",
      },
    },
  },
  tools: {
    name: "Tools & Ressourcen",
    submenu: {
      zulu: {
        title: "ZuluTrade",
        tagline: "Treten Sie dem größten sozialen Handelsnetzwerk bei",
      },
      calculators: {
        title: "Trading-Rechner",
        tagline: "Berechnungen für Sie leicht gemacht",
      },
      ecoCalendar: {
        title: "Wirtschaftskalender",
        tagline: "Bleiben Sie auf dem Laufenden und handeln Sie klug",
      },
      partnerships: {
        title: "Partnerschaften",
        tagline: "Partner mit uns und wachsen",
      },
      faq: {
        title: "FAQs",
        tagline: "Erhalten Sie Antworten auf häufige Fragen",
      },
    },
  },
  legalinfo: {
    name: "Rechtliche Informationen",
    para1:
      "Triple A Experts Investment Services Single Member SA ist in der EU zugelassen und wird von der Hellenic Capital Market Commission (id:2/540/17.2.2010) reguliert. Die eingetragene Adresse lautet Triple A Experts Investment Services S.A., 14 Akti Kondyli street, 18545 Piraeus, Griechenland.",
    para2:
      "Sikhula Venture Capital (Pty) Ltd. ist von der südafrikanischen Financial Sector Conduct Authority zugelassen und wird von ihr reguliert (FSCA Nr. 2017/315029/07).",
    para3:
      "www.aaafx.com wird von Triple A Experts Investment Services Single Member SA betrieben.",
    para4:
      "www.aaafx.com wird von Triple A Experts Investment Services Single Member SA betrieben.",
  },
  riskdisc: {
    name: "Risiko-Offenlegung",
    para_one:
      "CFDs sind komplexe Instrumente und bergen aufgrund der Hebelwirkung ein hohes Risiko, schnell Geld zu verlieren.",
    para_two:
      "der Konten von Kleinanlegern verlieren Geld beim Handel mit CFDs bei AAAFx. Sie sollten sich überlegen, ob Sie verstehen, wie CFDs funktionieren und ob Sie es sich leisten können, das hohe Risiko einzugehen, Ihr Geld zu verlieren. Details finden Sie unter",
    link: "hier.",
  },
  accounttypepage: {
    title: "Konto-Typen",
    tagline1:
      "Wählen Sie das Konto, das Ihren Handelsbedürfnissen entspricht! Wir haben spannende Angebote für",
    tagline2: "für jeden Händler, und zwar auf eine stark vereinfachte Weise.",
    zeroPointZero: "0.0",
    hundredDollar: "$100k",
    fiveDollar: "$5",
    threeDollar: "$3",
    thirtyX: "30X",
    hundered: "$100",
    tenThousand: "$10,000",
    chf: "CHF",
    seventyFifty: "70/50%",
    para1: {
      desc1:
        "Es gibt drei verschiedene Kontotypen, die den Anforderungen eines Einsteigers, eines professionellen Händlers oder eines institutionellen Händlers entsprechen. Einige der gemeinsamen spannenden Funktionen, die bei allen Konten gewährleistet sind, sind:",
      point1: "EU-regulierter Broker",
      point2: "Ultra-Dünne Brotaufstriche",
      point3: "Alle Handelsstrategien erlaubt",
      point4: "Kein Min. Bestellabstand - Bestellen Sie nach Belieben",
      point5: "Schutz vor negativem Saldo",
      point6: "Micro Lots Handel",
      desc2:
        "Ohne jegliche Diskriminierung bieten wir allen Händlern Spreads und Liquidität auf institutionellem Niveau.",
    },
    accdesc: {
      title: "Konto Beschreibung",
      point1: {
        title: "ECN-Konto",
        desc: "Genießen Sie rohe ECN-Spreads und blitzschnelle Handelsausführung zu sehr niedrigen Kosten. Niedrige Kommissionsgebühren und geringe Swap-Gebühren in Kombination mit unserer fortschrittlichen Technologie machen Ihr Handelserlebnis in jeder Hinsicht vorbildlich. Auch bei den Handelsstrategien gibt es bei uns keine Einschränkungen.",
      },
      point2: {
        title: "ECN plus Konto",
        desc: "Für Händler mit einer Mindesteinlage von $10.000 oder der Kategorie AAA im Loyalitätsprogramm ist ECN Zero eine Belohnung, nach der man sich sehnt. Dies ist die beste Kombination, die für jeden Händler möglich ist - Null Kommission auf Forex mit hauchdünnen Spreads, ohne Aufschlag. Das alles können Sie zusammen mit unserer blitzschnellen Handelsausführung genießen.",
      },
      point3: {
        title: "ECN Zulu Handelskonto",
        desc: "Werden Sie Teil der größten Social Trading-Community, indem Sie ein Zulu-Konto bei uns eröffnen. Dieses Konto wird automatisch mit der Zulu-Plattform verbunden, es sind keine weiteren Schritte erforderlich. So kommen Sie automatisch in den Genuss hauchdünner Spreads, niedriger Provisionen, unserer fortschrittlichen Technologie, hoher Liquidität und blitzschneller Ausführung sowie eines direkten Zugangs zur Weltklasse-Handelsgemeinschaft.",
      },
      para1:
        "Für Kunden, die als Professional eingestuft sind, können flexiblere Handelsbedingungen (höhere Hebelwirkung) gelten. Bitte loggen Sie sich in Ihr Konto ein und prüfen Sie, ob Sie als professioneller Kunde eingestuft werden können, oder schreiben Sie uns an",
    },
    supportEmail: "support{'@'}aaafx.com",
  },
  acttraderpage: {
    title: "ActTrader",
    para1:
      "Sie möchten handeln, sind sich aber unsicher, was die fortgeschrittenen Handelsplattformen angeht?",
    para2:
      " Mit unserer ActTrader Handelsplattform haben wir für Sie vorgesorgt. ActTrader ist seit dem Jahr 2000 der Spitzenreiter in der Online-Handelsbranche, ausgestattet mit der besten Technologie seiner Klasse. Die Plattform konzentriert sich auf Einfachheit, Lesbarkeit und die Infragestellung bestehender Handelstraditionen mit robuster Technologie, so dass sich der Benutzer voll und ganz auf die Handelsoptionen konzentrieren kann. ActTrader hat eine Vervielfachung des Handelsvolumens auf bis zu 5 Billionen Dollar pro Monat erlebt, was die hohe Liquidität der Plattform belegt.",
    para3: "Beginnen Sie Ihre reibungslose Handelsreise mit ActTrader:",
    questionnaire: {
      question1: {
        heading: "Schritte zum Herunterladen von ActTrader Desktop",
        point: "1. Laden Sie die Plattform über den obigen Link herunter.",
        point1: "2. Führen Sie die .exe-Datei aus",
        point2:
          "3. Geben Sie Ihre Handelskontonummer und Ihr Passwort auf Ihrer ACT-Plattform ein.",
        point3:
          " 4. Wählen Sie den Kontotyp: Demo für ein Demokonto / Real für ein Live-Konto.",
        point4: "5. Wählen Sie Ihre bevorzugte Sprache.",
        point5: '6. Klicken Sie auf "Anmelden".',
        point6: "7. Es öffnet sich ein kleines Feld. Wählen Sie die Zeitzone.",
        point7:
          "8. Auch hier öffnet sich ein kleines Feld. Wählen Sie das Layout der Plattform Anfänger / Fortgeschrittene.",
      },
      question2: {
        heading: "Schritte zur Deinstallation von ActTrader Desktop",
        point: "1. Klicken Sie auf die Schaltfläche Start in Windows",
        point1:
          "2. Die ACT-Bewerbung wird in die Liste der Programme aufgenommen.",
        point2:
          '3. Klicken Sie mit der rechten Maustaste auf den Namen der Anwendung und wählen Sie "Deinstallieren".',
      },
      question3: {
        heading: "Schritte zur Anmeldung beim webbasierten Act Trader",
        point: "1. Klicken Sie auf den Link Web Trader",
        aTag: "hier",
        point1:
          '2. Wählen Sie "Demo Web Trader" für ein Demokonto oder "Live Web Trader" für ein Live-Konto.',
        point2: "3. Eine neue Registerkarte wird geöffnet.",
        point3: "4. Geben Sie die Anmeldedaten ein. Sie sind jetzt eingeloggt.",
      },
      question4: {
        heading: "Schritte zum Herunterladen von ActTrader Android",
        point: "1. Installieren Sie die Anwendung über den obigen Link.",
        point1:
          "2. Klicken Sie auf die installierte Anwendung auf Ihrem Android-Gerät.",
        point2: '3. Drücken Sie auf "Zustimmen" bei der Lizenzvereinbarung.',
        point3:
          "4. Sie müssen Ihre Handelskontonummer als Benutzernamen und das dazugehörige Passwort eingeben.",
        point4:
          "5. Wählen Sie den Kontotyp: AAAFX Demo für Demo und AAAFX Live für Live.",
        point5: '6. Klicken Sie auf "Anmelden".',
      },
      question5: {
        heading: "Schritte zur Deinstallation von ActTrader Android",
        point:
          "1. Gehen Sie im Menü zu Einstellungen > Anwendungen > Anwendungen verwalten",
        point1:
          "2. Suchen Sie dort ACT und tippen Sie auf den Namen des Programms.",
        point2: "3. Tippen Sie auf Deinstallieren.",
      },
      question6: {
        heading: "Schritte zum Herunterladen von ActTrader iOS",
        point: "1. Öffnen Sie die ActPhone App.",
        point1:
          "2. Geben Sie die Anmeldedaten ein, die Sie per E-Mail erhalten haben.",
        point2:
          "3. Scrollen Sie unter Kontotyp nach unten und wählen Sie AAAFX Demo für ein Demokonto oder AAAFX Live für ein Live-Konto.",
        point3:
          "4. Wählen Sie Anmelden und warten Sie, bis Ihr Konto geladen ist.",
      },
      question7: {
        heading: "Schritte zur Deinstallation von ActTrader iOS",
        point:
          "1. Drücken Sie lange auf das ActTrader-Anwendungssymbol, bis alle Symbole auf Ihrem Bildschirm zu wackeln beginnen.",
        point1:
          '2. Klicken Sie auf das "x" in der oberen linken Ecke des Symbols für die ActTrader-Anwendung.',
      },
    },
    journey: "Beginnen Sie Ihre reibungslose Handelsreise mit ActTrader:",
    heading:
      "AAAFx ActTrader verspricht, dass der Benutzer eine Vielzahl von Handelsmöglichkeiten mit maßgeschneiderten Bedingungen und der Möglichkeit, alles von Grund auf zu überblicken, erkunden kann.",
    features: "Die wichtigsten Merkmale der AAAFx ActTrader Plattform:",
    platform:
      "Zögern Sie noch? Werfen Sie einen Blick auf den kurzen Überblick über die Funktionen der ActTrader-Plattform:",
    depth: "Eingehende Analysetools:",
    ul: {
      li: "Große Auswahl an bereits installierten Indikatoren",
      li1: "Mehrere Zeichenwerkzeuge zur Verwendung über den Diagrammen",
      li2: "Vereinfachtes Arbeiten mit der Ein-Klick-Handelsoption",
      li3: "Richten Sie wichtige Preiswarnungen ein, damit Sie keine Gelegenheit verpassen",
      li4: "Exportieren Sie Kontodaten ganz bequem direkt in Excel",
      liTag: "Zusätzlichen Arbeitsbereich hinzufügen/entfernen",
      liTag1: "Formatieren Sie die Einstellungen für Datum und Uhrzeit",
      liTag2:
        "Bringen Sie Farbe in Ihr Handelsterminal und gestalten Sie Ihren Arbeitsbereich nach Ihren Vorstellungen",
      liTag3: "Streamen Sie die Preise der Plattformen so, wie Sie es möchten",
      liTag4: "70+ Forex-Währungen",
      liTag5: "Beliebte Rohstoffe wie Gold und Öl",
      liTag6: "11 globale Indizes - Nasdaq, Dow Jones, usw.",
      liTag7: "Die 6 wichtigsten und meist gehandelten Kryptowährungen",
    },
    tradingWindow: "Personalisieren Sie Ihr Handelsfenster:",
    instument: "Angebotene Instrumente:",
    liveAccount: "LIVE-KONTO ERÖFFNEN",
    demoAccount: "DEMO-KONTO ERÖFFNEN",
  },
  loginPage: {
    h3Tag: "Bitte warten Sie. Weiterleitung zu Ihrem Konto",
  },
  compensation: {
    title: "Entschädigungsfonds",
    questions: {
      ques: "Was ist die Finanzkommission?",
      ans: "Die Finanzkommission ist ein einzigartiges, unabhängiges Gremium, das dafür sorgt, dass sich Händler sicher und geschützt fühlen. Das Hauptmotiv der Finanzkommission ist die schnelle und effektive Beilegung von Streitigkeiten zwischen Händlern und Brokern. Sie arbeitet auf eine Weise, bei der Transparenz, Schnelligkeit und Aufklärung die obersten Werte sind. Alle Dienstleistungen der Financial Commission sind für unsere Kunden absolut kostenlos.",
      ques1: "Wie funktioniert das?",
      ans1: "Ein Entschädigungsfonds wird von der Finanzkommission durch die Zuweisung von 10% der Mitgliedsbeiträge an den Fonds finanziert, die auf einem separaten Bankkonto gehalten werden und nicht zur Finanzierung des Betriebs oder anderer Aktivitäten der Organisation verwendet werden dürfen. Der Fonds bietet AAAFx-Kunden ein Sicherheitsnetz von bis zu 20.000 EUR für eine einzige Beschwerde.",
      ques2: "Warum sind wir der Finanzkommission beigetreten?",
      ans2: "Die Finanzkommission wurde von einigen der führenden Branchenspezialisten ins Leben gerufen, deren Hauptziel es ist, die Markttransparenz und die Servicestandards in der gesamten Forex-Branche zu erhöhen. Dies steht im Einklang mit dem, woran wir bei AAAFx wirklich glauben: Ehrlichkeit und Transparenz. Die Kunden in den Mittelpunkt unseres Geschäfts zu stellen, ist eine unserer wichtigsten Ideologien. Daher haben wir uns mit der Finanzkommission zusammengetan, um unseren Kunden eine effektive und zeitnahe Streitbeilegung zu ermöglichen.",
    },
    steps: "Was sind die Schritte eines Streits",
    process: "Lösungsprozess?",
    complaint: "Reklamation",
    pTag: "Ein Kunde kann sich an die Kommission wenden, wenn er",
    brTag: "haben eine offizielle Antwort von der",
    brTag1: "Makler bezüglich einer ungelösten Streitigkeit, die",
    brTag2: "die der Kunde für unbefriedigend hält.",
    investigation: "Nachforschungen",
    pTag1: "Sobald ihr Streitschlichtungsausschuss",
    brTag3: "die Beschwerde erhalten hat, Untersuchung und",
    brTag4: "die Forschung beginnt und eine Entscheidung wird getroffen",
    brTag5: "innerhalb von 1-2 Wochen.",
    text: "Entschädigung",
    pTag2: "Wenn Makler sich weigern, Entscheidungen zu befolgen",
    brTag6: "die von der Finanzkommission getroffen wurden, eine",
    brTag7:
      "wird dem Händler eine Entschädigung aus dem Sondervermögen gezahlt",
    brTag8: "Entschädigungsfonds.",
    decision: "Entscheidung",
    resolutionRegarding: "Die Entschließung des Ausschusses bezüglich",
    brTag9: "die Beurteilung der Streitigkeit ist bindend für",
    brTag10: "den Makler und muss von ihm eingehalten werden",
    brTag11: "den Makler.",
  },
  zuluTools: {
    title: "ZULUTRADE",
    pTag: "Handeln Sie nicht allein - Werden Sie Mitglied im größten sozialen Handelsnetzwerk",
    para: "Bei AAAFx haben Sie die Möglichkeit, mit Liquidität in institutioneller Qualität zu handeln und unsere hervorragenden Handelsbedingungen zu nutzen. Allerdings kann der Handel manchmal sowohl zeitlich als auch emotional sehr anstrengend sein, was für manche Menschen ein Hindernis für eine erfolgreiche Handelserfahrung sein kann.",
    bTag: "Bei AAAFx haben Sie die Möglichkeit, mit Liquidität in institutioneller Qualität zu handeln und unsere hervorragenden Handelsbedingungen zu nutzen. Allerdings kann der Handel manchmal sowohl zeitlich als auch emotional sehr anstrengend sein, was für manche Menschen ein Hindernis für eine erfolgreiche Handelserfahrung sein kann.",
    bTag1:
      "ZuluTrade wurde 2007 gegründet und hilft Anlegern dabei, außergewöhnliche Händler aus der ganzen Welt zu entdecken und ihre Strategien zu kopieren, um selbst zu handeln. Es handelt sich um eine Online-Plattform für den sozialen und den Copy-Trading-Handel, die es den Nutzern ermöglicht, den Aktionsplan von Experten für ihre Trades zu übernehmen. Die Plattform bewertet die Leistung der Experten und ermöglicht es dem Händler, die Handelsstrategien der Experten zu erkennen und zu kopieren. Heute ist es eines der beliebtesten sozialen Handelsnetzwerke.",
    copier: "Werden Sie ein Kopierer",
    pTag1:
      "Mit unserem ZuluTrade-Konto erhalten Sie direkten und automatischen Zugang zu einer Fülle von Gewinnmöglichkeiten durch die Zulu-Verbindung.",
    brTag:
      "Sie können sich einfach die Handelsergebnisse von Expert Traders ansehen, sie kopieren und sich entspannen!",
    register: "REGISTRIEREN",
    master: "Werden Sie ein Meister",
    pTag2:
      "Wenn Sie ein Master Trader werden wollen und möchten, dass andere Ihre Handelserfahrung sehen und kopieren, haben Sie bei uns auch diese Möglichkeit. Ihr AAAFx-Konto wird automatisch mit Zulu verbunden.",
    brTag1:
      "So können Sie auf Ihrem Handelskonto Gewinne erzielen und auch Performance-Gebühren von Ihren Kopierern erhalten!",
    offers:
      "ZuluTrade bietet eine Vielzahl von Funktionen und Produkten, von denen einige unten aufgeführt sind:",
    platform: "ZuluTrade Soziale Plattform:",
    pTag3:
      "Egal, ob Sie ein Trader sind und eine erfolgreiche Handelsstrategie mit anderen teilen möchten, oder ob Sie ein Investor sind und über Zulu Traders und ihre Performance diskutieren möchten, hier finden Sie ein Forum, in dem Sie alles finden. ZuluTrade verfügt über eine umfangreiche Social Trading Community-Plattform, die Blogs, Trading-Diskussionen und Social Feeds umfasst. So haben Sie die Möglichkeit, mit der Trading-Community zu interagieren und auch von ihr zu lernen.",
    zuluGuard: "ZuluTrade Guard:",
    pTag4:
      "ZuluTrade Guard bietet Schutz für Ihr Konto, indem es das Verhalten des Experten überwacht und den Signalanbieter aus dem Verkehr zieht, falls Änderungen an der Handelsstrategie vorgenommen werden.",
    brTag2:
      "Dazu wird ein Ausstiegswert für die offenen Geschäfte auf dem Konto berechnet, und wenn der Schwellenwert erreicht ist, werden die Geschäfte geschlossen.",
    automator: "Automator:",
    pTag5:
      "Automator steht für Automated Trading. Es handelt sich dabei um den Handel mit Hilfe von vordefinierten Regeln für den Einstieg und den Ausstieg aus dem Handel, die von einem automatisierten Programm ausgeführt werden. Es hilft dabei, Emotionen beim Handel auszuschalten und Zeit zu sparen.",
    combos: "Kombinationen:",
    pTag6:
      "Händler werden von ZuluTrade in Kombinationen auf der Grundlage ihrer Risikobereitschaft und Strategien gruppiert. Der Anleger kann eine Kombination wählen, der er folgen möchte. Jede Kombination wird von dem zertifizierten Management-Portfolio-Team von ZuluTrade verwaltet.",
    quickSteps: "Drei schnelle Schritte, um mit dem Kopieren zu beginnen:",
    openFund: "Eröffnen und finanzieren Sie Ihr AAAFx",
    zuluAccount: "ECN zulu Konto",
    cred: "Zulu-Anmeldedaten per E-Mail erhalten",
    zuluTrade: "Beginnen Sie mit dem Kopieren von Trades von Zulu Trade",
    openLive: "LIVE-KONTO ERÖFFNEN",
    openDemo: "DEMO-KONTO ERÖFFNEN",
  },
  zuluTrade: {
    mt4: "MT4",
    zulutrade: "ZuluTrade",
    h5Tag:
      "Menschen neigen dazu, in Gemeinschaften und durch das Folgen von Menschen, auf die man sich verlassen kann, bessere Leistungen zu erbringen.",
    pTag: "AAAfx hat dieses Bedürfnis verstanden und bietet daher die begehrte Zulu Trade Plattform an. Zulu Trade wurde 2007 gegründet, zu einer Zeit, als der Welt ein geeigneter Mechanismus fehlte, um Handelspraktiken zu überprüfen und sein Handelswissen miteinander zu teilen. Diese Plattform beseitigte auch die Notwendigkeit, stundenlang vor einem Bildschirm zu sitzen und führte den automatisierten und professionellen Finanzhandel in den Mainstream ein.",
    brTag:
      "Zulu Trade ist eine automatisierte Handelsplattform, die eine gründliche statistische Analyse der Top-Händler bietet, um dem Benutzer einen Einblick zu ermöglichen und ein System zum Kopieren von Geschäften und zum Erzielen von Vorteilen zu entwickeln.",
    startTrading: "Beginnen Sie den Handel in nur 3 einfachen Schritten:",
    openFund: "Eröffnen und finanzieren Sie Ihr AAAFx",
    ecnPlus: "ECN Zulu Handelskonto",
    variousTraders:
      "Analysieren Sie die Performance der verschiedenen Händler.",
    copy: "Wählen Sie den Händler, den Sie kopieren möchten.",
    pTag1:
      "Wählen Sie den Combo+ Service und lassen Sie Ihr Konto vom zertifizierten Management Portfolio Team von ZuluTrade im vollautomatischen oder halbautomatischen Modus verwalten, ganz wie Sie möchten!",
    ztp: "ZTP ist eine rein webbasierte Plattform, auf die Sie hier einfach zugreifen können",
    webBase: "Webbasierte Plattform",
    h3Tag:
      "AAAFx bietet Ihnen eine außergewöhnliche Handelserfahrung in Kombination mit den folgenden Funktionen der Weltklasse-ZTP:",
  },
  why: {
    title: "Warum AAAFx?",
    honesty: "Par Excellence mit Ehrlichkeit und Transparenz",
    believe: "Warum sollten Sie an AAAFx glauben?",
    pTag: "Wir können auf eine mehr als zehnjährige Geschichte zurückblicken, in der wir unseren Kunden weltweit einen zuverlässigen und hervorragenden Service bieten. Wir schaffen volle Transparenz für unsere Kunden, damit sie gut informierte Entscheidungen treffen können.",
    brTag:
      "Wir wissen, was es braucht, um ein erfolgreicher Trader zu sein, und sind daher bestrebt, unseren Kunden erstklassige Handelsbedingungen und einen erstklassigen Kundenservice zu bieten. Wir sind stolz darauf, einer der vertrauenswürdigsten Broker auf dem Devisenmarkt zu sein, der sowohl Privatkunden als auch institutionelle Kunden bedient.",
    listing: {
      point: "Sicherer und zuverlässiger Broker",
      point1: "Blitzschnelle Ausführung",
      point2: "Null Kommission, Raw Spreads auf Forex",
      point3: "Tiefer Liquiditätspool",
      point4: "3 Premium Handelsplattformen",
      point5: "Equinix-Rechenzentren ausgestattet mit High-End-Technologie",
      point6: "14 Jahre Erfahrung",
      point7: "Mehrere Methoden für kostenfreie Einzahlungen und Abhebungen",
    },
    more: "Und was noch?",
    socialTrading: "Auto Connect zur größten Social Trading Community",
    entireTeam: "Und das gesamte AAAFx-Team steht Ihnen sofort zu Diensten!!",
    pledge: "Wir versprechen...",
    liTag:
      "Ihnen einen Maklerservice zu bieten, der im besten Interesse der Händler arbeitet.",
    liTag1:
      "Die Einhaltung der Regeln, die im Rahmen der einschlägigen Vorschriften veröffentlicht wurden.",
    liTag2:
      "Ständig auf der Suche nach Gelegenheiten zur Innovation und Improvisation.",
    liTag3: "Die Einhaltung unserer Grundwerte zu jeder Zeit.",
    founded: "GEGRÜNDET IN",
    serve: "LÄNDER, DIE WIR BEDIENEN",
    trade: "Instrumente zum Handeln",
    platform: "Plattformen, die wir anbieten",
    support: "LIVE-Unterstützung",
    number: {
      twoThousand: "2008",
      thirty: "30",
      twoHundred: "200+",
      three: "3",
      twentyFour: "24/5",
    },
    team: "Unser Team...",
    pTag1:
      "Einzeln betrachtet, mögen unsere Ideale selbstverständlich erscheinen. Aber wenn wir sie alle zusammen nehmen, haben wir unsere eigene Unternehmenskultur. Wer wir sind, wofür wir stehen und wie wir handeln, wird von unseren Werten geprägt.",
    pTag2:
      "Unser Management besteht aus einem Team willensstarker und fähiger Fachleute, die über umfangreiche Erfahrungen an der Wall Street verfügen. Daher wissen sie genau, was es braucht, um ein erfolgreicher Händler zu sein. Mit ihrem beeindruckenden Hintergrund und ihrer Geschäftserfahrung verfügen sie über ein aufschlussreiches Wissen über die besten und schlechtesten Praktiken der Branche.",
    wallStreet:
      "Willensstarke Personen mit umfangreicher Erfahrung im Straßenverkehr",
    innovation: "Ständiges Streben nach Innovation und Verbesserung",
    approach: "Der Kunde steht im Mittelpunkt,",
    weDo: "bei allem was wir tun",
    values: "Unsere Werte, Ihr Erfolg!!",
    pTag3:
      "Wir stehen auf soliden Füßen, da wir in allen unseren Büros ein wertebasiertes Umfeld fördern, das durch den festen Glauben unseres ,Managements an die Geschäftsethik angetrieben wird.",
    pTag4:
      "Wir halten uns an unsere 5 Grundwerte, damit Sie in der globalen Handelsgemeinschaft glänzen können.",
    h3Tag: "Zufriedene Kunden in mehr als",
    countries: "30 EU-Länder*",
    taking: ", wobei",
    worldClass: "profitieren Sie von unseren erstklassigen Dienstleistungen.",
    france: "*Ausgenommen Belgien und Frankreich",
    info: "ΕΝΗΜΕΡΩΤΙΚΑ ΣΤΟΙΧΕΙΑ ΕΤΑΙΡΕΙΑΣ/UNTERNEHMENSINFORMATIONEN",
    data: "ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ/FINANZIELLE DATEN",
    date: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2024",
    thirtyFirst: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2023",
    thirty: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2023",
    financeStatement: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2022",
    financialData: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2022",
    statement: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2021",
    aTag: {
      li: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2021",
      liTag: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2020",
      liTag1: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2020",
      liTag2: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2019",
      liTag3: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2019",
      liTag4: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2018",
      liTag5: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2018",
      liTag6: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2017",
      liTag7: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2017",
      liTag8: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2016",
      liTag9: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2016",
      li1: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2015",
      li2: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2015",
      li3: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2014",
      li4: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2014",
      li5: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2013",
      li6: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2013",
      li7: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2012",
      li8: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2012",
      li9: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2011",
      liTag10: "ΕΝΔΙΑΜΕΣΗ ΣΥΝΟΠΤΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΠΛΗΡΟΦΟΡΗΣΗ 30-06-2011",
      liTag11: "ΟΙΚΟΝΟΜΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ 31-12-2010",
      liTag12:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 31-12-2015",
      liTag13:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 31-12-2014",
      liTag14:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 31-12-2013",
      liTag15:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 31-12-2012",
      liTag16:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 31-12-2011",
      liTag17:
        "ΙΣΟΛΟΓΙΣΜΟΣ ( ΣΥΝΟΠΤΙΚΑ ΟΙΚΟΝΟΜΙΚΑ ΣΤΟΙΧΕΙΑ & ΠΛΗΡΟΦΟΡΙΕΣ ) 31-12-2010",
    },
    dropdown: {
      title: "ΕΠΟΠΤΙΚΕΣ ΠΛΗΡΟΦΟΡΙΕΣ/ÜBERWACHUNGSINFORMATIONEN",
      aTag2: {
        pillar2023: "2023 Bericht zur Säule III Marktdisziplin und Offenlegung",
        pillar2022:
          "2022 Säule III Bericht über Marktdisziplin und Offenlegung",
        pillar2021: "2021 Bericht zur Säule III Marktdisziplin und Offenlegung",
        regulatory2023:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2023_α80&87_Ν4261_2014",
        corporateGovernance2022:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2022_α80&87_Ν4261_2014",
        financial2021:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2021_α80 ΕΩΣ 87_Ν4261_2014",
        financial2020:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2020",
        financial2019:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2019",
        financial2018:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2018",
        financial2017:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2017",
        financial2016:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2016",
        financial2015:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΜΕ ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2015",
        financial2014:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΑΠΟΦΑΣΗΣ ΕΚ 9 459-27/12/2007 ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2014",
        financial2013:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΑΠΟΦΑΣΗΣ ΕΚ 9 459-27/12/2007 ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2013",
        financial2012:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΑΠΟΦΑΣΗΣ ΕΚ 9 459-27/12/2007 ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2012",
        financial2011:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΑΠΟΦΑΣΗΣ ΕΚ 9 459-27/12/2007 ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2011",
        financial2010:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΑΠΟΦΑΣΗΣ ΕΚ 9 459-27/12/2007 ΗΜΕΡΟΜΗΝΙΑ ΑΝΑΦΟΡΑΣ 31-12-2010",
        details2020:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2020_α80 ΕΩΣ 87_Ν4261_2014",
        details2019:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2019_α80 ΕΩΣ 87_Ν4261_2014",
        details2018:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2018_α80 ΕΩΣ 87_Ν4261_2014",
        details2017:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2017_α80 ΕΩΣ 87_Ν4261_2014",
        details2016:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2016_α80 ΕΩΣ 87_Ν4261_2014",
        details2015:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2015_α81&82_Ν4261_2014",
        details2014b:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2015_α80 ΕΩΣ 87_Ν4261_2014",
        details2014:
          "ΔΗΜΟΣΙΟΠΟΙΗΣΗ ΕΠΟΠΤΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ 2014_α81&82_Ν4261_2014",
      },
    },
    announcment: "ΑΝΑΚΟΙΝΩΣΕΙΣ/ANKÜNDIGUNGEN",
    aTag3: {
      executionVenues2023:
        "2023 ΤΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2023 AUSFÜHRUNGSORTE",
      executionVenues2022:
        "2022 ΤΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2022 AUSFÜHRUNGSORTE",
      executionVenues2021:
        "2021 ΤΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2021 AUSFÜHRUNGSORTE",
      executionVenues2020:
        "2020 TΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2020 AUSFÜHRUNGSORT",
      executionVenues2019:
        "2019 TΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2019 AUSFÜHRUNGSORT",
      executionVenues2018:
        "2018 TΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2018 AUSFÜHRUNGSORT",
      executionVenues2017:
        "2017 TΟΠΟΙ ΕΚΤ. ΑΝΑ ΚΑΤΗΓ. ΧΡΗΜ. ΜΕΣΟΥ/2017 HINRICHTUNGSORT",
      generalMeetingInvite2013:
        "ΠΡΟΣΚΛΗΣΗ ΤΑΚΤΙΚΗΣ ΓΕΝΙΚΗΣ ΣΥΝΕΛΕΥΣΗΣ 28-06-2013",
    },
    accordion: "ΟΡΓΑΝΟΓΡΑΜΜΑ/UNTERNEHMENSORGANIGRAMM",
    officialOrganization: "AAAFx - Offizielles Organigramm (HCMC)",
    certifiedEmploy: {
      title: "ΠΙΣΤΟΠΟΙΗΜΕΝΟΙ ΥΠΑΛΛΗΛΟΙ/ZERTIFIZIERTE MITARBEITER",
    },
    name: "NAME",
    cretificate: "ZERTIFIZIERUNG",
    issuer: "EMITTENT",
    year: "JAHR",
    table: {
      td: "DIMOPOULOS CHRISTOS",
      td1: "Entgegennahme, Übermittlung und Ausführung von Aufträgen im Namen Dritter in Wertpapieren (A1)",
      td2: "HCMC",
      td0: "DORDA AIKATERINI",
      td3: "Entgegennahme, Übermittlung und Ausführung von Aufträgen im Namen Dritter in Wertpapieren (A1)",
      td4: "KARLIS KONSTANTINOS",
      td5: "Verwaltung des Kundenportfolios (C)",
      td6: "KONTOGEORGI ELENI",
      td7: "Entgegennahme, Übermittlung und Ausführung von Aufträgen im Namen Dritter in Wertpapieren (A1)",
      td8: "TZIANOUMI GIANNOULA",
      td9: " Anlageberatung für Wertpapiere, Anteile an Organismen für gemeinsame Anlagen, Geldmarktinstrumente, Derivate und strukturierte Finanzprodukte (B)",
      td10: "Wertpapierhändler",
      td11: "ASE",
      td12: "POLYCHRONEAS EFSTRATIOS",
      td13: "Durchführung von Analysen zu Finanzinstrumenten oder Emittenten (D)",
    },
    maria: "CHRYSAITOU MARIA ARGYRO",
    investment:
      "Anlageberatung für Wertpapiere, Anteile an Organismen für gemeinsame Anlagen, Geldmarktinstrumente, Derivate und strukturierte Finanzprodukte (B)",
    text: "PANAGIOTIS KOURBELIS",
    text1: "Praktiker Handelsschalter",
    text2: "GEORGIOS KARMIS",
    responsive: {
      trTag: {
        line: "ΟΝΟΜΑΤΕΠΩΝΥΜΟ",
        line1: "ΠΙΣΤΟΠΟΙΗΣΗ",
        line2: "ΦΟΡΕΑΣ",
        line3: "ΕΤΟΣ ΚΤΗΣΗΣ/ΑΝΑΝΕΩΣΗΣ",
        line4: "Δημόπουλος Χρήστος",
        line5: "Λήψη, Διαβίβαση και Εκτέλεση Εντολών σε Κινητές Αξίες (Α1)",
        line6: "Επιτροπή Επιτροπή",
        line7: "Καρλής Κωνσταντίνος",
        line8: "Διαχείριση Χαρτοφυλακίων (Γ)",
        line9: "Επιτροπή Κεφαλαιαγοράς",
        line10: "Κοντογεώργη Ελένη",
        line11: "Ντόρντα Αικατερίνη",
        line12: "Ντόρντα Αικατερίνη Εκτέλεση Εντολών σε Κινητές Αξίες (Α1)",
        line13: "Τζιανούμη Γιαννούλα",
        line14: "Παροχή Επενδυτικών Συμβουλών (Β)",
        line15: "Παναγιώτης Κουρμπέλης",
        line16: "Ασκούμενος Trading Desk",
        line17:
          "ΓΝΩΣΤΟΠΟΙΗΣΕΙΣ ΚΑΝΟΝΙΣΜΟΥ ΑΕΙΦΟΡΙΑΣ (SFDR)/ANGABEN ZUR NACHHALTIGKEITSVERORDNUNG (SFDR)",
        line18: "Offenlegung von Nachhaltigkeitsvorschriften (SFDR)",
        line19:
          "Γνωστοποιήσεις Κανονισμού Αειφορίας (SFDR) και Πολιτική Βιωσιμότητας (ESG)",
        line20: "Πιστοποιημένος Διαπραγματευτής Αξιών",
        line21: "Χρηματιστήριο Αξιών Αθηνών",
        line22: "Χρυσαΐτου Μαρία Αργυρώ",
        line23: "Γεώργιος Καρμής",
      },
    },
  },
  faq: {
    heading: "Häufig gestellte Fragen",
  },
  comparePlatform: {
    heading: "Handelsplattformen vergleichen",
    content: '"Je mehr, desto besser"',
    h6Tag:
      "AAAFx bietet mit der Vielzahl der angebotenen Handelsplattformen die beste Lösung für die Bedürfnisse jedes Händlers aus einer Hand.",
    pTag: "Jede Plattform verfügt über die grundlegenden Eigenschaften wie schnellste Ausführungsgeschwindigkeit, verschiedene anpassbare Optionen, die Verwendung von Indikatoren und Expert Advisors sowie die besten verfügbaren Marktpreise.",
    condition: "Handelsbedingungen",
    timeFrames: "Zeitrahmen",
    leverage: "Hebelwirkung",
    microLot: "Handel mit Kleinstanteilen",
    yes: "Ja",
    scalping: "Hedging und Scalping",
    attachment: "Anhang EAs/Indikatoren",
    other: "Andere Tools",
    economic: "Eingebauter Wirtschaftskalender",
    no: "Nein",
    report: "Konto Berichte Format",
    html: "HTML",
    language: "Plattformen Sprachkonverter",
    priceAlert: "Preisalarm",
    device: "Betriebliche Kompatibilität der Geräte",
    window: "Windows-Desktop",
    mac: "Mac/iPad",
    android: "Android",
    ios: "iOS",
    webBased: "Webbasiert",
    sutability: "Angemessenheit",
    beginner: "Anfänger",
    intermediate: "Zwischenprodukte",
    advance: "Fortgeschrittene",
    openAccount: "Konto eröffnen",
    platform: "Welche Plattform möchten Sie für sich selbst?",
    choice:
      "Das kann eine schwierige Entscheidung sein. Nachfolgend finden Sie, was Sie berücksichtigen können:",
    point: "Wie einfach ist die Benutzeroberfläche für Sie?",
    point1: "Welche Plattform passt zu Ihren Handelsstrategien?",
    point2: "Bieten Sie Unterstützung für diese Plattform an?",
    point3:
      "Für die letzte Frage haben wir eine Lösung für Sie. Wir bieten umfassenden technischen Support, falls Sie Probleme mit einer Plattform haben.",
    point4: "Für die beiden anderen Fragen können Sie eine",
    point5: "Demo-Konto",
    point6:
      "und machen Sie sich mit allen Nuancen unserer fantastischen Handelsplattformen vertraut!",
  },
  depWith: {
    heading: "Einzahlungen und Abhebungen",
    title:
      "Eine Vielzahl von einfachen und bequemen Optionen, die für uns absolut kostenlos sind",
    pTag: "Einzahlungen und Abhebungen von Ihrem Handelskonto waren noch nie so einfach! Investieren Sie in Ihr Handelskonto, ohne zusätzliche Gebühren zu zahlen. Wir bieten Ihnen verschiedene zuverlässige Ein- und Auszahlungsoptionen, damit Ihr Handel reibungslos und einfach vonstatten geht.",
    serviceFee: "0% Servicegebühr",
    charge: "Wir berechnen keine Gebühren für Einzahlungen oder Abhebungen",
    safety: "Transaktionen Sicherheit",
    funds:
      "Die Gelder werden in Tier-1-Banken verwahrt und sind von den Eigenmitteln des Unternehmens abgetrennt",
    quickProcessing: "Schnelle Bearbeitung",
    deposit: "Einzahlungen und Abhebungen bei AAAFX werden sofort bearbeitet",
    minDeposit: "Mindest-Einzahlungsbetrag",
    globalCurrency: "Globale Währungen akzeptiert",
    control: "Erhöhte Kontrolle",
    security: "Obligatorisches KYC sorgt für mehr Sicherheit",
    with: "RÜCKTRÄGE",
    seamless:
      "Nahtlose Abhebungen machen jeden Händler glücklich, oder? Das ist es, was wir für unsere Kunden anstreben. Hier finden Sie einige schnelle und einfache Optionen, mit denen Sie sich Ihr hart verdientes Geld innerhalb von 12 Stunden auszahlen lassen können.",
    step: "Schritte zur Abhebung von Ihrem AAAFx Live-Konto:",
    step1: "1. Loggen Sie sich in das Kundenportal ein.",
    step2: "2. Richten Sie ein Bankkonto unter 'Bankeinrichtung' ein.",
    step3: '3. Klicken Sie auf "Geld" und dann auf "Abheben".',
    depositText: "Einzahlung",
    withdrawal: "Abhebungen",
    bankCard: "Bankkarten",
    region: "Region",
    currencies: "Währungen",
    min: "Min. Einzahlung",
    service: "Service-Gebühr",
    processing: "Bearbeitungszeit",
    worldWide: "Weltweit",
    instant: "INSTANT",
    fund: "FONDS",
    bankWire: "Banküberweisung",
    days: "2-3 ARBEITSTAGE",
    europe: "Europa",
    southEast: "Südostasien",
    latinAmerica: "Lateinamerika",
    mexico: "Mexiko",
    eastAfrica: "Ostafrika",
    global: "Global",
    info: "Zusätzliche Informationen:",
    step4:
      "(1) Alle Auszahlungen werden über die Methode abgewickelt, die für die Einzahlung auf das Handelskonto verwendet wurde.",
    step5:
      "(2) AAAFx erhebt weder bei Einzahlungen noch bei Abhebungen eine Transaktionsgebühr.",
    step6:
      "(3) Wir erstatten Ihnen die Transaktionskosten bis zu 5 % Ihres Einzahlungsbetrags auf Ihr Handelskonto.",
    live: "LIVE-KONTO ERÖFFNEN",
    demo: "DEMO-KONTO ERÖFFNEN",
  },
  whiteLabels: {
    banner: {
      menu: {
        white_label: "Weißes Etikett",
      },
      title: "Weißes Etikett",
      subtitle: "Unsere Erfahrung, Ihr Erfolg!",
    },
    pamm_content: {
      intro: {
        heading:
          "Eine einmalige Gelegenheit, mit Hilfe unseres Wissens, unserer Erfahrung und unserer Unterstützung Ihr eigenes Maklerunternehmen zu gründen.",
      },
      description: {
        paragraph_1:
          "Ein White-Label-Programm ist eine großartige Möglichkeit, sich schnell eine starke Position auf dem Markt zu verschaffen. Dies ist möglich durch den Einsatz unserer Technologie, tadelloser Handelsbedingungen, Support-Services und nützlicher Back-Office-CRM-Tools.",
        paragraph_2:
          "Das AAAFx-Team engagiert sich für Ihren Erfolg durch unsere technische und professionelle Unterstützung.",
        paragraph_3:
          "Unser White-Label-Programm bietet Ihnen volle Flexibilität bei der Gestaltung Ihrer Produkte und Dienstleistungen, so dass Sie die besten Chancen haben, Ihr Unternehmen zum Erfolg zu führen.",
        paragraph_4:
          "Die Wahl des richtigen Maklers ist der erste Schritt zur Erreichung Ihrer gewünschten Ziele.",
        paragraph_5: "Rüsten Sie sich und treffen Sie jetzt die richtige Wahl!",
      },
    },
    expectations_section: {
      heading: "Was ist zu erwarten?",
      list: {
        item_1: "Zusammenarbeit mit größtem Social Trading Netzwerk",
        item_2: "Engagierte Kundenbetreuer für Investoren und Manager",
        item_3:
          "Flexibilität bei der Festlegung von Parametern und Bedingungen für das Konto",
        item_4: "Sehr niedrige Provisionen mit rohen Spreads",
        item_5: "Sicherheit der Gelder bei einem vertrauenswürdigen Broker",
        item_6: "Geringe Investition für den Anfang erforderlich",
        item_7: "Transparenz für die Anleger - keine versteckten Klauseln",
        item_8: "Volle Kontrolle der Anleger über Einzahlungen und Abhebungen",
      },
    },
    contact_section: {
      title:
        "Sind Sie bereit, maßgeschneiderte Lösungen für Ihr neues Vorhaben zu erhalten?",
      contact_us: "Kontaktieren Sie uns jetzt",
      email_link: "hier",
      email_info: "oder schreiben Sie uns an",
      email_address: "support{'@'}aaafx.com",
    },
  },
  vpsHosting: {
    banner: {
      title: "Kostenloses VPS-Hosting",
    },
    bonus_trade_section: {
      description:
        "Handeln Sie bequem von überall auf der Welt ohne Verbindungsunterbrechungen und machen Sie sich keine Gedanken über Internet- oder Stromausfälle. Es ist wichtig, die Latenzzeit beim Handel zu minimieren, denn eine kleine Verzögerung kann Sie ein Vermögen kosten.",
      customer_approach:
        "Im Einklang mit unserem kundenorientierten Ansatz möchten wir unseren Kunden stets die bestmögliche Handelserfahrung bieten. AAAFx bietet Ihnen Virtual Private Server Services, ohne dass Ihnen zusätzliche Kosten entstehen.",
      advantages_title: "Vorteile des Handels mit VPS",
      advantages_list: {
        item_1:
          "Mit VPS können Ihre Trades jederzeit mit minimaler Verzögerung ausgeführt werden, was zu weniger Slippage führt.",
        item_2:
          "VPS bietet einen endlosen Betrieb der Handelsplattform und ist besser geeignet, wenn Sie Handelsroboter oder Handelssignale verwenden.",
        item_3:
          "Damit können Sie von jedem Ort der Welt aus handeln, selbst wenn keine Internetverbindung verfügbar ist, der Strom ausfällt oder das System abstürzt.",
        item_4:
          "VPS bietet Anonymität, Datenschutz und Sicherheit, so dass Sie beruhigt handeln können, da Ihre wichtigen Daten sicher sind.",
      },
    },
    accordion_section: {
      how_to_get_vps: {
        title: "Wie kann ich einen kostenlosen VPS bekommen?",
        content:
          "Wenn Sie ein Kunde mit einem leicht hohen Handelsvolumen sind (mit einer Einzahlung von mindestens $5.000), haben Sie Anspruch auf einen kostenlosen VPS.",
      },
      why_free_vps: {
        title: "Warum bietet AAAFX einen kostenlosen VPS an?",
        content:
          "Unser Technologiepartner bietet uns günstiges VPN-Hosting im Gegenzug für ein hohes Volumen. Wir geben die Vorteile, die wir verdienen, gerne an unsere Kunden weiter.",
      },
      lesser_deposit: {
        title: "Was ist, wenn meine Einzahlung geringer ist?",
        content:
          "Das ist kein Problem. Sie können unseren VPS immer noch zu einer sehr niedrigen Miete von nur $25 pro Monat nutzen. Diese Miete wird automatisch von Ihrem Handelskonto abgebucht.",
      },
      other_vps: {
        title:
          "Was ist, wenn ich einen anderen VPS anstelle des von AAAFx vermittelten VPS verwenden möchte?",
        content:
          "Wenn Sie Ihren eigenen VPS oder den eines Drittanbieters nutzen möchten, können wir Ihnen eine Rückerstattung für Ihren VPS von bis zu $25/Monat gewähren, vorausgesetzt, Ihre Nettoeinzahlung für den Monat beträgt mindestens $5.000. Teilen Sie uns einfach Ihre VPS-Kaufdaten und den monatlichen Zahlungsbeleg mit, um diese Rückerstattung in Anspruch zu nehmen.",
      },
    },
    vps_configuration_section: {
      title: "Kostenlose VPS-Konfiguration",
      configuration: {
        intel: {
          title: "INTEL",
          description: "Prozessor",
        },
        ram: {
          title: "1300 MB",
          description: "RAM",
        },
        bandwidth: {
          title: "25 GB",
          description: "Bandbreite",
        },
        disk_space: {
          title: "2 TB",
          description: "Speicherplatz",
        },
      },
    },
    apply_vps_section: {
      title: "Wie beantrage ich einen kostenlosen VPS?",
      steps: {
        step_1: {
          description: "Ein Live-Konto eröffnen",
        },
        step_2: {
          description:
            "Einzahlung von mindestens $5.000 oder einer gleichwertigen Währung",
        },
        step_3: {
          description: "E-Mail an",
          email: "support{'@'}aaafx.com",
        },
      },
    },
  },
  tradingCondition: {
    heading: "Handelsbedingungen",
    pTag: "Funktionen, mit denen Sie noch profitabler handeln können! Eine Handelsumgebung, die sich für alle Arten von Handelsstrategien eignet.",
    h5Tag:
      "Werfen Sie einen Blick auf alle Bedingungen und Konditionen, um ein tadelloses Handelserlebnis zu planen:",
    content:
      "AAAFx bietet Handelsbedingungen, die für jeden Trader geeignet sind - egal ob Anfänger oder Experte. Wir möchten, dass unsere Kunden mit größtmöglichem Vertrauen und Komfort handeln können.",
    deepLiquidity: "ECN-Handel mit hoher Liquidität",
    buySell:
      "ECN-Konten (Electronic Communication Network) sind so konzipiert, dass sie Kauf- und Verkaufsaufträge durch direkten Zugang zu Liquiditätsanbietern zusammenführen.",
    brTag:
      "Über unsere Prime LPs sind wir in der Lage, die besten vorherrschenden Marktpreise und die beste Liquidität nahtlos an alle unsere Kunden weiterzugeben. So erhalten Sie sofortigen Zugang zu den großen Liquiditätspools zu vernachlässigbaren Spread-Kosten.",
    powerfulArsenal: "AAAFx Leistungsstarkes Handelsarsenal",
    arsenalContent:
      "Wir wissen, wie wichtig es ist, eine optimale Handelsplattform zu wählen, um Ihre Handelsstrategie umzusetzen! Wir haben uns um all Ihre Anforderungen gekümmert, damit Sie mit einer einfachen Navigation und Benutzeroberfläche schnell handeln und von über 200+ Handelsinstrumenten profitieren können, die auf drei voll ausgestatteten Handelsplattformen verfügbar sind - MT4, MT5, ActTrader. Das Tüpfelchen auf dem i ist die Verbindung zu Zulu Trade über das Zulu-Konto, mit dem Sie sofort mit der größten Social Trading-Community verbunden werden.",
    zeroCommission: "Null Provision und hauchdünne Spreads",
    commissionContent:
      "Wir bieten Ihnen die besten Bedingungen für den Handel zu den niedrigsten Kosten. Mit unserem ECN plus-Konto können Sie bei allen Forex-Paaren provisionsfrei handeln. Mit ultradünnen Spreads ab 0,0 Pips für alle handelbaren Instrumente können Sie unsere institutionelle Liquidität zu extrem niedrigen Kosten nutzen. Diese Handelskonditionen erhalten wir von unseren erstklassigen Liquiditätsanbietern, um Ihnen auf Ihrer Handelsreise den besten Service zu bieten.",
    fastExecution: "Blitzschnelle Ausführung",
    executionContent:
      "Die erstklassige Qualität und der Standort unserer Server ermöglichen die schnellstmögliche Handelsausführung mit einer Geschwindigkeit von bis zu 10 ms. Sie können Handelsaufträge von bis zu 100 Lots erteilen. Sie sind frei von Verzögerungen, Requotes und Dealing Desks. Das macht unsere Plattform ideal für alle Arten von Händlern - Scalper, Anfänger, EA-Nutzer, manuelle Händler usw.",
    fundingOptions: "Vielfältige Finanzierungsmöglichkeiten",
    fundingContent:
      "Nahtlose Ein- und Auszahlungen tragen wesentlich dazu bei, dass Ihre Handelsreise einfach und reibungslos verläuft. Sie können Ihre Einzahlungsmethode aus verschiedenen Optionen wählen. Wir wissen, dass bei der Finanzierung Ihrer Handelskonten jeder Cent zählt. Daher erheben wir keine Gebühren für die Annahme von Einzahlungen oder die Bearbeitung von Abhebungen. Abhebungen werden ultraschnell und reibungslos abgewickelt, und Sie können aus einer Vielzahl von Abhebungsmethoden wählen.",
    lowRollover: "Niedrige Rollover-Gebühren",
    rolloverContent:
      "Einige Händler möchten ihre Geschäfte über Nacht halten, und zu diesem Zweck sind die Swap-Sätze wichtig. Jedes Handelspaar hat seine eigenen Swap-Gebühren (außer bei islamischen Konten). Diese Sätze werden um 00:00 Uhr Serverzeit angewendet. Die Märkte sind am Wochenende geschlossen, aber die Banken berechnen auch für Positionen, die über das Wochenende gehalten werden, Zinsen. Wenn Sie also eine Position über Nacht an einem Freitag halten, fallen 3X Swap-Sätze an. Wir bieten Ihnen wettbewerbsfähige und niedrige Swap-Gebühren, damit Sie flexibler entscheiden können, wann Sie Ihre Trades schließen möchten.",
    doubt: "Haben Sie Zweifel an einer Handelsbedingung? Versuchen Sie unser",
    demoAccount: "Demo-Konto",
    stayAware: "Bleiben Sie aufmerksam und nutzen Sie die umfangreichen",
    calculate: "Trading-Rechner",
    getAll: "um alle Zahlen richtig zu machen!",
    liveAccount: "LIVE-KONTO ERÖFFNEN",
    openAccount: "DEMO-KONTO ERÖFFNEN",
  },
  tradingCalculator: {
    title: "Trading-Rechner",
    madeEasy: "Berechnungen für Sie leicht gemacht",
    neverMiss:
      "Verpassen Sie niemals Handelsgewinne aufgrund schlechter Berechnungen!",
    pTag: "Treffen Sie im Handumdrehen genaue Einschätzungen mit unseren Handelsrechnern. Wir möchten Ihnen helfen, das Beste aus Ihren Geschäften herauszuholen, indem Sie Zeit sparen und sich ganz auf die wichtigen Handelsentscheidungen konzentrieren, anstatt sich mit langwierigen Berechnungen zu beschäftigen. Wir haben die nützlichsten Rechner für den Handel ausgewählt und sie hier für Sie zusammengestellt. Sie müssen nichts herunterladen. Wählen Sie einfach den gewünschten Rechner aus, geben Sie Ihre Eingaben ein und der Rechner wird Ihnen die Antwort geben!",
    swap: "Swap-Rechner",
    margin: "Margen-Rechner",
    pip: "Pip-Rechner",
    calculate: "Taschenrechner",
  },
  forexStock: {
    innerPages: {
      forex: "Forex",
      indices: "Indizes",
      commodities: "Commodities",
      stocks: "Aktien",
      crypto: "Kryptowährungen",
    },
    title: "FOREX",
    trade: "Handeln Sie mit prominenten Devisenpaaren mit AAAFx",
    min: "min.",
    commission: "Kommission",
    execution: "Ausführung",
    spread: "Streuen Sie",
    upTo: "Bis zu",
    leverage: "Hebelwirkung",
    paris: "Paare",
    contract: "Forex Vertrag",
    specification: "Spezifikationen",
    flexible:
      "Für Kunden, die als Professional eingestuft sind, können flexiblere Handelsbedingungen (höhere Hebelwirkung) gelten. Bitte loggen Sie sich in Ihr Konto ein und prüfen Sie, ob Sie als professioneller Kunde eingestuft werden können, oder schreiben Sie uns an",
    email: "support{'@'}aaafx.com",
    instument: "Instrument",
    bid: "Angebot",
    ask: "Fragen Sie",
    size: "Vertragsgröße",
    minTrade: "Min. Handelsgröße",
    tickValue: "Tick-Wert",
    hours: "Handelszeiten",
    h3Tag: "Was ist Devisenhandel?",
    pTag: "Der Devisenmarkt ist ein ausgedehnter globaler Markt für den Austausch internationaler Währungen. Der Devisenhandel ist der allgemeine Kauf und Verkauf von Währungen mit dem Hauptziel, Gewinne zu erzielen. Der globale Devisenmarkt ist der größte und liquideste Markt der Welt, mit einem täglichen Transaktionsvolumen von mehr als 6 Billionen Dollar.",
    how: "Wie funktioniert das?",
    trading:
      "Beim Devisenhandel kaufen Sie eine Währung und verkaufen sie gegen eine andere Währung zum aktuellen Marktkurs. Es gibt keine Lieferung von Währungen und die Differenz zwischen Verkaufs- und Kaufkurs wird einfach auf dem Handelskonto ausgeglichen. Daher sind diese Devisenpaare wie Forex-CFDs zu Kassakursen. Wenn Sie auf dem eigentlichen Devisenmarkt handeln möchten, müssen Sie Hunderttausende von Dollars ausgeben. Mit den Vorteilen des Leverage-Handels und der CFDs benötigen Sie jedoch nur 100 Einheiten einer Währung, um von den Kursbewegungen zu profitieren. Darüber hinaus können Sie über Swap-Sätze auch von der Zinsdifferenz zwischen zwei Währungen profitieren. Wenn Sie über Nacht eine offene Position in einem Währungspaar halten und die Zinsen für die gekaufte Währung höher sind als die für die verkaufte Währung, erzielen Sie einen gewissen Zinsertrag. Andernfalls zahlen Sie eine Gebühr. Diese Zinsen werden als Swap- oder Rollover-Satz bezeichnet.",
    account: "Konto",
    type: "Typen",
    compare: "Kontotypen vergleichen",
    online: "Unser Online",
    tradingText: "Handel",
    platform: "Plattformen",
    desktop: "Desktop",
    webTrade: "Web Trader",
    android: "Android",
    ios: "iOS",
    learn: "MEHR LERNEN",
    negative: "Negativer Saldo",
    protection: "Schutz",
    pSubTag: "Zuverlässiger Schutz Ihrer Gelder auf AAAFx-Konten",
    pTag1:
      "Wir sind immer bestrebt, im besten Interesse unserer Kunden zu arbeiten. Wenn Ihr Konto in volatilen Zeiten ins Minus gerät, halten wir Ihnen den Rücken frei! Wir setzen Ihren negativen Saldo auf Null zurück, so dass Sie keinen zusätzlichen Verlust erleiden. Sie können einzahlen und den Handel wieder aufnehmen. Sie können also nicht mehr verlieren als das, was Sie eingezahlt haben.",
    live: "LIVE-KONTO ERÖFFNEN",
    demo: "DEMO-KONTO ERÖFFNEN",
  },
  pageNotFound: {
    title:
      "Die Seite, die Sie suchen, wurde möglicherweise entfernt, ihr Name wurde geändert oder sie ist vorübergehend nicht verfügbar.",
    redirect: "Zur AAAFx Homepage gehen",
  },
  annualLoser: {
    winner: "Gewinner",
    loser: "Verlierer",
    total: "Gesamt",
    percentage: "Prozentsatz der Verlierer",
    annually: "Jährlich",
    semi_annually: "Halbjährlich",
    quaterly: "Vierteljährlich",
    monthly: "Monatlich",
  },
  safetyFund: {
    title: "Sicherheit der Mittel",
    heading: "Integrität, Vertrauen und volle Verlässlichkeit",
    safety: "Fonds Sicherheit und Schutz",
    investor:
      "Anleger sollten ihre ganze Zeit und Energie darauf verwenden, effektive Strategien zu entwickeln, anstatt sich um die Sicherheit ihrer Fonds zu sorgen.",
    protect:
      "Wir sind hier, um Ihr Geld zu schützen, denn unsere Grundlage ist Ihr Vertrauen. Wir möchten, dass Sie klug investieren und sicher handeln.",
    heading1: "REGULIERT & BEWACHT",
    strict:
      "In Übereinstimmung mit dem strengen regulatorischen Rahmen der Hellenic Capital Market Commission (HCMC) der EU",
    responsible: "VERANTWORTUNGSBEWUSSTER TREUHÄNDER",
    client:
      "Das Geld der Kunden wird sicher auf sicheren Bankkonten bei vertrauenswürdigen Banken verwahrt.",
    audit: "SPEZIELLE PRÜFUNGEN UND",
    review: "COMPLIANCE-PRÜFUNGEN",
    internal:
      "Interne und externe Audits, dedizierte Compliance-Funktion zur ständigen Überprüfung der Anwendung der Verfahren für Kundenvermögen.",
    negativeBalance: "NEGATIVSALDO-SCHUTZ",
    pTag: "Die Kunden können nicht mehr als ihren Kontostand verlieren. Wenn ihr Saldo negativ wird, setzen wir ihn auf Null zurück.",
    funds: "GETRENNTE FONDS UND AUFZEICHNUNGEN",
    companyFunds:
      "Strikte Trennung zwischen Kunden- und Unternehmensgeldern. Es wird eine klare Trennung zwischen den Geldern/Aufzeichnungen der Kunden und denen des Unternehmens beibehalten",
    policies: "SOLIDE IT-POLITIK",
    secure:
      "Sichere Web-Sockets auf der Website, Cloudflare-Technologie und Zwei-Faktor-Authentifizierung (2FA) für alle Kundenkonten verfügbar.",
    investorFund: "ANLEGERENTSCHÄDIGUNGSFONDS",
    perPerson:
      "AAAFx-Anleger sind gemäß der europäischen Richtlinie 93/22/EWG bis zu 30.000 € pro Person durch den griechischen Garantiefonds geschützt.",
    security: "Wir sind stets bemüht, Ihre Sicherheit zu gewährleisten.",
    awareness: "Aber Ihre Achtsamkeit und Wachsamkeit sind ebenso wichtig:",
    never: "Niemals",
    click: "auf nicht identifizierte Links in E-Mails klicken.",
    unSecured:
      "ungesicherte drahtlose Netzwerke oder ein öffentliches Gerät für den Zugriff auf Finanzkonten zu verwenden.",
    otps: "auf E-Mails oder SMS zu antworten, in denen nach persönlichen Informationen oder OTPs gefragt wird.",
    websites:
      "Ihre persönlichen oder finanziellen Daten auf ungesicherten Websites eingeben.",
    leave:
      "Ihr Gerät unbeaufsichtigt lassen, während Sie bei gesicherten persönlichen oder finanziellen Konten angemeldet sind.",
    twoFa: "ein Finanzkonto ohne 2FA betreiben.",
  },
  regulations: {
    title: "Vorschriften und Lizenzen",
    multiple:
      "Wir haben mehrere Registrierungen und Vorschriften rund um den Globus. Volle Transparenz über unsere Registrierungsdetails bedeutet mehr Zuverlässigkeit, Sicherheit und Seelenfrieden für unsere Kunden!",
    capitalMarket: "Hellenische Kapitalmarktkommission (HCMC), Griechenland",
    member:
      "Triple A Experts Investment Services Single Member SA ist in der Europäischen Union von der Hellenic Capital Market Commission zugelassen und reguliert. (id:2/540/17.2.2010) Steueridentifikationsnummer: 998281207.",
    h5Tag: "Über HCMC",
    pTag: "Die Hellenic Capital Market Commission (HCMC) wurde in Griechenland als juristische Person zur Überwachung der ordnungsgemäßen Anwendung der Kapitalmarktgesetze gegründet. Die HCMC ist Mitglied der Europäischen Wertpapier- und Marktaufsichtsbehörde (ESMA) und der International Organization of Securities Commissions (IOSCO).",
    about: "Über MiFID II",
    adopted:
      "Das Europäische Parlament und der Rat haben am 15. Mai 2014 die Richtlinie 2014/65/EU über Märkte für Finanzinstrumente und zur Änderung der Richtlinie 2002/92/EG und der Richtlinie 2011/61/EU (Neufassung) (MiFID II) verabschiedet, die am 03/01/2018 in Kraft getreten ist. Ihr Ziel ist es, die Märkte für Finanzinstrumente für die Erbringung von Wertpapierdienstleistungen und Anlagetätigkeiten innerhalb des Europäischen Wirtschaftsraums (EWR) zu regulieren. Die MiFID wurde mit dem Gesetz Nr. 4514/2018 in die griechische Gesetzgebung aufgenommen. Die Hauptziele der Richtlinie sind die Erhöhung der Effizienz, die Verbesserung der finanziellen Transparenz, die Steigerung des Wettbewerbs und ein besserer Verbraucherschutz bei Wertpapierdienstleistungen.",
    gdpr: "Über GDPR",
    aboutGDPR:
      'Die General Data Protection Regulation (GDPR) gilt als eines der strengsten Datenschutzgesetze der Welt. Sie wurde von der Europäischen Union (EU) ausgearbeitet und verabschiedet und trat am 25. Mai 2018 in Kraft. Sie legt einen rechtlichen Rahmen fest, der Richtlinien für die Erhebung und den freien Verkehr personenbezogener Daten von Einzelpersonen innerhalb der Europäischen Union (EU) vorgibt. "AAAFx" und die mit ihr verbundenen Unternehmen, einschließlich ihrer Tochtergesellschaften, Niederlassungen, Repräsentanzen, Direktoren, leitenden Angestellten und Mitarbeiter, unternehmen alle angemessenen Schritte, um die GDPR einzuhalten.',
    investor: "Über den Investor Compensation Fund",
    hcmc: "AAAFx-Anleger sind gemäß der europäischen Richtlinie 93/22/EWG durch den griechischen Garantiefonds geschützt. Sollte eine Wertpapierfirma ihren Verpflichtungen nicht nachkommen, wird der griechische Garantiefonds tätig, um die Anleger mit bis zu 30.000 € pro Person zu entschädigen. Der griechische Garantiefonds wird von den Mitgliedern der ATHEX (Athener Börse) finanziert und von der HCMC beaufsichtigt.",
    group: "Gruppenreglement",
    sector: "Financial Sector Conduct Authority (FSCA), Südafrika",
    southAfrica:
      "Sikhula Venture Capital (Pty) Ltd. ist von der südafrikanischen Financial Sector Conduct Authority (FSCA) zugelassen und reguliert. (Zulassungsnummer: 2017/315029/07).",
    view: "Lizenz ansehen",
    register: "Registrierungen in anderen Gerichtsbarkeiten",
  },
  homePage: {
    h3tag: "Die Zukunft von FOREX ist...",
    h1tag: "ULTRA-LOW-Provisionen!",
    ul: {
      lTag: "Rohe Brotaufstriche",
      strong: "von",
      strong1: "0.0",
      lTag1: "Pips",
      lTag2: "Hebelwirkung bis zu",
      strong2: "500x*",
      supTag: "professionelle Kunden",
      lTag3: "und EU-Verordnungen und -Registrierungen",
      lTag4: "Einzahlungen und Abhebungen*",
    },
    liveAccount: "LIVE-KONTO ERÖFFNEN",
    demoAccount: "DEMO-KONTO ERÖFFNEN",
    tabs: {
      forex: "Forex",
      indices: "Indizes",
      commodities: "Commodities",
      stocks: "Aktien",
      cryptoCurrencies: "Kryptowährungen",
    },
    forex: {
      title: "70+ FX Paare",
      point1: "1",
      content: "Der liquideste Markt der Welt",
      pTag: "Genießen Sie den Zugang zu den liquidesten Märkten der Welt",
      point2: "2",
      h5Tag: "Handeln Sie mit Mikro-Losgrößen",
      pTag1:
        "Handeln Sie nach einer beliebigen Strategie, Mikro-Lots bis zu 100 Lots",
      point3: "3",
      h5Tag1: "Erweiterte Charting-Indikatoren",
      pTag2:
        "Nutzen Sie unsere großartigen Handelsplattformen mit fortschrittlichen Tools",
      startTrading: "START TRADING",
      tryDemo: "TESTEN SIE EINE DEMO",
      tableRow: {
        tableHeading: {
          pair: "Paar",
          bid: "Angebot",
          ask: "Fragen Sie",
          spread: "Spreads",
          trade: "Handel",
        },
      },
      buySell: "KAUFEN/VERKAUFEN",
      SeeAll: "Alle sehen",
    },
    indices: {
      title: "11+ Indizes",
      point1: "1",
      content: "Handel mit ständig wachsenden Indizes",
      pTag: "wie DOW JONES, S&P 500, Nasdaq und viele mehr...",
      point2: "2",
      h5Tag: "Niedrige Spreads und geringe Margin-Anforderungen",
      pTag1:
        "Wir haben die geringsten Spreads, hohe Hebelwirkung auf alle globalen Indizes",
      point3: "3",
      h5Tag1:
        "Diversifizieren Sie - handeln Sie ein Portfolio, nicht eine einzelne Aktie",
      pTag2: "Wir bieten alle wichtigen globalen Indizes zum Handel an",
      startTrading: "START TRADING",
      tryDemo: "TESTEN SIE EINE DEMO",
      tableRow: {
        tableHeading: {
          pair: "Paar",
          bid: "Angebot",
          ask: "Fragen Sie",
          spread: "Spreads",
          trade: "Handel",
        },
      },
      buySell: "KAUFEN/VERKAUFEN",
      SeeAll: "Alle sehen",
    },
    commodities: {
      title: "9 Rohstoffe",
      point1: "1",
      content: "Breite Palette an Rohstoffen",
      pTag: "Alle wichtigen Edelmetalle, Öl und Erdgas verfügbar",
      point2: "2",
      h5Tag: "Weniger investieren, mehr bekommen",
      pTag1: "Erhalten Sie wertvolle Vermögenswerte einfach mit Hebelwirkung",
      point3: "3",
      h5Tag1: "Keine Latenzzeit, minimaler Schlupf",
      pTag2:
        "Minimale Auswirkung der Volatilität bei einer Ausführungsgeschwindigkeit von 10 ms.",
      startTrading: "START TRADING",
      tryDemo: "TESTEN SIE EINE DEMO",
      tableRow: {
        tableHeading: {
          pair: "Paar",
          bid: "Angebot",
          ask: "Fragen Sie",
          spread: "Spreads",
          trade: "Handel",
        },
      },
      buySell: "KAUFEN/VERKAUFEN",
      SeeAll: "Alle sehen",
    },
    stocks: {
      title: "100+ Aktien",
      point1: "1",
      content: "Blue-Chip-Aktien handeln",
      pTag: "Nehmen Sie vertrauenswürdige Blue-Chip-Aktien in Ihr Portfolio auf",
      point2: "2",
      h5Tag: "Verdienen Sie Dividenden, ohne Aktien zu besitzen",
      pTag1:
        "Verdienen Sie spannende Dividendenerträge von erstklassigen Unternehmen",
      point3: "3",
      h5Tag1: "Kaufen oder Verkaufen, je nach Markt",
      pTag2:
        "Handeln Sie nicht nur mit steigenden, sondern auch mit fallenden Aktien, und zwar mit jeder Handelsstrategie.",
      startTrading: "START TRADING",
      tryDemo: "TESTEN SIE EINE DEMO",
      tableRow: {
        tableHeading: {
          pair: "Paar",
          bid: "Angebot",
          ask: "Fragen Sie",
          spread: "Spreads",
          trade: "Handel",
        },
      },
      buySell: "KAUFEN/VERKAUFEN",
      SeeAll: "Alle sehen",
    },
    crypto: {
      title: "6 Kryptowährungen",
      point1: "1",
      content: "Handel mit gelddrehenden Kryptos",
      pTag: "Handeln Sie die lukrativsten Vermögenswerte der heutigen Zeit",
      point2: "2",
      h5Tag:
        "Die leistungsfähigsten Kryptowährungen direkt auf Ihrer Handelsplattform",
      pTag1: "Alle wichtigen Kryptowährungen für den Handel verfügbar",
      point3: "3",
      h5Tag1: "Zuverlässiger Handel für volatile Vermögenswerte",
      pTag2:
        "Zugang zu hoher Liquidität mit einem regulierten, zuverlässigen Broker",
      startTrading: "START TRADING",
      tryDemo: "TESTEN SIE EINE DEMO",
      tableRow: {
        tableHeading: {
          pair: "Paar",
          bid: "Angebot",
          ask: "Fragen Sie",
          spread: "Spreads",
          trade: "Handel",
        },
      },
      buySell: "KAUFEN/VERKAUFEN",
      SeeAll: "Alle sehen",
    },
    youShouldJoin: "Warum Sie mitmachen sollten",
    aaafx: "AAAFx",
    content: {
      h3Tag: "Erstklassige Handelsbedingungen",
      ul: {
        liTag: "Schnellste Handelsausführung mit Spreads nahe Null",
        liTag1: "Niedrige Provisionen und Rollover-Gebühren",
        liTag2: "Alle Handelsstrategien erlaubt",
        liTag3: "Keine versteckten Aufschläge",
      },
    },
    content1: {
      h3Tag: "Sicherheit und Verlässlichkeit",
      ul: {
        liTag: "EU-regulierter Broker.",
        liTag1: "Registrierungsnummer: 2/540/17.2.2010.",
        liTag2: "Schutz vor negativem Saldo.",
        liTag3: "Strenge Einhaltung der Treuhandbestimmungen.",
      },
    },
    content2: {
      h3Tag: "14 Jahre Branchenerfahrung",
      ul: {
        liTag: "Seit über einem Jahrzehnt im Geschäft",
        liTag1: "Ein Team fähiger und erfahrener Fachleute",
        liTag2: "Vertrauenswürdiger und transparenter Broker",
        liTag3: "Tiefes Verständnis für die Bedürfnisse von Händlern",
      },
    },
    content3: {
      h3Tag: "Hoher Liquiditätspool",
      ul: {
        liTag: "Liquidität auf institutionellem Niveau",
        liTag1: "Keine Requisiten und minimaler Schlupf",
        liTag2: "Garantierte Liquidität auf allen Preisniveaus",
        liTag3: "Geeignet für hohe Handelsvolumina",
      },
    },
    content4: {
      h3Tag: "Technologie",
      ul: {
        liTag: "Hochwertige hauseigene Technologie",
        liTag1: "Server in erstklassigen Equinix-Rechenzentren",
        liTag2: "Schnellste Ausführungsgeschwindigkeit unter 10 ms",
        liTag3: "Kostenloser kollokierter VPS für noch niedrigere Latenzzeiten",
      },
    },
    content5: {
      h3Tag: "Ultra-schnelle Abhebungen",
      ul: {
        liTag: "Kostenlose Abhebungen innerhalb von 24 Stunden",
        liTag1: "Keine Beschränkungen hinsichtlich Betrag oder Häufigkeit",
        liTag2: "Mehrere flexible Auszahlungsoptionen",
        liTag3: "Bearbeitung von Hochsicherheitsabhebungen",
      },
    },
    rawSpread: "Rohspreads, Null Kommission",
    plusAccount: "auf FX-Paare mit einem ECN plus-Konto",
    pTag: " AAAFx ist hier, um die Spannung und die Provisionen von Ihrer Handelsreise zu nehmen. Ja, Sie haben richtig gelesen! Wir haben Platz für Sie, um eine kostengünstige Handelserfahrung mit uns zu manövrieren. Für mehr Informationen",
    clickHere: "Klicken Sie hier",
    brTag:
      "Wir geben Ihnen das volle Potenzial, um das bestmögliche Ergebnis zu erzielen. Durch den Einsatz modernster Technologie haben wir uns in die Lage versetzt, Ihnen sofortigen Zugang zu einem großen Liquiditätspool zu niedrigen Kosten zu verschaffen.",
    ecn: "ECN",
    commission: "Kommission",
    minSpread: "min. Streuen Sie",
    minDeposit: "min. Einzahlung",
    plus: "plus",
    forexCommission: "Kommission auf Forex",
    pips: "Pips",
    compare: "Kontotypen vergleichen",
    experience:
      "Erfahren, vertrauenswürdig und reguliert mit dem Versprechen des Schutzes Ihrer Gelder",
    security: "Sicherheit ist kein Produkt, sondern ein Prozess.",
    strongValue:
      "Mit einem starken Wertesystem bieten wir ein erstklassiges Handelserlebnis. Wir halten uns an einen strengen regulatorischen Rahmen, um Ihre Gelder zu schützen. Wir werden von der Hellenic Capital Market Commission (HCMC) reguliert, die der griechischen und europäischen Gesetzgebung unterliegt.",
    ourClient:
      "Unsere Kunden verlassen sich auf uns, da wir alle Maßnahmen ergreifen, um die Sicherheit ihrer Gelder und die reibungslose Ausführung ihrer Geschäfte zu gewährleisten.",
    success: "Handel mit Frieden, Handel für Erfolg!",
    live: "LIVE-KONTO ERÖFFNEN",
    demo: "DEMO-KONTO ERÖFFNEN",
    zuluTrade: "ZuluTrade",
    treasure: "Eine Schatzkammer für Forex-Händler!",
    copyTrade: "Kopieren Sie einen Trading-Meister oder werden Sie einer!",
    socialTrading:
      "Greifen Sie mit unserem Zulu-Konto über einen zuverlässigen Broker auf das größte soziale Handelsnetzwerk zu. Damit können Sie automatisch die Trades einiger erfolgreicher Trader kopieren, die ihre Live-Handelsperformance vorführen.",
    investor:
      "ihrer Anleger machen Gewinne, wenn sie Top-Trader richtig kopieren.",
    topTrader: "Werden Sie ein Top-Trader oder folgen Sie einem Top-Trader.",
    yourTrading: "Ihr Handel",
    arsenal: "Arsenal",
    actTrader: "Gesetz Händler",
    mostAdvance: "Fortschrittlichste Technologie",
    comming: "Demnächst",
    desktop: "Desktop",
    ios: "iOS",
    android: "Android",
    web: "Web",
    mt4: "MetaTrader 4",
    popularPlatform: "Beliebteste Plattform",
    mt5: "MetaTrader 5",
    nextGen: "Die Plattform der nächsten Generation",
    firstTrade:
      "Platzieren Sie Ihren ersten Trade mit AAAFx in weniger als 15 Minuten",
    register: "Registrieren Sie sich",
    min: "Innerhalb einer Minute",
    kyc: "KYC",
    photo: "Ein gültiger Lichtbildausweis",
    addressProof: "Ein aktueller Adressennachweis",
    deposit: "Einzahlung",
    instantly: "Sofort",
    method: "Über 5 Einzahlungsmethoden",
    trade: "Handel",
    range: "Eine Reihe von Märkten",
    spread: "Rohe Brotaufstriche",
    ultraLow: "Sehr niedrige Provision",
    create: "IHR KONTO ERSTELLEN",
  },
  contactUsPage: {
    heading: "Kontaktieren Sie uns",
    headingDescription: "Unser Support-Team ist 24/5 für Sie da",
    requestCallBack: "Fordern Sie einen Rückruf an:",
    FullName: "Vollständiger Name",
    EmailAddress: "E-Mail Adresse",
    PhoneNumber: "Telefon Nummer",
    Are_you_an_existing_client: "Sind Sie ein bestehender Kunde?",
    Yes: "Ja",
    No: "Nein",
    Select_your_Timezone: "Wählen Sie Ihre Zeitzone",
    How_can_we_help_you: "Wie können wir Ihnen helfen?",
    Select_a_topic: "Wählen Sie ein Thema",
    NewAccounts: "Neue Konten",
    CustomerSupport: "Kundenbetreuung",
    TechnicalQueries: "Technische Rückfragen",
    IBProgram: "IB-Programm",
    PAMM_Accounts: "PAMM-Konten",
    WhiteLabel: "Weißes Etikett",
    BestTimeToCallMessage:
      "Wann kann ich Sie am besten anrufen? Bitte wählen Sie hier",
    SelectPreferredTime: "Bevorzugte Zeit auswählen",
    eightAM: "8:00",
    tenAM: "10:00",
    twelveNoon: "12:00",
    twoPM: "14:00",
    fourPM: "16:00",
    sixPM: "18:00",
    eightPM: "20:00",
    Message: "Nachricht",
    I_agree_to_AAAFx: "Ich stimme AAAFx's",
    PrivacyPolicy: "Datenschutzbestimmungen",
    LiveChat: "Live-Chat",
    AvailableMondayToFriday: "(24/5, Montag-Freitag)",
    CallUs: "Rufen Sie uns an",
    GreeceAndAthens: "Griechenland, Athen",
    GreeceAndAthensContactNumber: "+30 213 0176300",
    AvailableMondayToFridayTime: "Montag bis Freitag 9:00-18:00",
    EmailAddresses: "E-Mail-Adressen",
    Support: "UNTERSTÜTZEN",
    Complaints: "BESCHWERDEN",
    FollowUs: "Folgen Sie uns",
    RegisteredAddress: "Registrierte Adresse",
    ProvidedRegisteredAddressOne:
      "Triple A Experts Investment Services Einzelmitglied S.A.",
    ProvidedRegisteredAddressTwo: "580 Vouliagmenis Avenue 16452",
    ProvidedRegisteredAddressThree: "Argyroupoli Attika",
  },
  depositBonusPage: {
    heading: "Einzahlungsbonus",
    headingDescription: "Warum sollten Sie sich mit weniger zufrieden geben?",
    subHeadingOne:
      "Mit AAAFX Bonus handeln Sie doppelt mit der gleichen Einzahlung",
    subHeadingOneDescription:
      "Wir bieten Ihnen derzeit ein Werbeangebot an, bei dem Sie kostenloses Guthaben (auch Bonusgeld genannt) in der Höhe Ihrer Einzahlung erhalten. Dieses Bonusgeld verdoppelt sofort Ihre Marge, so dass Sie mehr handeln und potenziell mehr verdienen können.",
    What_is_Bonus: "Was ist ein Bonus?",
    What_is_Bonus_desc:
      "Der Bonus wird als zusätzliche Marge zu Ihrem Handelskonto hinzugefügt. Er wird Ihrem Handelskonto sofort als Guthaben gutgeschrieben und erhöht das Gesamtkapital Ihres Handelskontos.",
    Why_should_I_avail_Bonus: "Warum sollte ich den Bonus in Anspruch nehmen?",
    Why_should_I_avail_Bonus_pointOne:
      "Doppelte Handelsspanne ohne zusätzliche Kosten verfügbar",
    Why_should_I_avail_Bonus_pointOne_desc:
      "Nehmen wir an, Sie zahlen $1.000 ein, dann werden wir Ihrem Konto weitere $1.000 hinzufügen. Sie erhalten also ein Gesamtkapital von $2.000, mit dem Sie handeln können. Sie können das kostenlose Bonusgeld sofort in Anspruch nehmen, sobald Sie die Einzahlung getätigt haben.",
    Why_should_I_avail_Bonus_pointTwo:
      "Sofortige Hinzufügung von zusätzlichem Geld auf dem Konto",
    Why_should_I_avail_Bonus_pointTwo_desc:
      'Um den Bonus in Anspruch zu nehmen, müssen Sie sich nach der Einzahlung einfach in Ihrem sicheren Kundenbereich anmelden und auf "Bonus in Anspruch nehmen" klicken. Er wird Ihrem Handelskonto sofort gutgeschrieben.',
    Why_should_I_avail_Bonus_pointThree:
      "DIE GEWINNE AUS DEM BONUS GEHÖREN GANZ IHNEN",
    Why_should_I_avail_Bonus_pointThree_desc:
      "Sie schulden uns nichts von den Gewinnen, die Sie entweder durch den Handel mit Ihrer eigenen Einlage oder durch den von uns hinzugefügten Bonus erzielen. Sie können alle von Ihnen erzielten Gewinne auf Ihrem Konto auszahlen lassen, wann immer Sie wollen.",
    Why_should_I_avail_Bonus_pointFour: "Verzögertes Stop-Out Level",
    Why_should_I_avail_Bonus_pointFour_desc:
      "Ein weiterer Vorteil der Verwendung von Bonusgeld ist, dass im Falle einer unglücklichen Auslosung der Stop-Out Ihres Kontos verzögert wird. Ihre Geschäfte werden vom System erst dann zwangsweise geschlossen, wenn 'ALLE' Ihrer eigenen Mittel beim Handel verloren gegangen sind. Das reguläre Stop-Out-Niveau liegt bei 50%, d.h. wenn Ihr Verhältnis von Eigenkapital zu verwendeter Marge 50% erreicht, wird Ihr Konto gestoppt. Dieses zusätzliche Polster gibt Ihnen die Möglichkeit, den Handel in die entgegengesetzte Richtung zu lenken und möglicherweise profitabel zu werden.",
    Why_should_I_avail_Bonus_pointFive:
      "Wir halten Ihnen bei jeder negativen Bilanz den Rücken frei",
    Why_should_I_avail_Bonus_pointFive_desc:
      "Wenn Sie zufällig Ihr eigenes Geld verlieren und Ihr Saldo ins Minus gerät, bieten wir Ihnen vollen Schutz. Sie können nicht mehr verlieren als das, was Sie eingezahlt haben. Wir setzen Ihren negativen Kontostand auf Null zurück.",
    Why_should_I_avail_Bonus_pointSix:
      "Können meine Verluste mit dem Bonus verrechnet werden?",
    Why_should_I_avail_Bonus_pointSix_desc:
      "Verluste können nicht mit dem Bonus verrechnet werden. Sobald Sie Ihr gesamtes Kapital beim Handel verloren haben, werden alle offenen Trades zu den aktuellen Marktpreisen geschlossen.",
    ReadAllTermsCondition: "Lesen Sie alle Bonusbedingungen und Konditionen",
    here: "hier",
    ClaimBonus: "BONUS ANFORDERN",
    ClaimBonusQuestion:
      "Haben Sie Fragen? Erreichen Sie uns im Live Chat oder schreiben Sie uns an",
  },
  depositWithdrawalPage: {
    heading: "Einzahlungen und Abhebungen",
    headingDescription:
      "Eine Vielzahl von einfachen und bequemen Optionen, die für uns absolut kostenlos sind",
    subHeading:
      "Einzahlungen und Abhebungen von Ihrem Handelskonto waren noch nie so einfach! Investieren Sie in Ihr Handelskonto, ohne zusätzliche Gebühren zu zahlen. Wir bieten Ihnen verschiedene zuverlässige Ein- und Auszahlungsoptionen, damit Ihr Handel reibungslos und einfach vonstatten geht.",
    subHeadingPointOne: "0% Servicegebühr",
    subHeadingPointOneDesc:
      "Wir berechnen keine Gebühren für Einzahlungen oder Abhebungen",
    subHeadingPointTwo: "Transaktionen Sicherheit",
    subHeadingPointTwoDesc:
      "Die Gelder werden in Tier-1-Banken verwahrt und sind von den Eigenmitteln des Unternehmens abgetrennt",
    subHeadingPointThree: "Schnelle Bearbeitung",
    subHeadingPointThreeDesc:
      "Einzahlungen und Abhebungen bei AAAFx werden sofort bearbeitet",
    subHeadingPointFour: "$100",
    subHeadingPointFourDesc: "Mindest-Einzahlungsbetrag",
    subHeadingPointFive: "10+",
    subHeadingPointFiveDesc: "Globale Währungen akzeptiert",
    subHeadingPointSix: "Erhöhte Kontrolle",
    subHeadingPointSixDesc: "Obligatorisches KYC sorgt für mehr Sicherheit",
    WithdrawalUpperCase: "RÜCKTRÄGE",
    WithdrawalDesc:
      "Nahtlose Abhebungen machen jeden Händler glücklich, oder? Das ist es, was wir für unsere Kunden anstreben. Hier finden Sie einige schnelle und einfache Optionen, mit denen Sie sich Ihr hart verdientes Geld innerhalb von 24 Stunden auszahlen lassen können.",
    StepsToWithdrawal: "Schritte zur Abhebung von Ihrem AAAFx Live-Konto",
    StepsToWithdrawalPointOne: "Loggen Sie sich in das Kundenportal ein.",
    StepsToWithdrawalPointTwo:
      "Richten Sie ein Bankkonto unter 'Bankeinrichtung' ein.",
    StepsToWithdrawalPointThree:
      'Klicken Sie auf "Gelder" und dann auf "Abheben".',
    Deposit: "Einzahlung",
    Withdrawals: "Abhebungen",
    BankCards: "Bankkarten",
    Region: "Region",
    Currencies: "Währungen",
    MinDeposit: "Min. Einzahlung",
    ServiceFee: "Service-Gebühr",
    ProcessingTime: "Bearbeitungszeit",
    WorldWide: "Weltweit",
    EUR: "EUR",
    USD: "USD",
    CHF: "CHF",
    GBP: "GBP",
    JPY: "JPY",
    AUD: "AUD",
    BGN: "BGN",
    zero: "0",
    ten: "10",
    instantCaps: "INSTANT",
    fundCaps: "FONDS",
    BankWire: "Banküberweisung",
    twoToThreeBusinessDays: "2-3 ARBEITSTAGE",
    MY: "MEIN",
    TH: "TH",
    ID: "ID",
    PH: "PH",
    VN: "VN",
    BTC: "BTC",
    AdditionalInformation: "Zusätzliche Informationen",
    AdditionalInformationPointOne:
      "Alle Auszahlungen werden über die Methode abgewickelt, die für die Einzahlung auf das Handelskonto verwendet wurde.",
    AdditionalInformationPointTwo:
      "AAAFx erhebt keine Transaktionsgebühren, weder für Einzahlungen noch für Abhebungen.",
    AdditionalInformationPointThree:
      "Wir erstatten Ihnen die Transaktionskosten bis zu 5% Ihres Einzahlungsbetrags auf Ihr Handelskonto.",
    CapsOpenLiveAccount: "LIVE-KONTO ERÖFFNEN",
    CapsOpenDemoAccount: "DEMO-KONTO ERÖFFNEN",
    DepositUpperCase: "EINLAGEN",
    DepositDesc:
      "Was gibt es Wichtigeres, als Geld sicher auf Ihr Handelskonto einzuzahlen? Beginnen Sie Ihre Handelsreise mit einer Mindesteinlage von nur $10. Wir bieten Ihnen eine große Auswahl an Optionen, mit denen Sie Ihr Handelskonto auffüllen können.",
    Steps_to_make_a_deposit:
      "Schritte, um eine Einzahlung auf Ihr AAAFx Live-Konto vorzunehmen",
    Steps_to_make_a_deposit_pointOne:
      "Loggen Sie sich in das Kundenportal ein.",
    Steps_to_make_a_deposit_pointTwo:
      'Klicken Sie auf "Fonds" und dann auf "Einzahlen".',
    Bitcoin: "Bitcoin",
    uptoThirtyMin: "Bis zu 30 Minuten",
    e_wallets: "E-Geldbörsen",
    depositNoteOne:
      "Im Falle einer Überlastung des Netzwerks können Bitcoin-Transaktionen mehrere Stunden dauern.",
    depositNoteTwo:
      "Bei Banküberweisungen deckt AAAFx nur die von unserer Empfängerbank, d.h. der Eurobank, erhobenen Gebühren bis zu einem Betrag von $25. AAAFx hat keine Kenntnis von anderen Gebühren, die vom Absender oder einer anderen zwischengeschalteten Bank erhoben werden, und daher werden diese Gebühren nicht übernommen.",
    EuroBankCaps: "EUROBANK",
    Currency: "Währung",
    SwiftCode: "Swift Code",
    BeneficiaryName: "Name des Begünstigten",
    ProvidedBeneficiaryName: "TRIPLE-A-EXPERTEN",
    ProvidedBeneficiaryNameTwo: "TRIPLE A EXPERTS INVESTMENT SERVICES SA",
    IBAN: "IBAN",
    Address: "Adresse",
    ProvidedAddress: "Akti Kondili 26-28, 18545 Piräus, GRIECHENLAND",
    ProvidedAddressTwo: "Chemin de la Crétaux 33, 1196 Gland, Schweiz",
    ProvidedSwiftCode: "ERBKGRAA",
    ProvidedSwiftCodeTwo: "SWQBCHZZXXX",
    IBANCodeOne: "GR9502600590000421200023114",
    IBANCodeTwo: "GR3202600590000410200460346",
    IBANCodeThree: "GR9702600590000441200009691",
    IBANCodeFour: "GR4202600590000451200009759",
    IBANCodeFive: "GR0602600590000411200012446",
    IBANCodeSix: "GR6202600590000441200012358",
    IBANCodeSeven: "GR5402600590000471200017496",
    IBANCodeEight: "CH0708781000097621100",
    Warning: "Warnung",
    WarningMessage:
      "Geben Sie bei ausgehenden Überweisungen immer Ihre E-Mail-Adresse, Ihren vollständigen Namen und Ihre Handelskontonummer an (bei neuen Konten nur Ihre E-Mail-Adresse und Ihren vollständigen Namen), um eine sofortige Bearbeitung zu gewährleisten. Andernfalls kann AAAFx Ihre Einzahlung verzögern.",
    swissubebankSA: "SWISSYUBE BANK SA",
  },
  stocksPage: {
    Forex: "Forex",
    Indices: "Indizes",
    Commodities: "Commodities",
    Stocks: "Aktien",
    Cryptocurrencies: "Kryptowährungen",
    heading: "AKTIEN",
    headingDescription:
      "Investieren Sie Ihre Anteile in die wichtigsten Blue-Chip-Aktien der Welt",
    min: "min",
    zeroPointZeroSeventyFive: "0.075",
    zeroPointZero: "0.0",
    five: "5",
    one: "1",
    Commission: "Kommission",
    minExecution: "min. Ausführung",
    tenMiliSeconds: "10ms",
    Spread: "Streuen Sie",
    hundredPlus: "100+",
    UpTo: "Bis zu",
    Leverage: "Hebelwirkung",
    StocksContract: "Aktien Vertrag",
    Specifications: "Spezifikationen",
    StocksContractSpecifications:
      "Für Kunden, die als Professional eingestuft sind, können flexiblere Handelsbedingungen (höhere Hebelwirkung) gelten. Bitte loggen Sie sich in Ihr Konto ein und prüfen Sie, ob Sie als professioneller Kunde eingestuft werden können, oder schreiben Sie uns an",
    supportMail: "support{'@'}aaafx.com",
    Instrument: "Instrument",
    Bid: "Angebot",
    Ask: "Fragen Sie",
    ContractSize: "Vertragsgröße",
    MinTradeSize: "Min. Handelsgröße",
    TickValue: "Tick-Wert",
    TradingHours: "Handelszeiten",
    sevenAM: "7:00 Uhr",
    twelvePM: "12:00 Uhr",
    Treasury_products_description:
      "Treasury-Produkte haben einen vierteljährlichen Verfallstermin (siehe Tabelle unten). Kunden, die am Verfallstag eine offene Position halten, werden zu unserem Geld-/Briefkurs um 21:00 Uhr GMT für BUND geschlossen. Die einzige Konsequenz daraus ist, dass der Kunde zum Zeitpunkt der Schließung einen variablen P/L realisiert. Für alle angebotenen Treasury-Kontrakte gibt es keine Rollover.",
    ExpirationDateCaps: "VERFALLSDATEN",
    Bund: "Bund",
    CORNF: "CORNF",
    WHEATF: "WHEATF",
    SOYF: "SOYF",
    seventhDecemberTwentyTwentyOne: "7-Dez-21",
    twentysixNovemberTwentyOne: "26-Nov-21",
    twentysevenNovemberTwentyOne: "27-Nov-21",
    twentyFourFebruaryTwentyTwo: "24-Feb-22",
    twentyNineDecemberTwentyOne: "29-Dez-21",
    WhatisStocksCFD: "Was ist der Handel mit Aktien-CFDs?",
    WhatisStocksCFDDesc:
      "Aktien-CFDs sind eine kostengünstige Möglichkeit, von den Kursbewegungen der Aktienkurse von Top-Unternehmen zu profitieren. Der größte Vorteil des Handels mit Aktien-CFDs gegenüber Aktien ist der geringe Kapitalbedarf. Wenn Sie mit Aktien handeln, müssen Sie den vollen Preis einer Aktie bezahlen. Bei Aktien-CFDs hingegen erwerben Sie nicht das tatsächliche Eigentum an den Aktien und zahlen daher nur einen kleinen Prozentsatz des Preises, um von den Kursbewegungen zu profitieren. Außerdem können Sie eine Hebelwirkung nutzen, um Ihr Gewinnpotenzial zu maximieren.",
    How_does_it_work: "Wie funktioniert das?",
    How_does_it_work_desc:
      "Beim Handel mit Aktien-CFDs besitzen Sie die Aktie, in die Sie investieren, nicht. Sie hinterlegen lediglich eine kleine Marge, die weit unter den tatsächlichen Kosten der Aktie liegt, und nutzen die Vorteile des gehebelten Handels. Die Gewinne oder Verluste werden berechnet, indem Sie den Kaufkurs vom Verkaufskurs abziehen und das Ergebnis mit Ihrer Positionsgröße multiplizieren. Um beispielsweise den Gegenwert von 100 Facebook-Aktien-CFDs bei uns zu kaufen, benötigen Sie nur eine Einlage von 20 % des gesamten Positionswerts im Vergleich zu dem, was Sie für den Kauf physischer Aktien zahlen würden. Dann müssten Sie bei uns nur eine Margin in Höhe von 6400 $ hinterlegen (20% von 32.000 $ = 6400 $), ohne die Provisionen. Würden Sie hingegen die gleiche Anzahl von Aktien direkt bei einem Aktienmakler kaufen, müssten Sie die gesamten 32.000 $ zuzüglich Provisionen und Steuern zahlen.",
    Account: "Konto",
    Types: "Typen",
    ECN: "ECN",
    plus: "plus",
    zulu: "zulu",
    DepositMin: "Kaution (min.)",
    hundred: "100",
    tenThousand: "10,000",
    CommissionPerLakh: "Provision (pro $100k)",
    zeroPointZeroNinetyThree: "0.093",
    SpreadMin: "Aufstrich (min.)",
    CompareAccountTypes: "Kontotypen vergleichen",
    OurOnline: "Unser Online",
    Trading: "Handel",
    Platforms: "Plattformen",
    Desktop: "Desktop",
    WebTrader: "Web Trader",
    Android: "Android",
    iOS: "iOS",
    LeranMore: "MEHR LERNEN",
    NegativeBalance: "Negativer Saldo",
    Protection: "Schutz",
    ReliableProtectionHeading:
      "Zuverlässiger Schutz Ihrer Gelder auf AAAFx-Konten",
    ReliableProtectionDescription:
      "Wir sind immer bestrebt, im besten Interesse unserer Kunden zu arbeiten. Wenn Ihr Konto in volatilen Zeiten ins Minus gerät, halten wir Ihnen den Rücken frei! Wir setzen Ihren negativen Saldo auf Null zurück, so dass Sie keinen zusätzlichen Verlust erleiden. Sie können einzahlen und den Handel wieder aufnehmen. Sie können also nicht mehr verlieren als das, was Sie eingezahlt haben.",
    OpenLiveAccount: "LIVE-KONTO ERÖFFNEN",
    OpenDemoAccount: "DEMO-KONTO ERÖFFNEN",
  },
  referAndEarnPage: {
    heading: "Empfehlen und verdienen",
    headingDescription: "Je mehr Sie teilen, desto mehr bekommen Sie",
    startsWithSharing: "Alles beginnt mit dem Teilen!",
    startsWithSharingDescOne:
      "Kennen Sie jemanden, den Sie in den Handel einführen möchten? Nun, sie könnten Ihnen Geld einbringen. Laden Sie Ihre Freunde ein, über Ihren einzigartigen Empfehlungslink bei AAAFx einzusteigen. Sie und Ihr Empfehlungsgeber verdienen jeweils $25.",
    startsWithSharingDescTwo:
      "Erhöhen Sie einfach Ihr Einkommen, ohne dass Ihnen zusätzliche Kosten entstehen. Je mehr Freunde Sie werben, desto mehr verdienen Sie!",
    startsWithSharingDescThree:
      "Behalten Sie mit unseren Echtzeit-Berichtstools immer den Überblick über Ihr Konto und überwachen Sie den Status Ihrer Empfehlungen, um Ihre Einnahmen zu maximieren:",
    startsWithSharingDescThreePointOne:
      "Sie erhalten Ihren persönlichen Empfehlungslink, wenn Sie ihn benötigen.",
    startsWithSharingDescThreePointTwo:
      "Sehen Sie, wie viel Sie bis heute verdient haben",
    startsWithSharingDescThreePointThree:
      "Überprüfen Sie die Überweisungshistorie",
    startsWithSharingDescThreePointFour:
      "Jederzeitiger Zugriff auf Statistiken",
    How_to_get_started: "Wie fangen Sie an?",
    How_to_get_started_pointOne:
      "Melden Sie sich in Ihrem sicheren Kundenbereich an",
    How_to_get_started_pointTwo:
      "Holen Sie sich Ihren Empfehlungslink und teilen Sie ihn mit Ihren Freunden.",
    How_to_get_started_pointThree:
      "Verdienen Sie $25, wenn sich Ihre Empfehlungen anmelden und qualifizieren.",
    WhatDoYourReferrals: "Was müssen Ihre Empfehlungsschreiben tun?",
    WhatDoYourReferralsDescOne:
      "Ihre Empfehlungen müssen lediglich Ihren Empfehlungslink verwenden, um sich bei uns zu registrieren. Wenn sie dies versäumen, ist das kein Problem! Sie können",
    WhatDoYourReferralsDescTwo:
      "kommen Sie einfach in den Live-Chat und teilen Sie uns mit, dass sie über Sie gekommen sind. Wir nehmen sie dann in Ihre Empfehlungsliste auf.",
    Benefits_to_you: "Vorteile für Sie",
    Benefits_to_you_pointOne: "Unbegrenzte Empfehlungseinnahmen.",
    Benefits_to_you_pointTwo:
      "Nachdem Sie 10 Kunden geworben haben, können Sie entweder im Refer and Earn Plan weitermachen oder zum IB-Programm wechseln.",
    Benefits_to_you_pointThree: "Live-Verfolgung Ihrer Einnahmen.",
    Benefits_to_you_pointFour:
      "Gewinnen Sie Kunden mit unseren lukrativen Werbeangeboten inklusive Bonus.",
    Benefits_to_you_pointFive:
      "24/5 Kundenbetreuung und persönlicher Kundenbetreuer.",
    Benefits_to_your_referrals: "Vorteile für Ihre Empfehlungsgeber",
    Benefits_to_your_referrals_pointOne:
      "Genießen Sie unsere tadellosen Handelsbedingungen.",
    Benefits_to_your_referrals_pointTwo:
      "Verdienen Sie die Empfehlungsprämie, genau wie der Empfehlende.",
    Benefits_to_your_referrals_pointThree:
      "Nutzen Sie die Vorteile unserer vollständig integrierten Konten bei ZuluTrading.",
    Benefits_to_your_referrals_pointFour:
      "Profitieren Sie von unseren Sonderangeboten, einschließlich Bonus und Treueprogramm.",
    Benefits_to_your_referrals_pointFive:
      "Verwenden Sie ihren eigenen Empfehlungslink und bringen Sie ihre eigenen Kunden mit.",
    How_is_AAAFx_Refer_and: "Wie ist AAAFx Refer und",
    Earn_Plan_different_from_the_IB_Program:
      "Earn Plan anders als das IB-Programm?",
    How_is_AAAFx_Refer_desc:
      "Obwohl beide Programme ähnlich klingen, sind sie sehr unterschiedlich. Hier sind die wichtigsten Unterschiede",
    Feature: "FEATURE",
    referandEarnPlan: "EMPFEHLEN UND VERDIENEN PLAN",
    IBProgram: "IB-PROGRAMM",
    Earnings: "Ergebnis",
    EarningsPointOneP1: "$25 für Sie und Ihre Empfehlung; bis zu",
    EarningsPointOneP2: "10 Kunden (ändert sich auf $20 nach",
    EarningsPointOneP3: "10 qualifizierte Kunden)",
    EarningsPointTwop1: "20% Provisionsanteil in Standard IB",
    EarningsPointTwop2: "Programm und angepasste Aktie in",
    EarningsPointTwop3: "Fortgeschrittenes IB-Programm",
    Earning_frequency: "Verdiensthäufigkeit",
    Earning_frequency_p1: "Einmalige Belohnung",
    Earning_frequency_p2: "Lebenslange Provisionen",
    Live_tracking: "Live-Verfolgung",
    Yes: "Ja",
    No: "Nein",
    View_of_referrals_activities:
      "Ansicht der Aktivitäten von Empfehlungsgebern",
    Limited: "Begrenzt",
    Full_fledged: "Vollwertig - flügge",
    SeparatePortal: "Separates Portal",
    Pay_out_frequency: "Auszahlungshäufigkeit",
    Weekly: "Wöchentlich",
    you_can_read_terms_and_condition:
      "Sie können alle Bedingungen und Konditionen des Refer and Earn Plans lesen",
    here: "hier",
    capsStartRefering: "ANFANGEN ZU ÜBERWEISEN",
    readyToGoBeyondEarnPlan:
      "Sind Sie bereit, über den Refer and Earn Plan hinauszugehen?",
    signUpAsIBWithUs: "Melden Sie sich als IB bei uns an. Alle Vorteile lesen",
  },
  commoditiesPage: {
    Forex: "Forex",
    Indices: "Indizes",
    Commodities: "Commodities",
    Stocks: "Aktien",
    Cryptocurrencies: "Kryptowährungen",
    heading: "GÜTER",
    headingDescription:
      "Bauen Sie Ihr vielfältiges Portfolio durch den Handel mit wichtigen Rohstoffen auf",
    min: "min",
    hundred: "100",
    tenThousand: "10,000",
    CommissionPerLakh: "Provision (pro $100k)",
    zeroPointNinentyNine: "0.99",
    zeroPointSeventyFour: "0.74",
    Commission: "Kommission",
    zeroPintZero: "0.0",
    Spread: "Streuen Sie",
    execution: "Ausführung",
    tenMiliSec: "10ms",
    ten: "10",
    Up_to: "Bis zu",
    twenty: "20",
    Leverage: "Hebelwirkung",
    CommoditiesContract: "Commodities Vertrag",
    Specifications: "Spezifikationen",
    CommoditiesContractDesc:
      "Für Kunden, die als Professional eingestuft sind, können flexiblere Handelsbedingungen (höhere Hebelwirkung) gelten. Bitte loggen Sie sich in Ihr Konto ein und prüfen Sie, ob Sie als professioneller Kunde eingestuft werden können, oder schreiben Sie uns an",
    supportmail: "support{'@'}aaafx.com",
    Instrument: "Instrument",
    Bid: "Angebot",
    Ask: "Fragen Sie",
    ContractSize: "Vertragsgröße",
    MinTradeSize: "Min. Handelsgröße",
    TickValue: "Tick-Wert",
    TradingHours: "Handelszeiten",
    sevenAM: "7:00 Uhr",
    twelvePM: "12:00 Uhr",
    TreasuryProductsDescription:
      "Treasury-Produkte haben einen vierteljährlichen Verfallstermin (siehe Tabelle unten). Kunden, die am Verfallstag eine offene Position halten, werden zu unserem Geld-/Briefkurs um 21:00 Uhr GMT für BUND geschlossen. Die einzige Konsequenz daraus ist, dass der Kunde zum Zeitpunkt der Schließung einen variablen P/L realisiert. Für alle angebotenen Treasury-Kontrakte gibt es keine Rollover.",
    capsExpirationDates: "VERFALLSDATEN",
    Bund: "Bund",
    cornf: "CORNF",
    wheatf: "WHEATF",
    soyf: "SOYF",
    seventhDecemberTwentyTwentyOne: "7-Dez-21",
    twentysixNovemberTwentyOne: "26-Nov-21",
    twentysevenNovemberTwentyOne: "27-Nov-21",
    twentyFourFebruaryTwentyTwo: "24-Feb-22",
    twentyNineDecemberTwentyOne: "29-Dez-21",
    What_is_Commodities_Trading: "Was ist der Handel mit Rohstoffen?",
    What_is_Commodities_Trading_desc:
      'Zu den Rohstoffen gehören Edelmetalle, Öl und Erdgas. Diese Instrumente weisen eine geringere Korrelation zu allen anderen auf dem Markt angebotenen Vermögenswerten auf und können eine hervorragende Option zur Diversifizierung sein. Angesichts der fundamentalen Volatilität der Länder weltweit gelten Rohstoffe als "sicherer Hafen", der sie vor starken Preisschwankungen schützt.',
    How_does_it_work: "Wie funktioniert das?",
    How_does_it_work_desc:
      "Beim Handel mit Rohstoffen erhalten Sie keine physische Lieferung von Vermögenswerten. Das Potenzial für Gewinne liegt in den Preisbewegungen. Da diese Vermögenswerte auf der Erde nur in begrenztem Umfang vorhanden sind und in der industriellen Produktion verwendet werden, sind sie zuweilen Schwankungen ausgesetzt, die von verschiedenen wirtschaftlichen und politischen Faktoren abhängen. Ohne den Vermögenswert tatsächlich zu besitzen, kann der Händler einfach auf seinen Preis spekulieren. Da eine Vielzahl von Informationen über die Wirtschaft verschiedener Länder, die politische Lage, Investitionen, Angebot und Nachfrage usw. zur Verfügung stehen, ist es für die Händler bequemer denn je geworden, größere Preisbewegungen vorherzusagen und darauf zu spekulieren. XAUUSD bezieht sich zum Beispiel auf den Goldpreis in USD. Um tatsächlich in Gold zu investieren, benötigen Sie ein beträchtliches Kapital. Mit Leveraged Trading können Sie jedoch mit minimalem Kapitaleinsatz in alle Edelmetalle, Öl usw. investieren.",
    Account: "Konto",
    Types: "Typen",
    ECN: "ECN",
    plus: "plus",
    zulu: "zulu",
    DepositMin: "Kaution (min.)",
    spreadMin: "Aufstrich (min.)",
    CompareAccountTypes: "Kontotypen vergleichen",
    OurOnline: "Unser Online",
    Trading: "Handel",
    Platforms: "Plattformen",
    Desktop: "Desktop",
    WebTrader: "Web Trader",
    Android: "Android",
    iOS: "iOS",
    capsLearnMore: "MEHR LERNEN",
    NegativeBalance: "Negativer Saldo",
    Protection: "Schutz",
    NegativeBalanceDesc1: "Zuverlässiger Schutz Ihrer Gelder auf AAAFx-Konten",
    NegativeBalanceDesc2:
      "Wir sind immer bestrebt, im besten Interesse unserer Kunden zu arbeiten. Wenn Ihr Konto in volatilen Zeiten ins Minus gerät, halten wir Ihnen den Rücken frei! Wir setzen Ihren negativen Saldo auf Null zurück, so dass Sie keinen zusätzlichen Verlust erleiden. Sie können einzahlen und den Handel wieder aufnehmen. Sie können also nicht mehr verlieren als das, was Sie eingezahlt haben.",
    CapsOpenLiveAccount: "LIVE-KONTO ERÖFFNEN",
    CapsOpenDemoAccount: "DEMO-KONTO ERÖFFNEN",
  },
  careerPage: {
    heading: "Karriere",
    headingDescription:
      "Wir lieben, was wir tun, und glauben, dass Sie es auch lieben werden! Inklusion, Vielfalt, Innovation und Loyalität sind die Gründe, warum unsere Mitarbeiter ihre Arbeit lieben und jeden Tag gerne zur Arbeit kommen.",
    Join_us_and_help_us:
      "Schließen Sie sich uns an und helfen Sie uns, bei allem, was wir tun, Mehrwert zu schaffen!",
    OurCulture: "Unsere Kultur",
    OurCulturePointOne:
      "Niemand kann eine Sinfonie pfeifen. Es braucht ein ganzes Orchester, um sie zu spielen. - (H.E. Luccock)",
    OurCulturePointTwo:
      "Bei AAAFx ermutigen wir Sie, die bessere Version Ihrer selbst zu sein. Zeigen Sie, wer Sie wirklich sind, lernen Sie und haben Sie Erfolg! Derzeit beschäftigen wir über 80 Mitarbeiter und wollen unser Team weiter ausbauen. Unser Ziel ist es, ein förderliches Arbeitsumfeld zu schaffen, das Ihnen ein Gefühl der Erfüllung vermittelt.",
    When_our_clients: "Wenn unsere Kunden",
    succeed_we_succeed: "Erfolg haben, haben wir Erfolg!",
    succeed_we_succeed_pointOneP1:
      "Wir sind weniger, wenn wir nicht alle mit einbeziehen.",
    succeed_we_succeed_pointOneP2: "- (Stuart Milk)",
    succeed_we_succeed_pointOnedesc1:
      "Wir haben eine kohäsive und integrative Kultur aufgebaut, die ein breites Spektrum von Mitarbeitern umfasst, die eine lange Liste von persönlichen Erfolgen und einen immensen Teamgeist aufweisen. Inklusion fördert ein Gefühl der Zugehörigkeit und des Respekts gegenüber der Organisation. Das ist der Grund, warum sich unsere Mitarbeiter wichtig und wertvoll fühlen.  Wir bemühen uns, ein Umfeld zu schaffen, in dem jeder das Gefühl hat, gemeinsam für dieselbe Sache zu arbeiten.",
    succeed_we_succeed_pointOnedesc2:
      '"Ausgezeichnete Leistung für ein besseres Morgen".',
    succeed_we_succeed_pointTwoP1:
      "Die Stärke liegt in den Unterschieden, nicht in den Gemeinsamkeiten.",
    succeed_we_succeed_pointTwoP2: "- (Stephen R. Covey)",
    succeed_we_succeed_pointTwodesc1:
      "Ein geschlechtlich und kulturell vielfältiges Team ist für uns unerlässlich, um eine breitere und globale Wirkung zu erzielen. Unser Prinzip ist es, ein gleiches Verhältnis von männlichen und weiblichen Teammitgliedern zu haben, die wir respektieren und akzeptieren. Indem wir körperliche Fähigkeiten, Rassismus und religiöse Überzeugungen beiseite lassen, koexistieren und gedeihen wir in einer förderlichen Umgebung. Jeder, der bei uns arbeitet, erhält die gleichen Chancen, wird gleich bezahlt und trägt zur Überwindung gesellschaftlicher Stereotypen bei.",
    succeed_we_succeed_pointThreeP1:
      "Die Loyalität der Mitarbeiter beginnt mit der Loyalität des Arbeitgebers.",
    succeed_we_succeed_pointThreeP2: " - (Harvey Mackay)",
    succeed_we_succeed_pointThreedesc:
      "Ohne die Unterstützung unseres Teams hätten wir nicht erreichen können, wo wir sind. Unsere Marke lebt von der Loyalität ihrer Mitarbeiter, seien es Kunden oder unsere Mitarbeiter. Loyalität ist nicht nur eine gewöhnliche Eigenschaft, sondern eine Kraft, die Teammitglieder dazu antreibt, ihr Bestes zu geben und Höchstleistungen zu erbringen. Außerdem wird oft gesagt, dass die Loyalität der Mitarbeiter ansteckend ist. Sie beginnt an der Spitze und zieht sich durch alle Bereiche unseres Teams. Unser Team ist stolz auf das, was es tut, und es ist entschlossen, 100 % zu geben.",
    succeed_we_succeed_pointFourP1: "Innovation ist der einzige Weg zum Sieg.",
    succeed_we_succeed_pointFourP2: "- (Steve Jobs)",
    succeed_we_succeed_pointFourdesc:
      "Wir fördern das unkonventionelle Denken auf allen Ebenen, um das Beste in unseren Mitarbeitern hervorzubringen. Kreativität ist unerlässlich, um mit Hilfe von Vorstellungskraft neue Dinge zu schaffen, die dann durch die einzigartigen Fähigkeiten unserer Mitarbeiter weiter verfeinert werden. Dies hat dazu geführt, dass wir die Kundenbeziehungen verbessern, die Produktivität steigern, einen besseren Service bieten, die Kosten senken und gemeinsam eine starke Marke aufbauen konnten.",
    Rewards_and_Benefits: "Belohnungen und Vorteile",
    Rewards_and_Benefits_PointOne:
      "Die Belohnung für gut gemachte Arbeit ist die Möglichkeit, mehr zu tun. - (Jonas Salk)",
    Rewards_and_Benefits_PointTwo:
      "Möchten Sie mehr Zeit mit Ihrer Familie verbringen oder sich um Ihre Gesundheit und Fitness kümmern? Sind Sie bereit, sich beruflich weiterzuentwickeln und trotzdem ein Gleichgewicht zu halten? Wir bieten unseren Mitarbeitern nicht nur eine branchenübliche Vergütung, sondern auch ein flexibles Arbeitsumfeld, lukrative Belohnungen und verschiedene Formen der Wertschätzung und Anerkennung.",
    CurrentVacancies: "Aktuelle Stellenangebote",
    CurrentVacanciesDescOne:
      "Kommen Sie zu uns und werden Sie Teil einer herausragenden Belegschaft, die nur durch hervorragende Leistungen und Engagement in einer kohäsiven Teamumgebung angetrieben wird. Jeder, der bei AAAFx arbeitet, fühlt sich bei der Arbeit wertgeschätzt!",
    CurrentVacanciesDescTwo:
      "Erfahren Sie, was es braucht, um einer von uns zu werden und wie Sie sich am besten vorbereiten können. Wir freuen uns darauf, Ihre Bewerbung zu erhalten und von Ihnen zu hören.",
    ReadyForChallengesReadyForYou:
      "Wenn Sie bereit für Herausforderungen sind, sind wir bereit für Sie",
    CustomerSupportGreece: "Kundenbetreuer, Griechenland",
    What_the_job_looks_like: "Wie sieht der Job aus?",
    What_the_job_looks_like_pointOne:
      "Kundenbetreuung im Chat, per E-Mail und Telefon.",
    What_the_job_looks_like_pointTwo:
      "Verantwortungsvolle und proaktive Bearbeitung von Kundenanfragen.",
    What_the_job_looks_like_pointThree:
      "Untersuchung von Geschäften von Kunden, falls erforderlich.",
    What_the_job_looks_like_pointFour:
      "Kommunizieren Sie mit Ihren Kunden auf sanfte, freundliche und hochprofessionelle Weise.",
    What_the_job_looks_like_pointFive:
      "Enge Zusammenarbeit mit der Geschäftsleitung bei der Festlegung kurz- und langfristiger Ziele und Vorgaben.",
    What_the_job_looks_like_pointSix:
      "Sie notieren die Anfragen Ihrer Kunden und leiten sie proaktiv an die zuständigen Teams weiter.",
    What_the_job_looks_like_pointSeven:
      "Sie arbeiten bei Bedarf mit verwandten Teams zusammen, um den Kunden einen hervorragenden Service zu bieten.",
    What_the_job_looks_like_pointEight:
      "Sicherstellen, dass den Kunden ein Höchstmaß an Kundenservice geboten wird.",
    What_do_we_look_for: "Wonach suchen wir?",
    What_do_we_look_for_pointOne:
      "Starke Geistesgegenwart und Problemlösungskompetenz.",
    What_do_we_look_for_pointTwo: "Ausgezeichnete Kommunikationsfähigkeiten.",
    What_do_we_look_for_pointThree: "Starker Teamgeist",
    What_do_we_look_for_pointFour:
      "Eine positive Einstellung und ein ruhiges und gelassenes Verhalten.",
    What_do_we_look_for_pointFive:
      "Frühere Erfahrungen im Bereich Investment Finance oder Kundenbetreuung.",
    What_do_we_look_for_pointSix:
      "Professionalität, Ehrlichkeit und Integrität.",
    applyForTheJob: "BEWERBEN SIE SICH FÜR DIE STELLE",
    FinanceExecutiveGreece: "Geschäftsführer Finanzen, Griechenland",
    What_the_job_looks_like_point1:
      "Unterstützung bei der Erstellung vierteljährlicher und jährlicher Budgets",
    What_the_job_looks_like_point2:
      "Verwaltung von Aufzeichnungen und Quittungen",
    What_the_job_looks_like_point3:
      "Erstellung von Budget-/Ist-Analysen und Berichten",
    What_the_job_looks_like_point4:
      "Abgleich von täglichen, monatlichen, vierteljährlichen und jährlichen Transaktionen",
    What_the_job_looks_like_point5: "Erstellung von vierteljährlichen Bilanzen",
    What_the_job_looks_like_point6: "Bearbeitung von Rechnungen",
    What_the_job_looks_like_point7:
      "Erstellung von Cashflow-Rechnungen für die Abteilung",
    What_the_job_looks_like_point8:
      "Sie sind Ansprechpartner für andere Abteilungen in Finanzangelegenheiten.",
    What_the_job_looks_like_point9:
      "Verrechnung von Erstattungen für Mitarbeiter.",
    What_the_job_looks_like_point10:
      "Berechnung und Veröffentlichung von Finanzkennzahlen",
    What_the_job_looks_like_point11:
      "Unterstützung bei Audits, falls erforderlich.",
    What_the_job_looks_like_point12:
      "Einbringen von Ideen und Vorschlägen für ein effizientes Fondsmanagement",
    What_do_we_look_for_point1: "Leidenschaft für Finanzen und Buchhaltung",
    What_do_we_look_for_point2: "Vollständige Kenntnisse in ERP und MS Office",
    What_do_we_look_for_point3:
      "Master in Rechnungswesen und mindestens 3 Jahre Berufserfahrung bei einem globalen Broker.",
    What_do_we_look_for_point4: "Starke analytische Fähigkeiten",
    What_do_we_look_for_point5: "Ausgezeichneter Teamplayer",
    What_do_we_look_for_point6: "Positive Einstellung",
    DataAdministratorGreece: "Datenverwalter, Griechenland",
    What_the_job_looks_like_p1:
      "Kontrollieren Sie Zugriffsberechtigungen und Privilegien.",
    What_the_job_looks_like_p2:
      "Bieten Sie den Entwicklern Unterstützung und Hilfe an.",
    What_the_job_looks_like_p3:
      "Überwachen und pflegen Sie den Systemzustand und die Sicherheit.",
    What_the_job_looks_like_p4:
      "Entwerfen Sie Backup-Prozesse für Server und zugehörige Daten.",
    What_the_job_looks_like_p5:
      "Erstellen Sie Konten für alle Benutzer und weisen Sie Sicherheitsstufen zu.",
    What_the_job_looks_like_p6:
      "Bieten Sie technischen End-to-End-Support und Problemlösungen an.",
    What_the_job_looks_like_p7:
      "Planen und führen Sie regelmäßige Serverwartungen durch.",
    What_the_job_looks_like_p8: "Erstellen Sie Datenbankverwaltungsprozeduren.",
    What_the_job_looks_like_p9:
      "Bereiten Sie statistische Informationen für den internen und externen Gebrauch vor.",
    What_the_job_looks_like_p10:
      "Bewerten Sie Modelle und Verfahren zur Datenanalyse.",
    What_the_job_looks_like_p11:
      "Nehmen Sie am Cross-Training-Programm des Unternehmens teil.",
    What_do_we_look_for_p1: "Bachelor-Abschluss in Informatik.",
    What_do_we_look_for_p2: "1+ Jahre Erfahrung in einer ähnlichen Funktion.",
    What_do_we_look_for_p3:
      "Fortgeschrittene Kenntnisse der Datenbankstruktur und -theorie.",
    What_do_we_look_for_p4: "Erfahrung mit MySQL und MSSQL.",
    What_do_we_look_for_p5: "Verständnis von Datenbank-Backup-Verfahren.",
    What_do_we_look_for_p6: "PostgreSQL-Zertifizierung bevorzugt.",
    What_do_we_look_for_p7:
      "Sie sind in der Lage, mit minimaler Aufsicht und Unterstützung selbstständig zu arbeiten.",
    How_to_Apply: "Wie kann man sich bewerben?",
    How_to_Apply_p1:
      "Wenn Sie der Meinung sind, dass Sie gut in eine der oben genannten Rollen passen, klicken Sie einfach auf die Schaltfläche 'Bewerben' und senden Sie uns Ihre",
    How_to_Apply_p2:
      "Lebenslauf. Unser HR Associate wird sich mit Ihnen in Verbindung setzen.",
  },
  autoChartistPage: {
    heading: "Autochartist",
    headingDesc: "Lässt Sie Ihre Handelszeit sinnvoll investieren",
    subHeadingOne:
      "Greifen Sie kostenlos auf eines der beliebtesten Trading-Tools bei AAAFx zu",
    subHeadingOneP1:
      "Treffen Sie fundierte Entscheidungen, denn Autochartist analysiert alle Charts und Muster für Sie.",
    subHeadingOneP2:
      "Wenn Sie ein Trader sind, kennen Sie den Wert der Zeit wie kein anderer. Wir stellen Ihnen ein hervorragendes Tool vor, das Ihnen viel Zeit und Energie spart und verschiedene Arten von Analysen für Sie durchführt.",
    subHeadingTwo: "Wie funktioniert Autochartist?",
    subHeadingTwoP1: "Verpassen Sie nie eine Gelegenheit!",
    subHeadingTwoP2: "Autochartist arbeitet mit drei Arten von Mustern:",
    ChartPatterns: "Chart-Muster",
    FibonacciPatterns: "Fibonacci-Patterns",
    KeyLevels: "Schlüssel Levels",
    subHeadingTwoDesc:
      "Es überwacht den Markt und sendet ständig Benachrichtigungen über Handelsmöglichkeiten. Lassen Sie die Technologie für Sie arbeiten, 24 Stunden am Tag, nonstop.",
    One_stop_solution: "Alles aus einer Hand für die Marktanalyse",
    One_stop_solution_p1:
      "Identifizierung von Unterstützungs- und Widerstandsniveaus",
    One_stop_solution_p2:
      "Echtzeit-Benachrichtigungen bei übermäßigen Bewegungen",
    One_stop_solution_p3:
      "Eingehende Analyse der makroökonomischen Nachrichten",
    One_stop_solution_p4:
      "Identifizierung von Unterstützungs- und Widerstandsniveaus",
    Single_Screen_access_to_everythinig:
      "Zugriff auf alles über einen einzigen Bildschirm",
    Get_simply_plugged_in_to_MT4_and_MT5:
      "Verbinden Sie sich einfach mit MT4 und MT5",
    API_Driven_Technology_free_from_manual_errors:
      "API-gesteuerte Technologie, frei von manuellen Fehlern",
    All_rounder_for_all_types_of_Traders:
      "Allrounder für alle Arten von Tradern",
    Autochartist_Volatility_Analysis: "Autochartist Volatilitätsanalyse",
    Autochartist_Volatility_Analysis_p1:
      "Erstellen Sie Ihre Handelsstrategie auf der Grundlage von Fakten.",
    Autochartist_Volatility_Analysis_p2:
      "Kennen Sie den besten Zeitpunkt für den Handel mit einem Instrument, indem Sie sich über die volatilsten und die am wenigsten volatilen Zeiten des Tages informieren.",
    Autochartist_Volatility_Analysis_p3:
      "Mit diesem Tool erhalten Sie folgende Informationen",
    Autochartist_Volatility_Analysis_sub_p1:
      "Erwartete Preisspannen in verschiedenen Zeiträumen",
    Autochartist_Volatility_Analysis_sub_p2:
      "Erwartete Kursbewegung nach Stunden des Tages",
    Autochartist_Volatility_Analysis_sub_p3:
      "Erwartete Kursentwicklung nach Wochentag",
    Know_more_here: "Erfahren Sie hier mehr",
    AutochartistRiskCalculator: "Autochartist Risiko-Rechner",
    AutochartistRiskCalculatorP1: "Messen Sie Ihr Risiko, bevor Sie handeln.",
    AutochartistRiskCalculatorP2:
      "Jetzt können Sie immer wissen, welches Handelsvolumen für Sie ideal ist und dabei Ihre Risikobereitschaft im Auge behalten.",
    AutochartistRiskCalculatorP3:
      "Dieses Tool zeigt Ihnen die zu erwartenden Preisbewegungsspannen",
    AutochartistRiskCalculatorSubP1:
      "Legen Sie das gewünschte Einstiegsniveau und das Stop-Loss-Niveau fest.",
    AutochartistRiskCalculatorSubP2:
      "Geben Sie den Geldbetrag ein, den Sie für den Handel zu riskieren bereit sind",
    AutochartistRiskCalculatorSubP3:
      "Der Rechner sagt Ihnen, wie groß die Position sein sollte.",
    CapsOpenLiveAccount: "LIVE-KONTO ERÖFFNEN",
    CapsOpenDemoAccount: "DEMO-KONTO ERÖFFNEN",
  },
  cryptoCurrency: {
    innerPages: {
      forex: "Forex",
      indices: "Indizes",
      commodities: "Commodities",
      stocks: "Aktien",
      crypto: "Kryptowährungen",
    },
    title: "KRYPTOWÄHRUNGEN",
    heading:
      "Handeln Sie die stärksten Kryptowährungen auf unseren Handelsplattformen",
    min: "min .",
    tradeSize: "Handel Größe",
    execution: "Ausführung",
    paris: "Paare",
    leverage: "Hebelwirkung",
    upTo: "Bis zu",
    contract: "Kryptowährungen Vertrag",
    specification: "Spezifikationen",
    pTag: "Für Kunden, die als Professional eingestuft sind, können flexiblere Handelsbedingungen (höhere Hebelwirkung) gelten. Bitte loggen Sie sich in Ihr Konto ein und prüfen Sie, ob Sie als professioneller Kunde eingestuft werden können, oder schreiben Sie uns an",
    email: "support{'@'}aaafx.com",
    table: {
      heading: {
        instrument: "Instrument",
        bid: "Angebot",
        ask: "Fragen Sie",
        spread: "Streuen Sie",
        contractSize: "Vertragsgröße",
        tradeSize: "Min. Handelsgröße",
        tickValue: "Tick-Wert",
        tradingHours: "Handelszeiten",
      },
    },
    trading: "Was ist der Handel mit Kryptowährungen?",
    pTag1:
      "Kryptowährungen sind im Wesentlichen digitale Vermögenswerte, die durch Kryptographie gesichert sind und sich über ein dezentrales elektronisches Netzwerk bewegen. Diese Vermögenswerte sind nicht durch eine Ware gedeckt und nicht in eine Ware umwandelbar. Sie funktionieren über ein öffentliches Hauptbuch, das auf der Blockchain-Technologie basiert. Bitcoin, das 2009 auf den Markt kam, ist die erste dezentrale Kryptowährung. Seitdem wurden viele andere Kryptowährungen geschaffen. Diese Münzen haben die Finanzmärkte grundlegend verändert.",
    howItWork: "Wie funktioniert das?",
    pTag2:
      "Die traditionellen Fiat-Währungen werden im Allgemeinen von den wirtschaftlichen und politischen Ereignissen auf der ganzen Welt beeinflusst. Da Kryptowährungen jedoch nicht an ein bestimmtes Land gebunden und in der Regel dezentralisiert sind, tendieren ihre Preise dazu, sich unabhängig zu bewegen. Sie sind eine hochgradig volatile Klasse von Vermögenswerten, weshalb Händler das Risiko abwägen müssen, bevor sie mit ihnen handeln. Wir bieten CFDs auf Kryptowährungen an, was bedeutet, dass Sie einfach mit Kryptowährungen handeln können, ohne sie besitzen zu müssen. Die Gewinne und Verluste, die sich aus den Preisunterschieden ergeben, werden einfach auf Ihrem Konto verbucht. Diese Instrumente erscheinen als Paar, das gegen den USD notiert. Zum Beispiel BTCUSD. Der Preis dieses Paares gibt an, wie viele USD für 1 BTC benötigt werden.",
    account: "Konto",
    types: "Typen",
    ecn: "ECN",
    plus: "plus",
    zulu: "zulu",
    deposit: "Einzahlung",
    commission: "Kommission",
    compare: "Kontotypen vergleichen",
    ourOnline: "Unser Online",
    tradingText: "Handel",
    platform: "Plattformen",
    desktop: "Desktop",
    webTrade: "Web Trader",
    android: "Android",
    ios: "iOS",
    learn: "MEHR LERNEN",
    negative: "Negativer Saldo",
    protection: "Schutz",
    pSubTag: "Zuverlässiger Schutz Ihrer Gelder auf AAAFx-Konten",
    pTag3:
      "Wir sind immer bestrebt, im besten Interesse unserer Kunden zu arbeiten. Wenn Ihr Konto in volatilen Zeiten ins Minus gerät, halten wir Ihnen den Rücken frei! Wir setzen Ihren negativen Saldo auf Null zurück, so dass Sie keinen zusätzlichen Verlust erleiden. Sie können einzahlen und den Handel wieder aufnehmen. Sie können also nicht mehr verlieren als das, was Sie eingezahlt haben.",
    live: "LIVE-KONTO ERÖFFNEN",
    demo: "DEMO-KONTO ERÖFFNEN",
  },
  ib: {
    whiteLabel: "Weißes Etikett",
    pamm: "PAMM/MAM",
    title: "Einführender Broker",
    heading: "Erschließen Sie eine dauerhafte Einkommensquelle für sich selbst",
    h3Tag:
      "Erfolg bedeutet heute, ein starkes Netzwerk aufzubauen. Lassen Sie Ihr Netzwerk daran arbeiten, Geld für Sie zu verdienen, auch wenn Sie schlafen!",
    pTag: "Möchten Sie das Beste aus Ihren Marketingfähigkeiten herausholen? AAAFx hat ein bereicherndes Programm für unsere Kunden entwickelt, mit dem Sie unsere fantastische Plattform bekannt machen und unbegrenzt Geld verdienen können. Laden Sie einfach Händler zu uns ein und verdienen Sie eine Provision, wenn diese handeln!",
    h3Tag1:
      "Verbreiten Sie die Nachricht - Schaffen Sie eine Wirkung in der Handelsgemeinschaft",
    pTag1:
      "Wir bieten hervorragende Handelsbedingungen und Tools für Händler und helfen unseren IB-Partnern, zusammen mit ihren Kunden zu wachsen:",
    ul: {
      li: "Hohe Liquidität für den Handel",
      liTag: "Keine Provisionen auf Forex",
      liTag1: "Rohe Aufstriche",
      liTag2: "Hohe Hebelwirkung bis zu 500X",
      liTag3: "Vertrauenswürdiger und zuverlässiger Makler",
      liTag4: "Zugang zu Trading-Tools wie Auto Chartist",
      liTag5: "Direkter Zugang zu Zulu Trade",
      liTag6: "Modernste Technologie",
    },
    question: {
      ques: "Warum sollten Sie als AAAFx IB mitmachen?",
      point:
        "Die Belohnung für Ihre kluge Arbeit und Ihre Beständigkeit kann enorm sein, wenn Sie unsere Trading-Community weiter ausbauen und ihr helfen, die verschiedenen Funktionen unserer Handelsplattformen zu nutzen. Bei AAAFx bieten wir das am besten angepasste und einfachste IB-Programm. Nicht alle IBs sind gleich. Aber wir haben für jeden etwas zu bieten.",
      point1: "Daher haben wir zwei Kategorien von IB-Programmen erstellt:",
      point2:
        "Standard IB Programm- Sie erhalten sofort 20% unserer Provisionseinnahmen von Ihren Kunden. Dies ist nützlich für IB-Anfänger, die neu anfangen wollen oder ein begrenztes Volumen an Kunden zu uns bringen können.",
      point3:
        "Fortgeschrittenes IB-Programm- Dies ist ein sehr lohnendes und maßgeschneidertes IB-Programm für unsere größeren IBs. Es eignet sich für jemanden mit einem großen Kundenstamm, der ein größeres Volumen einbringen kann.",
      point4:
        "Sie können vom Standard IB Programm zum Advanced IB Programm wechseln, sobald Sie Ihr Netzwerk groß genug gemacht haben.",
    },
    signUp: "Registrieren Sie sich als IB",
    referralLink: "Empfehlungslink teilen",
    clients: "Holen Sie sich Ihre Kunden",
    earn: "Verdienen Sie, während sie handeln",
    benefits: "Weitere Vorteile unseres IB-Programms",
    zero: "Verdienen ohne Investition oder Erfahrung",
    ibCommission: "Wöchentliche IB-Provisionsausschüttungen",
    earning: "Unbegrenztes Verdienstpotenzial",
    customized: "Hochgradig individuelles und lohnendes Advanced IB Programm",
    ultraFast: "Ultraschnelle Abhebungen von IB-Provisionen",
    easyUser: "Einfache Benutzeroberfläche des IB-Portals",
    accountManager: "Engagierter Kundenbetreuer",
    helpful: "Hilfreiches und kostenloses Marketingmaterial",
    h6Tag:
      "Unser fortgeschrittenes IB-Programm ist in hohem Maße anpassbar und bietet ein hohes Einkommenspotenzial. Wenn Sie glauben, dass Sie dieses Potenzial haben, nehmen Sie Kontakt mit uns auf, um mehr zu erfahren. Kontaktieren Sie uns jetzt",
    click: "hier",
    orWrite: "oder schreiben Sie uns an",
    email: "support{'@'}aaafx.com.",
  },
  mt4PageData: {
    MT4: "MT4",
    MetaTrade4: "MetaTrader 4",
    MT5: "MT5",
    ActTrader: "ActTrader",
    ZuluTrade: "ZuluTrade",
    MetaTrade4DescOne:
      "Die MetaTrader 4-Plattform wurde im Jahr 2002 von MetaQuotes entwickelt. Die MT4-Plattform gilt als der Goldstandard unter den zahlreichen Handelsplattformen und wird für den Handel mit Devisen, CFDs, Aktien und verschiedenen beliebten Kryptowährungen verwendet.",
    MetaTrade4DescTwo:
      "Die MT4-Plattform von AAAFx bietet eine benutzerfreundliche Oberfläche, die es den Nutzern ermöglicht, die Funktionen der Plattform mit absoluter Leichtigkeit zu verstehen. Sie passt sich den Anforderungen des Benutzers an und bietet die bestmögliche Lösung, indem sie die Möglichkeit bietet, verschiedene Analysetools anzuwenden, Handelsroboter (Expert Advisors) einzusetzen und Trades von anderen zu kopieren.",
    MetaTrade4DescThree:
      "Verbessern Sie Ihr Handelserlebnis auf einem größeren Bildschirm mit mehr Funktionen und größerem Fokus, indem Sie die MT4-Plattform auf Ihren Desktop herunterladen oder einfach auf unsere webbasierte Plattform zugreifen.",
    Steps_to_download_MT4_Desktop: "Schritte zum Herunterladen von MT4 Desktop",
    Steps_to_download_MT4_Desktop_point1:
      "1. Laden Sie die Plattform über den obigen Link herunter.",
    Steps_to_download_MT4_Desktop_point2: "2. Führen Sie die .exe-Datei aus",
    Steps_to_download_MT4_Desktop_point3:
      '3. Gehen Sie zu Datei> Ein Konto eröffnen".',
    Steps_to_download_MT4_Desktop_point4:
      "4. Klicken Sie auf die Schaltfläche Neuen Broker hinzufügen und geben Sie AAAFX ein. Wählen Sie AAAFX-FX-DEMO für das Demokonto und AAAFX-FX-REAL für das Live-Konto.",
    Steps_to_download_MT4_Desktop_point5:
      "5. Klicken Sie auf die Schaltfläche Scannen. Der Server wird nun hinzugefügt.",
    Steps_to_download_MT4_Desktop_point6:
      '6. Klicken Sie auf Weiter> Aktivieren Sie das Kontrollkästchen "Bestehendes Handelskonto" und geben Sie Ihre Anmelde-ID und Ihr Passwort ein. Klicken Sie auf Fertig stellen.',
    Steps_to_uninstall_MT4_Desktop:
      "Schritte zur Deinstallation von MT4 Desktop",
    Steps_to_uninstall_MT4_Desktop_point1:
      "1. Klicken Sie auf die Schaltfläche Start in Windows",
    Steps_to_uninstall_MT4_Desktop_point2:
      "2. Die MT4-Anwendung wird in die Liste der Programme aufgenommen.",
    Steps_to_uninstall_MT4_Desktop_point3:
      '3. Klicken Sie mit der rechten Maustaste auf den Namen der Anwendung und wählen Sie "Deinstallieren".',
    Steps_to_log_into_Webbased_MT4:
      "Schritte zur Anmeldung beim webbasierten MT4",
    Steps_to_log_into_Webbased_MT4_point1:
      '1. Gehen Sie im Web-Trader auf die Option "Datei" in der Menüleiste und wählen Sie "Anmeldung zum Handelskonto".',
    Steps_to_log_into_Webbased_MT4_point2:
      "2. Geben Sie die ID und das Passwort für Ihr Handelskonto ein.",
    Steps_to_log_into_Webbased_MT4_point3:
      '3. Wählen Sie als Server "AAAFX-FX-REAL" für das Live-Konto und "AAAFX-FX-DEMO" für das Demo-Konto',
    Steps_to_log_into_Webbased_MT4_point4:
      '4. Wählen Sie dann die Plattform MT4 und klicken Sie auf "OK".',
    AAAFx_mobile_trading_application_description:
      "Nehmen Sie Ihre Handelseuphorie überall hin mit, mit allen Handelswerkzeugen und Indikatoren, die für die mobile Handelsanwendung von AAAFx verfügbar sind.",
    Steps_to_download_MT4_Android: "Schritte zum Herunterladen von MT4 Android",
    Steps_to_download_MT4_Android_point1:
      "1. Laden Sie die Anwendung über den obigen Link herunter.",
    Steps_to_download_MT4_Android_point2:
      '2. Klicken Sie auf die drei horizontalen Linien im Menü und gehen Sie zu "Konten verwalten"/ "Erste Schritte".',
    Steps_to_download_MT4_Android_point3:
      '3. Klicken Sie auf das "+"-Zeichen in der oberen rechten Ecke.',
    Steps_to_download_MT4_Android_point4:
      '4. Wählen Sie "Bei einem bestehenden Konto anmelden".',
    Steps_to_download_MT4_Android_point5:
      '5. Wählen Sie unter "Finden Sie Ihren Broker" AAAFX-FX-DEMO für das Demokonto und AAAFX-FX-REAL für das Live-Konto. Geben Sie nun Ihre Login-ID und Ihr Passwort ein und klicken Sie auf Login.',
    Steps_to_uninstall_MT4_Android:
      "Schritte zur Deinstallation von MT4 Android",
    Steps_to_uninstall_MT4_Android_point1:
      "1. Gehen Sie im Menü zu Einstellungen > Anwendungen > Anwendungen verwalten",
    Steps_to_uninstall_MT4_Android_point2:
      "2. Suchen Sie dort nach MT4 und tippen Sie auf seinen Namen.",
    Steps_to_uninstall_MT4_Android_point3:
      "3. Tippen Sie auf 'Deinstallieren'.",
    Steps_to_download_MT4_iOS: "Schritte zum Herunterladen von MT4 iOS",
    Steps_to_download_MT4_iOS_point1:
      "1. Laden Sie die Anwendung über den obigen Link herunter.",
    Steps_to_download_MT4_iOS_point2:
      '2. Klicken Sie auf "Einstellungen" und gehen Sie zur Option "Neues Konto",',
    Steps_to_download_MT4_iOS_point3:
      '3. Klicken Sie dann auf "Bei einem bestehenden Konto anmelden".',
    Steps_to_download_MT4_iOS_point4:
      '4. Geben Sie unter Broker suchen "AAAFX" ein.',
    Steps_to_download_MT4_iOS_point5:
      "5. Wählen Sie AAAFX-FX-DEMO für das Demokonto und AAAFX-FX-REAL für das Live-Konto.",
    Steps_to_download_MT4_iOS_point6:
      '6. Geben Sie Ihre Login-ID und Ihr Passwort ein und klicken Sie auf "Anmelden".',
    Steps_to_uninstall_MT4_iOS: "Schritte zur Deinstallation von MT4 iOS",
    Steps_to_uninstall_MT4_iOS_point1:
      "1. Drücken Sie lange auf das MT4-Anwendungssymbol, bis alle Symbole auf Ihrem Bildschirm zu wackeln beginnen.",
    Steps_to_uninstall_MT4_iOS_point2:
      "2. Klicken Sie auf das 'x' in der oberen linken Ecke des Symbols für die MT4-Anwendung.",
    take_trading_experience_to_next_level:
      "Bringen Sie Ihr Handelserlebnis auf der MT4-Plattform von AAAFx mit den folgenden Funktionen auf die nächste Stufe",
    Why_AAAFxs_MT4: "Warum MT4 von AAAFx?",
    Why_AAAFxs_MT4_point1:
      "Assoziiert mit der größten Handelsgemeinschaft von MQL",
    Why_AAAFxs_MT4_point2:
      "Mehr als 20 grafische Objekte für eine gründliche Analyse",
    Why_AAAFxs_MT4_point3: "Marktpreis in Echtzeit",
    Why_AAAFxs_MT4_point4: "Einfach zu verstehende Schnittstelle",
    Why_AAAFxs_MT4_point5:
      "Kompatibel mit Windows, iPhone, Android oder handeln Sie einfach direkt über das Internet",
    Why_AAAFxs_MT4_point6:
      "Gebrauchsfertige Skripte, die einen automatisierten Handel ermöglichen",
    Why_AAAFxs_MT4_point7:
      "1000+ kostenlose und herunterladbare Indikatoren/EAs, die von MQL4 angeboten werden",
    Why_AAAFxs_MT4_point8:
      "Schnellste Ausführungsgeschwindigkeit mit mehreren Servern in der ganzen Welt",
    Why_AAAFxs_MT4_point9:
      "Über 70 Forex-Währungspaare, globale Indizes und Rohstoffe zum Handeln verfügbar",
    Why_AAAFxs_MT4_point10:
      "Marktausführung und 4 Arten von schwebenden Aufträgen verfügbar",
    capsOpenLiveAccount: "LIVE-KONTO ERÖFFNEN",
    capsOpenDemoAccount: "DEMO-KONTO ERÖFFNEN",
  },
  mt5PageData: {
    MT4: "MT4",
    MetaTrade5: "MetaTrader 5",
    MT5: "MT5",
    ActTrader: "ActTrader",
    ZuluTrade: "ZuluTrade",
    MetaTrade5DescOne:
      "Die MT5-Plattform wurde 2010 veröffentlicht und bietet eine schnellere Verarbeitungstechnologie als je zuvor sowie zusätzliche Layouts.",
    MetaTrade5DescTwo:
      "Die MT5-Plattform von AAAFx bietet eine umfangreiche Liste von Handelsinstrumenten, darunter auch Cryptocurrency-CFDs, die der fortschrittlichen Plattform helfen, ihren futuristischen Ausblick zu erfüllen.",
    download_mt5_preferred_device:
      "Auf einem größeren Bildschirm ist es immer besser. Laden Sie unsere MT5-Plattform auf Ihr bevorzugtes Gerät herunter.",
    Steps_to_download_MT5_Desktop: "Schritte zum Herunterladen von MT5 Desktop",
    Steps_to_download_MT5_Desktop_point1:
      "1. Laden Sie die Plattform über den obigen Link herunter.",
    Steps_to_download_MT5_Desktop_point2: "2. Führen Sie die .exe-Datei aus",
    Steps_to_download_MT5_Desktop_point3:
      '3. Gehen Sie zu Datei> Ein Konto eröffnen".',
    Steps_to_download_MT5_Desktop_point4:
      "4. Geben Sie AAAFX und in 'Neuen Broker hinzufügen' ein und klicken Sie auf 'Ihren Broker finden'.",
    Steps_to_download_MT5_Desktop_point5:
      '5. Wählen Sie "AAAFX" und klicken Sie auf "Weiter".',
    Steps_to_download_MT5_Desktop_point6:
      '6. Klicken Sie auf "Mit einem bestehenden Handelskonto verbinden" und geben Sie Ihre Anmeldedaten ein',
    Steps_to_download_MT5_Desktop_point7:
      "7. Um sich bei einem Live-Konto anzumelden, wählen Sie den Servernamen 'AAAFX-FX-REAL' und 'AAAFX-FX-DEMO' für das Demo-Konto aus dem Dropdown-Menü und klicken Sie auf \"Fertig stellen\".",
    Steps_to_uninstall_MT5_Desktop:
      "Schritte zur Deinstallation von MT5 Desktop",
    Steps_to_uninstall_MT5_Desktop_point1:
      "1. Klicken Sie auf die Schaltfläche Start in Windows",
    Steps_to_uninstall_MT5_Desktop_point2:
      "2. Die MT5-Anwendung wird in die Liste der Programme aufgenommen.",
    Steps_to_uninstall_MT5_Desktop_point3:
      '3. Klicken Sie mit der rechten Maustaste auf den Namen der Anwendung und wählen Sie "Deinstallieren".',
    Steps_to_log_into_Webbased_MT5:
      "Schritte zur Anmeldung beim webbasierten MT5",
    Steps_to_log_into_Webbased_MT5_point1:
      '1. Gehen Sie im Web-Trader auf die Option "Datei" in der Menüleiste und wählen Sie "Anmeldung zum Handelskonto".',
    Steps_to_log_into_Webbased_MT5_point2:
      "2. Geben Sie die ID und das Passwort für Ihr Handelskonto ein.",
    Steps_to_log_into_Webbased_MT5_point3:
      '3. Wählen Sie den Server "AAAFX-FX-REAL " für das Live-Konto und "AAAFX-FX-DEMO" für das Demo-Konto',
    Steps_to_log_into_Webbased_MT5_point4:
      '4. Wählen Sie dann die Plattform MT5 UND klicken Sie auf "OK".',
    AAAFx_mobile_trading_application:
      "Nehmen Sie Ihre Handelseuphorie überall hin mit, mit allen Handelswerkzeugen und Indikatoren, die für die mobile Handelsanwendung von AAAFx verfügbar sind.",
    Steps_to_download_MT5_Android: "Schritte zum Herunterladen von MT5 Android",
    Steps_to_download_MT5_Android_point1:
      "1. Laden Sie die Anwendung über den obigen Link herunter.",
    Steps_to_download_MT5_Android_point2:
      '2. Klicken Sie auf die drei horizontalen Linien im Menü und gehen Sie zu "Konten verwalten"/ "Erste Schritte".',
    Steps_to_download_MT5_Android_point3:
      '3. Klicken Sie auf das "+"-Zeichen in der oberen rechten Ecke.',
    Steps_to_download_MT5_Android_point4:
      '4. Wählen Sie unter "Finden Sie Ihren Broker" AAAFX-FX-DEMO für das Demokonto und AAAFX-FX-REAL für das Live-Konto. Geben Sie nun Ihre Login-ID und Ihr Passwort ein und klicken Sie auf Login.',
    Steps_to_uninstall_MT5_Android:
      "Schritte zur Deinstallation von MT5 Android",
    Steps_to_uninstall_MT5_Android_point1:
      "1. Gehen Sie im Menü zu Einstellungen > Anwendungen > Anwendungen verwalten",
    Steps_to_uninstall_MT5_Android_point2:
      "2. Suchen Sie dort nach MT4 und tippen Sie auf seinen Namen.",
    Steps_to_uninstall_MT5_Android_point3:
      "3. Tippen Sie auf 'Deinstallieren'.",
    Steps_to_download_MT5_iOS: "Schritte zum Herunterladen von MT5 iOS",
    Steps_to_download_MT5_iOS_point1:
      "1. Laden Sie die Anwendung über den obigen Link herunter.",
    Steps_to_download_MT5_iOS_point2:
      '2. Klicken Sie auf "Einstellungen" und gehen Sie zur Option "Neues Konto",',
    Steps_to_download_MT5_iOS_point3:
      '3. Klicken Sie dann auf "Bei einem bestehenden Konto anmelden".',
    Steps_to_download_MT5_iOS_point4:
      '4. Geben Sie unter Broker suchen "AAAFX" ein. br 5. Wählen Sie AAAFX-FX-DEMO für das Demokonto und AAAFX-FX-REAL für das Live-Konto.',
    Steps_to_download_MT5_iOS_point5:
      '5. Geben Sie Ihre Login-ID und Ihr Passwort ein und klicken Sie auf "Anmelden".',
    Steps_to_uninstall_MT5_iOS: "Schritte zur Deinstallation von MT5 iOS",
    Steps_to_uninstall_MT5_iOS_point1:
      "1. Drücken Sie lange auf das MT5-Anwendungssymbol, bis alle Symbole auf Ihrem Bildschirm zu wackeln beginnen.",
    Steps_to_uninstall_MT5_iOS_point2:
      "2. Klicken Sie auf das 'x' in der oberen linken Ecke des Symbols für die MT5-Anwendung.",
    trading_experience_the_next_level:
      "Bringen Sie Ihr Handelserlebnis auf der MT5-Plattform von AAAFx mit den folgenden Funktionen auf die nächste Stufe:",
    Why_AAAFxs_MT5: "Warum MT5 von AAAFx?",
    TechnicalAnalysisTools: "Tools für die technische Analyse",
    TechnicalAnalysisToolsPoint1:
      "21 verschiedene Zeitrahmen, damit Sie keine einzige Sekunde der Gelegenheit verlieren",
    TechnicalAnalysisToolsPoint2:
      "30+ integrierte Indikatoren und 40+ technische Objekte",
    TechnicalAnalysisToolsPoint3:
      "Verfügbarkeit von historischen Kartendaten von bis zu 30 Jahren",
    TechnicalAnalysisToolsPoint4:
      "6 Arten von schwebenden Aufträgen, die zusammen mit der Marktausführung verfügbar sind",
    TechnicalAnalysisToolsPoint5:
      "Integrierte und modifizierbare Option für Skripte",
    FundamentalAnalysisTools: "Tools für die Fundamentalanalyse",
    FundamentalAnalysisToolsPoint1:
      "Eingebauter Wirtschaftskalender; hält Sie über jedes unbeständige Ereignis auf dem Laufenden",
    FundamentalAnalysisToolsPoint2:
      "Möglichkeit, den detaillierten Kontoauszug für einen anpassbaren Zeitraum herunterzuladen",
    FundamentalAnalysisToolsPoint3:
      "Markttiefe-Tool, das Ihnen einen Vorteil bei Ihren Handelsstrategien verschafft",
    capsOpenLiveAccount: "LIVE-KONTO ERÖFFNEN",
    capsOpenDemoAccount: "DEMO-KONTO ERÖFFNEN",
  },
  ourServicesPage: {
    heading: "Unsere Server",
    headingDescription: "Robuste Einrichtung für ein makelloses Erlebnis",
    EquinixDataCenters: "Equinix Rechenzentren",
    EquinixDataCentersDescription:
      "In unserem Bestreben, unseren Kunden ein erstklassiges Handelserlebnis zu bieten, verlassen wir uns auf nichts weniger als die beste Technologie und Infrastruktur der Welt. Wir sind bestrebt, die zuverlässigste und schnellste Konnektivität zu bieten, wenn es um die Ausführung von Handelsgeschäften geht, und nutzen daher die fortschrittlichsten globalen Netzwerke und Server-Cluster der Welt.",
    What_are_the_advantages_of_Equinix: "Was sind die Vorteile von Equinix?",
    FastestExecution: "Schnellste Ausführung",
    FastestExecutionDescription:
      "Das Rechenzentrum ist mit unseren großen LPs zusammengelegt und bietet so die schnellstmögliche Verbindung.",
    Low_latency_connection: "Verbindung mit niedriger Latenzzeit",
    Low_latency_connection_description:
      "Die schnelle Verbindung zwischen unseren Handelsservern und den LPs über einen dedizierten Kanal sorgt für die geringstmögliche Latenzzeit.",
    Uninterrupted_trading: "Ununterbrochener Handel",
    Uninterrupted_trading_description:
      "Sofortige und nahtlose Konnektivität, maximale Betriebszeit, so dass Ihr Handelserlebnis einwandfrei ist.",
    Low_slippage: "Geringer Schlupf",
    Low_slippage_description:
      "Eine ultraschnelle Verbindung bedeutet, dass Sie den gewünschten Preis erhalten, ohne dass die Gefahr eines Ausrutschers besteht.",
    Easy_connectivity: "Einfache Konnektivität",
    Easy_connectivity_description:
      "Sie müssen nicht mit der Konnektivität kämpfen, wenn Sie sich mit einem dichten Netzwerk verbinden, das mit modernster Technologie arbeitet",
    What_is_Equinix: "Was ist Equinix?",
    What_is_Equinix_desone:
      "Equinix, Inc. (NASDAQ: EQIX) ist ein amerikanisches multinationales Unternehmen mit Hauptsitz in Redwood City, Kalifornien, das sich auf Internet-Konnektivität und das Management von Rechenzentren spezialisiert hat.",
    What_is_Equinix_destwo:
      "Das Unternehmen ist mit 229 Rechenzentren in 27 Ländern auf fünf Kontinenten führend in der globalen Colocation. Darüber hinaus hat das Unternehmen verschiedene Auszeichnungen für Zuverlässigkeit und Nachhaltigkeit erhalten. Ihre Rechenzentren gelten als Goldstandard und als die zuverlässigste und sicherste digitale Infrastruktur.",
    What_is_the_LD4_Data_Center: "Was ist das LD4 Data Center?",
    What_is_the_LD4_Data_Center_descOne:
      "Das Equinix LD4-Rechenzentrum, in dem die meisten AAAFx-Server untergebracht sind, ist der beste Standort für die Platzierung von Servern in der Forex-Branche, da es eine direkte Direktverbindung mit allen großen globalen Liquiditätsanbietern ermöglicht. Es ist über 14.000 m² groß und verfügt über verschiedene globale Zertifizierungen, wie SOC 1 Typ 1, SOC 2 Typ 2, ISO 27001, PCI DSS, OHSAS 18001, ISO 9001:2015, ISO 22301, ISO 14001:1015 und ISO 50001.",
    What_is_the_LD4_Data_Center_descTwo:
      "Die beschleunigte Verbindung zu unseren Liquiditätsanbietern über das dichte Netzwerk ermöglicht eine ultraschnelle Handelsausführung mit geringsten Latenzzeiten.",
  },
  LoyaltyBonusPageData: {
    heading: "Treueprogramm",
    headingDescription:
      "Je mehr Sie handeln, desto mehr Prämien erhalten Sie automatisch!",
    LoyaltyBonusDescription:
      "Man sagt, Loyalität geht in beide Richtungen. Wir verdienen uns die Loyalität unserer Kunden durch unsere harte Arbeit <br />und Transparenz, und wir glauben daran, sie durch unser kostenloses Rewards-Programm zurückzugeben.0",
    What_is_AAAFx_loyalty_program: "Was ist das AAAFx Treueprogramm?",
    What_is_AAAFx_loyalty_program_descOne:
      "Jeder Handel zählt auf der Reise eines Traders. Jeder Handel, den Sie bei uns tätigen, trägt dazu bei, dass Sie durch unser großartiges Loyalitätsprogramm spannende Renditen erzielen.",
    What_is_AAAFx_loyalty_program_descTwo:
      "Sie müssen sich nicht anmelden. Für alle Ihre Geschäfte erhalten Sie automatisch Reward Points (RPs). Wenn Sie eine bestimmte Anzahl von Reward Points (RP) gesammelt haben, können Sie diese auf verschiedene Weise einlösen, auch in bar!",
    Deposit: "Einzahlung",
    Trade: "Handel",
    Earn_RPs: "RPs verdienen",
    Redeem_RPs: "RPs einlösen",
    loyalty_program_descOne:
      "Unser Treueprogramm eignet sich für alle Arten von",
    loyalty_program_descTwo:
      "Händler. Es gibt zwei Möglichkeiten, voranzukommen",
    loyalty_program_descThree: "durch seine Tier Levels:",
    ExpressRoute: "Express Route",
    ExpressRouteDesc: "Geeignet für Trader, die gerne mehr auf einmal handeln",
    SteadyRoute: "Stetige Route",
    SteadyRouteDesc:
      "Für diejenigen, die über einen längeren Zeitraum hinweg konsequent handeln möchten",
    OurFabulousFourLoyaltyTiers: "Unsere fabelhaften vier Loyalitätsstufen",
    OurFabulousFourLoyaltyTiersDescOne: "Mehr handeln, mehr verdienen",
    OurFabulousFourLoyaltyTiersDescTwo:
      "Mit jeder Stufe, die Sie aufsteigen, wird es größer und besser.",
    OurFabulousFourLoyaltyTiersDescThree:
      "Wir haben zwei sehr einfache und flexible Wege, um sich für die Treueschichten zu qualifizieren. Welchen Weg Sie auch wählen, wir sorgen dafür, dass",
    OurFabulousFourLoyaltyTiersDescFour:
      "verdienen Sie dieselben Treuelevel und dieselben Prämienpunkte. Wenn sich diese beiden Routen überschneiden, werden Sie",
    OurFabulousFourLoyaltyTiersDescFive:
      "die höhere Stufe der beiden Routen zugewiesen.",
    Redeem_your_Reward_Points: "Lösen Sie Ihre Reward Points ein",
    EarnMoreRedeemMore: "Mehr verdienen, mehr einlösen",
    EarnMoreRedeemMoreDesc:
      "Flexible und attraktive Optionen zur Umwandlung Ihrer Reward-Punkte in zahlreiche Vorteile",
    Redeem_your_Reward_Points_point1:
      "Bargeld (Mindestens 500 RPs können gegen Bargeld eingelöst werden)",
    Redeem_your_Reward_Points_point2: "Kostenloser Basic VPS für 3 Monate",
    Redeem_your_Reward_Points_point3: "Kostenloser Premium VPS für 3 Monate",
    Redeem_your_Reward_Points_point4: "SeatsonAX Abonnement für 3 Monate",
    Redeem_your_Reward_Points_point5:
      "Noch schnellere Abhebungen für die nächsten 20 Tage",
    Redeem_your_Reward_Points_point6:
      "Zum nächsten Reward Tier Level aufsteigen",
    Redeem_your_Reward_Points_point7:
      "Iphone/Ipad oder ein ähnliches intelligentes Gerät im Wert von bis zu $1200",
    Redeem_your_Reward_Points_point8: "1 Pip flacher Spread für 10 Handelstage",
    Redeem_your_Reward_Points_point9:
      "10% zusätzliche IB-Provision für den letzten Monat",
    Redeem_your_Reward_Points_point10:
      "$100 extra für jede Empfehlung im letzten Monat",
    Redeem_your_Reward_Points_point11: "1 Monat Provisionsrückerstattung",
    Redeem_your_Reward_Points_point12:
      "Vorauszahlung für die Kaution in Transit",
    Redeem_your_Reward_Points_point13: "Zusätzlicher Bonus auf dem Konto",
    Redeem_your_Reward_Points_point14: "1 Monat Swap-Gebühr Rückerstattung",
    Redeem_your_Reward_Points_point15:
      "10% Extra-Einzahlung (auszahlbar) auf die letzten 5 Einzahlungen",
    Redeem_your_Reward_Points_point16:
      "Rückerstattung von Verlusten bei einem beliebigen Handel in den letzten 20 Handelstagen",
    Redeem_your_Reward_Points_point17:
      "Spread-Erstattung für 10 verlustbringende Trades (in den letzten 20 Tagen)",
    AdditionalCommAmount: "Zusätzliche Komm. Betrag",
    AdvanceDepositAmount: "Betrag der Vorauszahlung",
    Reimbursement_amount: "Erstattungsbetrag",
    readTermsAndConditionHere:
      "Lesen Sie die Bedingungen für unser Treueprogramm",
    BonusAmount: "Bonusbetrag",
    here: "hier",
    two: "2",
    six: "6",
    seven: "7",
    ten: "10",
    sixHundred: "600",
    sevenHundred: "700",
    oneThousand: "1000",
    twoThousand: "2000",
    twoThousandFivehundred: "2500",
    threeThousand: "3000",
    tenThousand: "10,000",
    twentyFiveThousand: "25,000",
    rps: "RPs",
    rpsPerReferral: "RPs pro Überweisung",
    oneusd: "1USD",
  },
  legalDocument: {
    title: "Juristische Dokumente",
    heading: "Wir bei AAAFx sind stolz auf Ehrlichkeit und Transparenz",
    recommend:
      "Wir empfehlen Ihnen, alle notwendigen Informationen zu lesen und zu verstehen.",
    tradingJourney:
      "rechtliche Dokumente, bevor Sie Ihre Handelsreise mit uns beginnen.",
    policy: "Datenschutzbestimmungen",
    view: "ansehen",
    risk: "Risiko-Haftungsausschluss",
    clientAgreement: "Privatkundenvertrag",
    refundPolicy: "Erstattungspolitik",
    executionPolicy: "Ausführungspolitik",
    conflicts: "Richtlinie zu Interessenkonflikten",
    clientAsset: "Kundenvermögen",
    investor: "Anlegerentschädigungssystem",
    h3Tag: "SCHLÜSSELINFORMATIONSDOKUMENT - CFDS ZU ROHSTOFFEN",
    h3Tag1: "SCHLÜSSELINFORMATIONSDOKUMENT-CFDS ÜBER INDIZES",
    h3Tag2: "SCHLÜSSELINFORMATIONSDOKUMENTE-CFD's AUF AKTIEN",
    h3Tag3: "KEY INFORMATION DOCUMENT-CFDS ZU WÄHRUNGSPAAREN",
    h3Tag4: "MiFID ΙΙ Richtlinie Grundlagen",
  },
  pamm: {
    whiteLabel: "Weißes Etikett",
    title: "PAMM/MAM",
    programm: "PAMM/MAM-Programm",
    heading:
      "Eine perfekte Gelegenheit, von der jahrelangen Erfahrung eines erfolgreichen Händlers zu profitieren",
    pTag: "Bei AAAFx bieten wir Händlern die einmalige Gelegenheit, ihre Handelserfahrung der Welt zu präsentieren und durch ihre Follower zu verdienen. Dies gibt auch den Anlegern die Möglichkeit, die besten Händler auszuwählen, die für sie handeln.",
    account: "Was ist ein PAMM oder ein MAM-Konto?",
    pTag1:
      "Dabei handelt es sich um eine Art gepoolter Investmentfonds, bei dem ein Vermögensverwalter mit den Geldern seiner Kunden handelt. Mit einem einzigen Kontozugang kann der Vermögensverwalter Geschäfte in allen Konten seiner Anleger platzieren. Bei einem PAMM-Konto werden die Geschäfte automatisch und sofort im Verhältnis zum relativen Eigenkapital auf den Konten der Anleger zugeteilt.  Beim MAM-Konto kann der Anleger das Risikoniveau wählen, das er eingehen möchte, und dementsprechend über die Handelszuteilung entscheiden.",
    combined: "Warum haben wir unser PAMM und MAM mit ZuluTrade kombiniert?",
    pTag2:
      "ZuluTrade ist ein Synonym für Transparenz. Wenn Sie als Investor Gelder zusammenlegen und einen Händler mit Ihrem Geld handeln lassen, müssen Sie einen klaren Einblick in die historische Performance des Händlers haben, volle Flexibilität bei der Wahl der Handelszuteilungen, die Möglichkeit, mit verschiedenen erfahrenen Händlern zu interagieren, ihnen Fragen zu stellen, von ihnen zu lernen, usw. All das bieten wir Ihnen in Zusammenarbeit mit ZuluTrade.",
    advantage: "Vorteil für PAMM/MAM Manager",
    pTag3:
      "Der PAMM/MAM-Manager kann sein Fachwissen nutzen, um über die Performancegebühr, die er seinen Kunden in Rechnung stellt, ein höheres Einkommen zu erzielen. Unsere PAMM/MAM-Manager erhalten auch volle Flexibilität bei der Festlegung ihrer Bedingungen in Bezug auf die Handelsaktivitäten und die Gewinnverwendung.  Darüber hinaus erhalten die PAMM/MAM-Manager zusätzlich zu den Performance-Gebühren von ihren Kunden auch sehr attraktive IB-Auszahlungen.",
    investor: "Vorteil für Investoren",
    pTag4:
      "Die Anleger können aus einer großen Anzahl von Händlern wählen, die bei ZuluTrade mit AAAFx gelistet sind. Sie können deren Handelsleistung überprüfen und mit ihnen interagieren, bevor sie am PAMM- oder MAM-Programm teilnehmen. Danach können Sie sich einfach entspannen und den Manager seine Arbeit machen lassen. Nachdem Sie auf Ihr Konto eingezahlt und den völlig transparenten Geschäftsbedingungen zugestimmt haben, können Sie die Performance Ihres Kontos kontinuierlich überwachen. Sie haben auch die volle Kontrolle über ihr Konto in Bezug auf Einzahlungen, Abhebungen und die Trennung vom Konto des Managers.",
    aaafxProgramm: "Warum AAAFx PAMM/MAM Programm?",
    ul: {
      liTag: "Zusammenarbeit mit größtem Social Trading Netzwerk",
      liTag1: "Engagierte Kundenbetreuer für Investoren und Manager",
      liTag2:
        "Flexibilität bei der Festlegung von Parametern und Bedingungen für das Konto",
      liTag3: "Sehr niedrige Provisionen mit rohen Spreads",
      liTag4: "Sicherheit der Gelder bei einem vertrauenswürdigen Broker",
      liTag5: "Geringe Investition für den Anfang erforderlich",
      liTag6: "Transparenz für die Anleger - keine versteckten Klauseln",
      liTag7: "Volle Kontrolle der Anleger über Einzahlungen und Abhebungen",
    },
    minimum: "Mindestanforderungen",
    liTag: "Die Gesamteinlage muss mindestens $5.000 betragen.",
    subAccount: "Mindestens 4 Unterkonten erforderlich.",
    eachInvestor:
      "Jeder Anleger sollte die POA unterschreiben und mit allen Bedingungen einverstanden sein.",
    howTo: "Wie kann ich mich anmelden?",
    portal: "Registrieren Sie sich auf dem AAAFx-Portal.",
    build: "Bauen Sie ein Team von Investoren auf.",
    sign: "Lassen Sie die Investoren die Vollmacht unterschreiben.",
    earning: "Fangen Sie an, Gewinne zu erzielen.",
    titleHeading:
      "Unser PAMM/MAM-Programm ist in hohem Maße anpassbar. Setzen Sie sich mit uns in Verbindung, um mehr zu erfahren und um ein",
    contact:
      "PAMM/MAM-Konto. Kontaktieren Sie uns jetzt hier oder schreiben Sie uns an",
    email: "support{'@'}aaafx.com.",
  },
  indicesPages: {
    innerPages: {
      forex: "Forex",
      indices: "Indizes",
      commodities: "Commodities",
      stocks: "Aktien",
      crypto: "Kryptowährungen",
    },
    title: "INDIKTE",
    heading:
      "Vergrößern Sie Ihr Handelskonto durch den Handel mit globalen Indizes",
    min: "min .",
    commission: "Kommission",
    execution: "Ausführung",
    spread: "Streuen Sie",
    upTo: "Bis zu",
    leverage: "Hebelwirkung",
    contract: "Indizes Vertrag",
    specification: "Spezifikationen",
    pTag: "Für Kunden, die als Professional eingestuft sind, können flexiblere Handelsbedingungen (höhere Hebelwirkung) gelten. Bitte loggen Sie sich in Ihr Konto ein und prüfen Sie, ob Sie für die Einstufung als Professioneller Kunde in Frage kommen, oder schreiben Sie uns an",
    email: "support{'@'}aaafx.com",
    instument: "Instrument",
    bid: "Angebot",
    ask: "Fragen Sie",
    size: "Vertragsgröße",
    minTrade: "Min. Handelsgröße",
    tickValue: "Tick-Wert",
    hours: "Handelszeiten",
    trading: "Was ist der Handel mit Indizes CFDs?",
    pTag1:
      "Ein Index stellt ein separates Portfolio dar, in dem verschiedene Unternehmensprofile zusammengefasst sind, was dazu beiträgt, das Risikoprofil eines Kunden abzumildern. Der Handel mit Indizes entlastet den Händler von dem großen Zeitaufwand, der für die Analyse einer einzelnen Aktie erforderlich ist. Es gibt verschiedene Arten von Indizes: geografische Indizes (wie der spanische Index, der deutsche Index, der Hongkong-Index) und Branchenindizes (wie der NASDAQ).",
    how: "Wie funktioniert das?",
    content:
      "Die Volatilität der Aktienindizes wird von politischen und wirtschaftlichen Faktoren bestimmt und nicht nur von der Entwicklung einzelner Aktien. Händler können Gewinne erzielen, indem sie auf die Bewegung von Aktienindizes nach oben oder unten spekulieren. Der Händler muss nicht alle Einzelaktien kaufen, die z.B. im Dow Jones gelistet sind. Er kann einfach den Dow Jones CFD handeln. Der Handel mit Indizes ist eine großartige Möglichkeit, Ihr Portfolio mit einem geringen Kapitaleinsatz zu diversifizieren. Händler stützen sich in der Regel auf die Wirtschaftsleistung in Regionen (bei länderbasierten Indizes) oder auch auf die Gesamtleistung des Sektors (bei sektorbasierten Indizes), um zu beurteilen, ob sie mit dem Index long oder short gehen sollten. Der Index selbst ist nur eine Zahl, aber das Schöne an diesem Produkt ist die Möglichkeit, mit einem viel geringeren Kapitaleinsatz insgesamt in alle Einzelaktien des Index zu investieren.",
    account: "Konto",
    type: "Typen",
    ecn: "ECN",
    plus: "plus",
    zulu: "zulu",
    deposit: "Einzahlung",
    compare: "Kontotypen vergleichen",
    online: "Unser Online",
    tradingText: "Handel",
    platform: "Plattformen",
    desktop: "Desktop",
    webTrade: "Web Trader",
    android: "Android",
    ios: "iOS",
    learn: "MEHR LERNEN",
    negative: "Negativer Saldo",
    protection: "Schutz",
    pSubTag: "Zuverlässiger Schutz Ihrer Gelder auf AAAFx-Konten",
    workTowards:
      "Wir sind immer bestrebt, im besten Interesse unserer Kunden zu arbeiten. Wenn Ihr Konto in volatilen Zeiten ins Minus gerät, halten wir Ihnen den Rücken frei! Wir setzen Ihren negativen Saldo auf Null zurück, so dass Sie keinen zusätzlichen Verlust erleiden. Sie können einzahlen und den Handel wieder aufnehmen. Sie können also nicht mehr verlieren als das, was Sie eingezahlt haben.",
    live: "LIVE-KONTO ERÖFFNEN",
    demo: "DEMO-KONTO ERÖFFNEN",
  },
  economicCalander: {
    title: "Wirtschaftskalender",
    heading: "Globale Ereignisse auf Knopfdruck",
    h5Tag:
      "Unser Wirtschaftskalender informiert Sie über alle wichtigen Finanzereignisse, die die globalen Märkte beeinflussen.",
    news: "Wirtschaftskalender, Forex Nachrichten",
    pTag: "Dies ist ein unverzichtbares Tool für die fundamentale Analyse von Finanzmarkern auf der Grundlage von Wirtschaftsnachrichten. Mehr als 500 Indizes der größten Volkswirtschaften der Welt basieren auf Echtzeitdaten, die aus öffentlichen Quellen stammen.",
    upNext: "Nächstes Mal",
    country: "Land",
    selectAll: "Alle auswählen",
    clear: "Klar",
    myFilter: "Mein Filter",
    default: "Standard",
    text: "Auswirkungen",
    type: {
      all: "Alle",
      medium: "Medium",
      high: "Hoch",
    },
    saveSetting: "Einstellung in meinem Filter speichern",
    apply: "Filter anwenden",
    calander: {
      time: "Zeit",
      country: "Land",
      event: "Veranstaltung",
      actual: "Aktuell",
      forecast: "Vorhersage",
      previous: "Vorherige",
    },
    head: "Titel:",
    category: "Kategorie:",
    desc: "Beschreibung:",
    defi: "Definition:",
  },
  faqs: {
    "Erste Schritte": {
      0: {
        label: "Wie registriere ich mich bei AAAFx und verifiziere mein Konto?",
        content:
          "\n\t\t\t<div class=\"content\">\n\t\t\t<p>Für eine erfolgreiche Überprüfung ist der folgende Prozess zu befolgen:</p>\n\t\t\t<ul>\n\t\t\t<li>Schritt 1: Bitte geben Sie Ihre persönlichen Daten an, einschließlich Name, Telefonnummer, E-Mail-Adresse usw.</li>\n\t\t\t<li>Schritt 2: Nachdem Sie alle persönlichen Daten angegeben haben, laden Sie bitte einen Lichtbildausweis hoch (Führerschein, Reisepass usw.)</li>\n\t\t\t<li>Schritt 3: Zur Sicherheit machen Sie bitte vor Ort ein Selfie und laden es auf der gewünschten Seite hoch.</li>\n\t\t\t<li>Schritt 4: Im nächsten Schritt laden Sie bitte einen aktuellen 'Wohnsitznachweis' (innerhalb von 3 Monaten nach dem aktuellen Datum ausgestellt) hoch, der Ihren vollständigen Namen und Ihre Adresse enthält (eine Rechnung eines Versorgungsunternehmens, einen Kontoauszug usw.)</li>\n\t\t\t<li>Schritt 5: Füllen Sie bitte die Angaben aus und klicken Sie auf Absenden.</li>\n\t\t\t</ul>\n\t\t\t</div>\n\t\t  ",
      },
      1: {
        label: "Aus welchem Land akzeptieren Sie Kunden?",
        content:
          '<div class="content"><p>Wir akzeptieren Kunden aus 27 Ländern des Europäischen Wirtschaftsraums (EU und Island, Schweiz und Liechtenstein). Kunden aus Belgien und dem Vereinigten Königreich werden nicht akzeptiert.</p></div>',
      },
      2: {
        label: "Ist AAAFx reguliert?",
        content:
          '<div class="content"><p>AAAFx ist ein regulierter Finanzdienstleister mit Lizenzen von HCMC, Griechenland und FSCA, Südafrika.</p></div>',
      },
      3: {
        label:
          "Kann ich mich auch ohne E-Mail-Adresse/Telefonnummer anmelden, da ich keine habe?",
        content:
          '<div class="content"><p>Bitte beachten Sie, dass Sie eine E-Mail-Adresse/Telefonnummer benötigen, um sich bei uns anzumelden, da wir E-Mail-Bestätigungen an die registrierte E-Mail-Adresse senden, um die über das Web-Konto gestellte Anfrage zu überprüfen. Wir möchten Sie bitten, auch Ihre Telefonnummer anzugeben, damit wir Sie in dringenden Fällen erreichen können.</p></div>',
      },
      4: {
        label: "Welche Dokumente sind für die Kontoverifizierung erforderlich?",
        content:
          "<div class=\"content\">\n\t\t  <p>Die folgenden Dokumente werden benötigt, um ein Konto bei uns zu eröffnen:</p>\n\t\t  <ul>\n\t\t  <li>1. Einen gültigen Lichtbildausweis (z.B. Reisepass, Führerschein oder einen von einer Behörde ausgestellten Lichtbildausweis)</li>\n\t\t  <li>2. ein aktueller Wohnsitznachweis (innerhalb von 3 Monaten ausgestellt) mit vollständigem Namen und Adresse (z.B. eine Stromrechnung, ein Kontoauszug usw.). Sie können die oben genannten erforderlichen Dokumente in Ihrem Webkonto hochladen oder per E-Mail an support{'@'}aaafx.com senden.</li>\n\t\t  </ul>\n\t\t  </div>",
      },
      5: {
        label:
          "Was ist, wenn ich meine Angaben später ändern muss? Wie aktualisiere ich Informationen in meinem Profil?",
        content:
          "<div class=\"content\">\n\t\t  <p>Sie können die folgenden persönlichen Daten ändern, indem Sie sich in Ihr Webkonto einloggen:</p>\n\t\t  <ul>\n\t\t  <li>Primäres Telefon</li>\n\t\t  <li>Mobiltelefon</li>\n\t\t  <li>Geschlecht</li>\n\t\t  <li>Familienstand</li>\n\t\t  </ul>\n\t\t  <p>Sie können Ihre Bankverbindung auch ändern, indem Sie sich in Ihr Web-Konto einloggen. Wenn Sie andere Angaben aktualisieren möchten, wenden Sie sich bitte an uns im Live Chat oder per E-Mail an support{'@'}aaafx.com.</p>\n\t\t  </div>",
      },
      6: {
        label: "Wie viele Live-Konten kann ich eröffnen?",
        content:
          '<div class="content"><p>Sie können so viele Konten eröffnen, wie Sie möchten. Es gibt keine Einschränkung.</p></div>',
      },
      7: {
        label: "In wie vielen Basiswährungen kann ich ein Konto eröffnen?",
        content:
          '<div class="content"><p>Sie können ein Konto mit einer Basiswährung wie USD, EUR und CHF eröffnen.</p></div>',
      },
      8: {
        label: "Wie hoch ist die Mindesteinlage zur Eröffnung eines Kontos?",
        content:
          '<div class="content"><p>Die Mindesteinlage beträgt nur $100.</p></div>',
      },
      9: {
        label: "Bieten Sie islamische (kostenlose Tausch-) Konten an?",
        content:
          '<div class="content"><p>Ja, Sie können bei der Erstellung der Anfrage den islamischen Kontotyp auswählen.</p></div>',
      },
      10: {
        label: "Erlauben Sie Hedging?",
        content: '<div class="content"><p>Ja, wir erlauben Hedging.</p></div>',
      },
      11: {
        label: "Erlauben Sie Scalping?",
        content: '<div class="content"><p>Ja, wir erlauben Scalping.</p></div>',
      },
    },
    "Ein- und Auszahlungen": {
      0: {
        label: "Wie kann ich eine Einzahlung auf mein Konto vornehmen?",
        content:
          '<div class="content">\n\t\t  <ul>\n\t\t  <li>1. Melden Sie sich bei Ihrem Web-Konto an</li>\n\t\t  <li>2. gehen Sie im linken Bereich auf die Registerkarte Fonds</li>\n\t\t  <li>3. wählen Sie das Handelskonto aus, auf das Sie einzahlen möchten.</li>\n\t\t  <li>4. wählen Sie die bevorzugte Zahlungsmethode, die Sie verwenden möchten.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      1: {
        label: "Wie kann ich Geld zwischen meinen Konten überweisen?",
        content:
          "<div class=\"content\">\n\t\t  <ul>\n\t\t  <li>1. Melden Sie sich bei Ihrem Web-Konto an</li>\n\t\t  <li>2. gehen Sie im linken Bereich zu Konten verwalten</li>\n\t\t  <li>3. klicken Sie auf die Schaltfläche 'Interne Übertragung'.</li>\n\t\t  <li>4. wählen Sie die Konten aus und geben Sie den Betrag ein, den Sie überweisen möchten.</li>\n\t\t  <li>5. Klicken Sie auf Fortfahren. Das Geld wird sofort überwiesen.</li>\n\t\t  </ul>\n\t\t  <p>Bei internen Überweisungen zwischen Konten mit unterschiedlichen Basiswährungen wird der Betrag zu den jeweils gültigen Marktpreisen überwiesen.</p>\n\t\t  </div>",
      },
      2: {
        label: "Wie kann ich Geld von meinem Konto abheben?",
        content:
          '<div class="content">\n\t\t  <ul>\n\t\t  <li>1. Melden Sie sich bei Ihrem Web-Konto an.</li>\n\t\t  <li>2. gehen Sie auf die Registerkarte Fonds im linken Bereich.</li>\n\t\t  <li>3. klicken Sie auf die Registerkarte Abhebungen.</li>\n\t\t  <li>4. wählen Sie die Handels-ID, von der Sie eine Abhebung vornehmen möchten.</li>\n\t\t  <li>5. Geben Sie den abzuhebenden Betrag ein und wählen Sie die Art der Abhebung.</li>\n\t\t  <li>6. klicken Sie auf Transaktion erstellen.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      3: {
        label: "Wie lange dauert es, eine Abhebung zu bearbeiten?",
        content:
          '<div class="content"><p>Alle Auszahlungen unterliegen einer Bearbeitungszeit von 24 Stunden, einschließlich Wochenenden.</p></div>',
      },
      4: {
        label: "Gibt es Gebühren für Einzahlungen/Abhebungen?",
        content:
          '<div class="content"><p>Nein, alle Ein- und Auszahlungen sind von unserer Seite aus kostenlos.</p></div>',
      },
      5: {
        label:
          "Wie lange dauert es, bis die Einzahlung auf meinem Handelskonto erscheint?",
        content:
          '<div class="content">\n\t\t  <ul>\n\t\t  <li><b>Bankkarten: </b>Die Zahlungen werden sofort verarbeitet.</li>\n\t\t  <li><b>Banküberweisung: </b>Banküberweisungen benötigen in der Regel 2-3 Arbeitstage, um uns zu erreichen.</li>\n\t\t  <li><b>eWallets: </b>Die Zahlungen werden sofort verarbeitet. Es dauert in der Regel bis zu 1 Werktag, bis der Betrag auf Ihrem Handelskonto erscheint, wenn die Einzahlung über Skrill initiiert wurde.</li>\n\t\t  <li><b>Kryptowährungen: </b>Krypto-Einzahlungen werden innerhalb von 30-40 Minuten gutgeschrieben.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      6: {
        label: "Werden die Transaktionsgebühren erstattet?",
        content:
          '<div class="content"><p>AAAFx erstattet Ihnen die Transaktionskosten, die Ihnen bei einer Einzahlung bei uns entstehen, bis zu maximal 5% des Transaktionswertes der Einzahlung.</p></div>',
      },
      7: {
        label:
          "Was passiert, wenn ich die Transaktionen nicht in der Basiswährung meines Kontos tätige?",
        content:
          '<div class="content"><p>Wenn Sie eine Einzahlung in einer beliebigen Währung vornehmen, wird das Geld in der Basiswährung Ihres Kontos angezeigt. Die Umrechnung erfolgt zum besten verfügbaren Marktpreis zu diesem Zeitpunkt.</p></div>',
      },
      8: {
        label: "Wann kann ich eine Einzahlungsanfrage stornieren?",
        content:
          "<div class=\"content\"><p>Sie können jede Einzahlungsanforderung stornieren, indem Sie uns eine E-Mail an support{'@'}aaafx.com schicken oder Sie kommen zu unserem Live-Chat-Support und wir werden die Anforderung für Sie stornieren.</p></div>",
      },
      9: {
        label:
          "Gibt es eine Möglichkeit, einen Geldtransfer von einem anderen Broker auf mein Handelskonto zu veranlassen?",
        content:
          '<div class="content"><p>AAAFx unterstützt keine Geldüberweisungen zwischen Brokern. Um einen Geldtransfer einzuleiten, müssen Sie die festgelegten Methoden befolgen.</p></div>',
      },
      10: {
        label:
          "Gibt es irgendwelche Beschränkungen für den Mindest- oder Höchstbetrag einer Auszahlung?",
        content:
          '<div class="content"><p>Der Mindestauszahlungsbetrag beträgt $10. Es gibt keine Obergrenze für Abhebungen.</p></div>',
      },
      11: {
        label:
          "Wie kann man sich über die verfügbaren Finanzierungsmethoden zurückziehen?",
        content:
          '<div class="content">\n\t\t  <ul>\n\t\t  <li>Loggen Sie sich in Ihr Web-Konto ein</li>\n\t\t  <li>Gehen Sie auf die Registerkarte Fonds im linken Bereich</li>\n\t\t  <li>Klicken Sie auf die Registerkarte Abhebungen.</li>\n\t\t  <li>Wählen Sie die Handels-ID, von der Sie eine Abhebung vornehmen möchten.</li>\n\t\t  <li>Geben Sie den abzuhebenden Betrag ein und wählen Sie die Art der Abhebung.</li>\n\t\t  <li>Klicken Sie auf Transaktion erstellen.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      12: {
        label: "Wie lange dauert die Bearbeitung von Abhebungen normalerweise?",
        content:
          '<div class="content"><p>Abhebungen werden normalerweise innerhalb von 1 Werktag bestätigt. Von dem Moment an, in dem sie von Ihrem Konto freigegeben werden, bis sie auf dem von Ihnen angegebenen Bankkonto zur Verfügung stehen, vergehen einige Werktage, abhängig von Faktoren wie dem Zielland, der Verwendung einer zwischengeschalteten Bank usw.</p></div>',
      },
      13: {
        label:
          "Kann ich eine Auszahlung mit einer anderen Methode beantragen als der, die ich ursprünglich für die Einzahlung verwendet habe?",
        content:
          "<div class=\"content\"><p>Wenn die Einzahlungsquelle aus irgendeinem Grund ungültig ist, können Sie uns für die entsprechenden Maßnahmen entweder über den Live-Chat erreichen oder uns eine E-Mail an <a href=\"mailto:contactus{'@'}aaafx.com\">contactus{'@'}aaafx.com.</a></p></div>",
      },
      14: {
        label: "Bearbeiten Sie auch Abhebungen über das Wochenende?",
        content:
          '<div class="content"><p>Ja, wir bearbeiten die Abhebungen über das Wochenende.</p></div>',
      },
      15: {
        label:
          "Gibt es Umstände, unter denen ein Widerruf verweigert werden kann?",
        content:
          '<div class="content">\n\t\t  <p>Ja, ein Rücknahmeantrag kann abgelehnt werden. Mögliche Gründe können sein:</p>\n\t\t  <ul>\n\t\t  <li>Unzureichender freier Spielraum</li>\n\t\t  <li>Unrichtige Angaben zur Abhebung</li>\n\t\t  </ul>\n\t\t  <p>Es kann weitere Gründe geben, die im Falle einer Ablehnung der Abhebung angegeben werden.</p>\n\t\t  </div>',
      },
      16: {
        label: "Wann kann ich einen Abhebungsantrag stornieren?",
        content:
          "<div class=\"content\"><p>Sie können jede Abhebungsanfrage selbst stornieren, indem Sie uns eine E-Mail an <a href=\"mailto:support{'@'}aaafx.com\">support{'@'}aaafx.com</a> schicken oder uns über unseren Live-Chat-Support erreichen und wir werden die Anfrage für Sie stornieren</p></div>",
      },
      17: {
        label: "Gibt es Rücknahmebedingungen?",
        content:
          '<div class="content"><p>Der Abhebungsantrag muss mit derselben Finanzierungsmethode und in derselben Höhe wie die Einzahlung gestellt werden.</p><p>Zum Beispiel: Eine Einzahlung in Höhe von $50 wurde mit einer Bankkarte und $100 mit einer Banküberweisung getätigt. Dann können Sie in diesem Fall $50 mit der Bankkarte und $100 mit der Banküberweisung abheben. Sie können nicht mehr als $50 mit der Bankkarte oder mehr als $100 mit der Banküberweisung abheben.</p><p>Wenn der abgehobene Betrag den Betrag übersteigt, der über einen anderen Kanal als die Banküberweisung eingezahlt wurde (z.B. Sofortige Einzahlung per Kreditkarte oder Moneybookers), wird der verbleibende Abhebungsbetrag per Banküberweisung überwiesen.</p></div>',
      },
      18: {
        label: "Kann ich mein Geld während offener Handelsgeschäfte abheben?",
        content:
          '<div class="content"><p>Sie können nur Beträge bis zur Höhe der freien Marge abheben, die auf Ihren Handelskonten verfügbar ist. In der Regel empfiehlt es sich, eine Abhebung zu beantragen, solange Sie keine offenen Geschäfte haben.</p><p>Sollten Sie jedoch offene Geschäfte haben, müssen Sie prüfen, wie viel Sie wirklich abheben möchten. Falls Sie nicht über eine ausreichende Marge auf Ihrem Handelskonto verfügen, kann der Antrag abgelehnt werden.</p></div>',
      },
      19: {
        label: "Akzeptieren Sie Zahlungen von Dritten?",
        content:
          '<div class="content"><p>Nein, wir akzeptieren keine Zahlungen von Dritten.</p></div>',
      },
      20: {
        label:
          "Wie kann ich Geld auf mein Demokonto einzahlen oder von ihm abheben?",
        content:
          '<div class="content">\n\t\t  <ul>\n\t\t  <li>1. Melden Sie sich bei Ihrem Web-Konto an.</li>\n\t\t  <li>2. gehen Sie auf die Registerkarte Fonds im linken Fensterbereich.</li>\n\t\t  <li>3. wählen Sie Einzahlungen, um Geld auf Ihr Demokonto einzuzahlen.</li>\n\t\t  <li>4. Wählen Sie Abhebungen, um Guthaben vom Demokonto abzubauen.</li>\n\t\t  <li>5. Wählen Sie die Kontonummer und geben Sie dann den Betrag ein, den Sie einzahlen/abheben möchten.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
    },
    "Forex-Handel": {
      0: {
        label: "Wie berechnet man Gewinn/Verlust?",
        content:
          '<div class="content">\n\t\t  <p>Wenn der Wert einer Währung, die Sie gekauft haben, steigt, dann entsteht ein Gewinn. Sie können den Gewinn dieser Transaktion sichern, indem Sie die Währung wieder verkaufen und so die Position schließen. Lassen Sie uns das an einem Beispiel sehen, bei dem wir US-Dollar kaufen und Schweizer Franken verkaufen.</p>>\n\t\t  <p>Der Kurs, der Ihnen genannt wird, ist 1,2755 / 1,2760. Da Sie US-Dollar kaufen, arbeiten Sie mit dem Briefkurs von 1,2760, also dem Kurs, zu dem Händler bereit sind zu verkaufen.</p> <p>\n\t\t  <p>Angenommen, Sie kaufen 1 Standardlot (100.000 Einheiten) zu 1,2760.</p>\n\t\t  <p>Ein paar Stunden später bewegt sich der Kurs auf 1,2780 und Sie beschließen, Ihren Handel zu schließen.</p>\n\t\t  <p>Die neue Notierung für USD/CHF lautet 1,2780 / 1,2785. Da Sie Ihren Handel schließen und ursprünglich gekauft haben, um in den Handel einzusteigen, verkaufen Sie jetzt, um den Handel zu schließen. Sie müssen also den "Geldkurs" von 1,2780 nehmen, also den Kurs, zu dem Händler bereit sind zu kaufen.</p> <p>\n\t\t  <p>Die Differenz zwischen 1,2760 und 1,2780 beträgt 0,0020 oder 20 Pips.</p>\n\t\t  <p>Anhand der Berechnungsformel für den Pip ergibt sich nun (.0001/1.2780) x 100.000 = $7,82 pro Pip x 20 Pips = $156,49 Denken Sie daran, dass Sie beim Betreten oder Verlassen eines Handels der Spanne zwischen Geld- und Briefkurs unterliegen.</p>\n\t\t  <p>Wenn Sie eine Währung kaufen, verwenden Sie den Geld- oder Briefkurs, und wenn Sie verkaufen, verwenden Sie den Geldkurs.</p>\n\t\t  </div>',
      },
      1: {
        label: "Wie sind die Handelszeiten von AAAFx?",
        content:
          '<div class="content"><p>Der Markt öffnet am Sonntag um 22:00 UTC und schließt am Freitag um 22:00 UTC.\n\t\tWenn im Osten Sommerzeit ist, öffnet der Markt am Sonntag um 21:00 UTC und schließt am Freitag um 21:00 UTC.</p></div>',
      },
      2: {
        label:
          "Warum sehe ich, dass die Kurse aktualisiert werden, bevor der Markt öffnet, aber ich kann nicht handeln?",
        content:
          '<div class="content"><p>Auch wenn der Markt am Sonntag um 00.00 Uhr öffnet, können Sie schon vor der Eröffnung leichte Kursschwankungen feststellen. Der Trading Desk leitet die entsprechenden Dienste ein und beginnt mit der Aktualisierung der Kurse, damit diese bei Wiederaufnahme des Handels vorbereitet und verfügbar sind. Die Kurse, die vor der offiziellen Markteröffnung angezeigt werden, können jedoch nicht auf neue Marktaufträge angewendet werden und der Handel kann nicht durchgeführt werden.</p></div>',
      },
      3: {
        label:
          "Welche Auswirkungen hat es auf meine offene Position, wenn sich die Kurse zwischen dem Schlusskurs am Freitag und dem Eröffnungskurs am Sonntag ändern?",
        content:
          '<div class="content"><p>Unter normalen Marktbedingungen können Sie bei der Markteröffnung feststellen, dass der Eröffnungskurs eines Währungspaares sehr nahe an dem am Freitag vor Marktschluss registrierten Kurs liegt. Es gibt jedoch Zeiten, in denen sich die Kurse deutlich nach oben oder unten bewegen können, was sich positiv oder negativ auf Ihre Handelsaktivitäten auswirken kann. Wenn es eine wichtige Nachricht oder wichtige wirtschaftliche Ereignisse gibt, die sich auf den Wert der Währung auswirken, ist die Wahrscheinlichkeit größer, dass es zu Marktlücken kommt.</p><p>Bitte bedenken Sie, dass sich der Kurs gegen Ihre aktuelle Position bewegen kann, so dass Sie feststellen können, dass Ihre Position Verluste macht, obwohl sie bei Marktschluss im Gewinn war. Aus diesem Grund sollten Händler, die über das Wochenende Positionen oder Orders halten, sich über solche ungünstigen Kurslücken im Klaren sein und auf mögliche Verluste vorbereitet sein.</p></div>',
      },
      4: {
        label:
          "Warum habe ich eine Benachrichtigung über einen Margin Call erhalten, als der Markt geschlossen war?",
        content:
          '<div class="content"><p>Die Markteröffnung erfolgt nicht sofort - es handelt sich um einen allmählichen Prozess, der vor 22:00 Uhr UTC beginnt.</p><p>Als Folge davon erhalten wir auch schon vor 22:00 Uhr Kurse, so dass wir vor diesem Zeitpunkt einen Margin Call oder eine Stop Out-Benachrichtigung generieren - allerdings werden die Trades nicht vor der offiziellen Markteröffnung um 22:00 Uhr geschlossen.</p><p>Wenn nach der Markteröffnung die verfügbaren Kurse Ihr Konto immer noch unter das Stop-Out-Niveau bringen, wird der Stop-Out-Mechanismus ausgelöst und die Schließung der Trades eingeleitet.</p></div>',
      },
      5: {
        label:
          "Der Kurs bei Markteröffnung hat mein vorher festgelegtes Stop/Limit für einen Handel überschritten. Was wird mit dem Handel geschehen?",
        content:
          '<div class="content"><p>Wenn der vorher festgelegte Stop-Wert bei Markteröffnung überschritten wird, wird der Handel zum zu diesem Zeitpunkt geltenden Kurs geschlossen. Der Kurs hängt von der zu diesem Zeitpunkt verfügbaren Liquidität ab. Die Ausführung einer Stop-Order bei einem überschrittenen Kurs bedeutet größere Verluste als erwartet.</p><p>Wenn der Markt jedoch zu einem Kurs eröffnet, der den von Ihnen festgelegten Limit-Wert übersteigt, wird der Handel mit einem höheren Gewinn als erwartet geschlossen.</p><p>Sehen wir uns das an einem Beispiel an:</p><p>Sie haben eine KAUFEN EUR/USD-Position zum Preis von 1,1150 mit einem auf 1 gesetzten Limit eröffnet.1350.</p><p>Am Freitag, als der Markt schloss, erreichte der Preis des Paares 1,1250, und am Sonntag, als der Markt öffnete, lag der Preis bei 1,1450.</p><p>Wie Sie sehen können, hat der Preis das Limit von 1,1350 überschritten, so dass der Handel zu diesem neuen aktuellen Preis geschlossen würde, was Ihnen einen Gewinn von 300 Pips statt der festgelegten 200 Pips einbrächte.</p></div>',
      },
      6: {
        label:
          "Wie kann ich meine über das Wochenende getätigten Geschäfte schützen?",
        content:
          '<div class="content"><p>Wenn Sie glauben, dass der Markt über das Wochenende volatil sein könnte und sich die Kurse gegen Ihre offenen Positionen bewegen werden, sollten Sie mit einem Risiko rechnen. Wenn Ihnen diese Handelsstrategie nicht zusagt, empfiehlt es sich, aus einem Handel auszusteigen, indem Sie Ihren aktuellen Gewinn oder Verlust realisieren, bevor der Markt schließt.</p></div>',
      },
      7: {
        label: "Was ist Rollover/Swap?",
        content:
          '<div class="content"><p>AAAFx rollt automatisch alle offenen Positionen um 21:00 UTC weiter. Der Handel wird in der Regel für bis zu 1 Minute während des Rollvorgangs ausgesetzt. Der gezahlte oder verdiente Betrag hängt von der Richtung der offenen Position und dem Zinsunterschied zwischen den beiden beteiligten Währungen ab. Angenommen, die britischen Zinssätze sind deutlich höher als die japanischen, dann erhält ein Händler, der GBP/JPY long ist (d.h. Pfund Sterling hält), beim Rollover Zinsen. Umgekehrt werden einem Händler, der GBP/JPY short ist (d.h. Yen hält), beim Rollover Zinsen belastet.</p><p>Die täglichen Rollover-Kurse von AAAFx und detaillierte Berichte über Rollover-Aktivitäten finden Sie in der Swap-Spalte Ihrer Kontoübersicht auf der MT4-Plattform. Richtwerte für Rollover-Gebühren finden Sie auf unserer Website.</p></div>',
      },
      8: {
        label:
          "Wie hoch sind Ihre Margin-Anforderungen für einen Stop-Out (Margin Call)?",
        content:
          '<div class="content"><p>Das Niveau, bei dem ein Stop-Out auf Ihrem Konto ausgelöst wird, entspricht 70% der Margin-Anforderung, z.B. wenn die Margin-Anforderung 1.000$ beträgt und das Eigenkapital des Kontos 700$ erreicht, werden alle offenen Positionen automatisch geschlossen.</p><p>Bitte beachten Sie, dass AAAFx einen Margin Call ausgibt, wenn Ihr Eigenkapital 100% der Margin-Anforderung erreicht, und Sie per E-Mail benachrichtigt, damit Sie umgehend Maßnahmen ergreifen können, um einen Stop-Out zu verhindern.</p></div>',
      },
      9: {
        label: "Wie kann ich einen Stop Out (Margin Call) vermeiden?",
        content:
          '<div class="content">\n\t\t  <p><b>Ausreichende Marge</b></p>\n\t\t  <p>Um einen Stop-Out zu vermeiden, sollten Sie generell darauf achten, dass Sie immer über eine ausreichende Marge verfügen, um Ihre aktuellen Positionen offen zu halten und einem möglichen Drawdown zu widerstehen. Solange Ihr Eigenkapital mehr als 70% der Marge beträgt, die Sie für Ihre derzeit offenen Positionen verwenden, wird es auf Ihrem Konto nicht zu einem Stop-Out kommen. Bitte beachten Sie, dass Sie Ihr Margin-Level jederzeit von Ihrem MT4 aus überwachen können; je höher der Prozentsatz Ihres Margin-Levels ist, desto unwahrscheinlicher ist ein Stop-Out.</p>\n\t\t  <p>Bitte beachten Sie, dass AAAFx einen Margin Call ausgibt, wenn Ihr Eigenkapital 100% der Marginanforderung erreicht, und Sie per E-Mail benachrichtigt, damit Sie umgehend Maßnahmen ergreifen können, um einen Stop-Out zu verhindern. Außerdem wird bei einem Margin-Level von 100% die Informationszeile im Terminal Ihres MT4-Kontos von grau auf rot umgestellt.</p> <p>\n\t\t  <p><b>Schließen von offenen Positionen</b></p>\n\t\t  <p>Eine schnelle Möglichkeit, Ihr Margin-Level zu erhöhen und das Risiko eines Stop-Out zu verringern, besteht darin, einige Positionen zu schließen, so dass die Margin, die zur Eröffnung dieser Positionen verwendet wurde, wieder in Ihr Eigenkapital fließt.</p>\n\t\t  <p><b>Fondsaufstockung</b></p>\n\t\t  <p>Eine weitere Möglichkeit, ein übermäßiges Engagement zu vermeiden, Ihr Margin-Level zu erhöhen und damit das Risiko eines Stop-Out zu verringern, besteht darin, mehr Geld einzuzahlen. Sie können die Methode der sofortigen Einzahlung nutzen, um sofort Kapital auf Ihr Konto einzuzahlen. Gehen Sie dazu einfach auf die Registerkarte Fonds in Ihrem Kunden-Login-Bereich.</p>>\n\t\t  <p><b>Vermeiden Sie eine Überschuldung</b></p>\n\t\t  <p>Ein weiterer Faktor, der Ihr Konto dem Risiko eines Stop-Out aussetzen kann, ist eine übermäßige Hebelwirkung. Der Einsatz eines größeren Hebels kann Ihre Gewinne potenziell vergrößern, er kann aber auch Verluste vergrößern, die Ihre nutzbare Marge schnell aufzehren werden. Je mehr Leverage Sie einsetzen, desto schneller können sich Ihre Verluste anhäufen.</p>>\n\t\t  <p>Wenn Sie einen übermäßigen Hebel einsetzen, kann die Tatsache, dass Ihr Konto mehr Handelspotenzial hat, leicht dazu führen, dass Sie es überbewerten und dadurch Verluste erleiden. Um zu verdeutlichen, wie dies geschehen kann, betrachten Sie das folgende Beispiel:</p>>\n\t\t  <p>Trader A hat ein Konto mit 500 $ Eigenkapital und verwendet einen Hebel von 200:1, während Trader B ein Konto mit 500 $ und einem Hebel von 100:1 hat.</p>\n\t\t  <p>Händler A kann mit bis zu 100.000 Währungseinheiten handeln und beschließt, 60 % seines Kapitals zu handeln. Er eröffnet also 6 Trades zu je 0,1 Standard-Lots (insgesamt 60.000 $) und verwendet somit 300 $ der Margin (50 $ x 0,6 Lots), wobei 200 $ als freie Margin verbleiben. Jeder Pip, der sich in dieser Handelsgröße bewegt, entspricht $1. Wenn also alle offenen Handelsgeschäfte einen Tiefstand von 290 Pips erreichen (Verlust von ca. 48 Pips pro Handel), wird sein Eigenkapital $210 betragen. In diesem Fall beträgt sein Margin-Level 70 % (210/300), so dass ein Stop-Out erfolgt und alle offenen Trades auf seinem Konto geschlossen werden.</p>>\n\t\t  <p>Trader B hingegen kann mit bis zu 50.000 Währungseinheiten handeln und beschließt, 60% seines Kapitals zu handeln. Da in diesem Fall für ein 0,1 Standard-Lot eine Marge von 100 $ erforderlich ist, reicht die Hälfte des Kapitals für 3 Trades zu je 0,1 Standard-Lot (insgesamt 30.000 $). Wiederum entspricht jeder sich bewegende Pip in dieser Handelsgröße $1. Wenn also alle offenen Trades ein Tief von 48 Pips erreichen, beträgt das Gesamttief 144 und sein Eigenkapital somit 356. Wenn das passiert, beträgt seine Marge 118% (356/300), so dass er nicht Gefahr läuft, einen Stop Out zu setzen.</p>>>\n\t\t  <p>Zusammenfassend lässt sich sagen, dass der Hebel ein Instrument ist, mit dem Sie Ihre Gewinne oder Verluste um die gleiche Größenordnung vergrößern können. Je mehr Hebel Sie auf Ihr Kapital anwenden, desto höher ist das Risiko, das Sie eingehen.</p>\n\t\t  </div>',
      },
      10: {
        label:
          "Warum war mein Handel betroffen, obwohl ich auf dem MT4-Chart sehe, dass der kritische Kurs nicht erreicht wurde?",
        content:
          '<div class="content">\n\t\t  <p>Bitte beachten Sie, dass die MT4-Grafiken nur die Geldkurse und nicht die Briefkurse anzeigen (die Differenz zwischen ihnen ist der Spread).</p>\n\t\t  <p>Bitte beachten Sie auch, dass ein Verkaufshandel zum Geldkurs (Buy) eröffnet und zum Briefkurs (Sell) geschlossen wird, während ein Kaufhandel zum Briefkurs (Sell) eröffnet und zum Geldkurs (Buy) geschlossen wird.</p>\n\t\t  <p>Die genauen Kurse, zu denen Ihr Konto gehandelt wird, können Sie jedoch jederzeit im Fenster Market Watch Ihres MT4 einsehen.</p>\n\t\t  </div>',
      },
      11: {
        label: "Kommt es bei den Aufträgen von AAAFx-Kunden zu Slippage?",
        content:
          '<div class="content">\n\t\t  <p>Slippage bezieht sich auf die Differenz zwischen dem angeforderten Preis einer Order und dem Preis, zu dem die Order tatsächlich ausgeführt wird. Es gibt Marktereignisse/Bedingungen, die eine hohe Volatilität verursachen und damit das Auftreten von Slippage wahrscheinlicher machen, wie z.B. Marktnachrichten oder Ankündigungen.</p>\n\t\t  <p>In solchen Fällen füllt AAAFx die Aufträge zum besten verfügbaren Preis aus, basierend auf dem angeforderten Preis und abhängig von der Menge sowie der Art der Aufträge. Dies kann dazu führen, dass eine Order zu Ergebnissen führt, die günstiger, gleich oder ungünstiger als die ursprünglichen Erwartungen sind, wobei die Ergebnisse als positive Slippage, keine Slippage bzw. negative Slippage bezeichnet werden.</p> <p>\n\t\t  </div>',
      },
      12: {
        label: "Bietet AAAFx einen Schutz vor negativem Saldo?",
        content:
          "<div class=\"content\"><p>AAAFx arbeitet auf der Grundlage eines 'Negativsaldo-Schutzes', was bedeutet, dass der Kunde nicht mehr als sein gesamtes investiertes Kapital (Einlage) verlieren kann. AAAFx stellt nach eigenem Ermessen und in gutem Glauben fest, dass das Auftreten eines solchen negativen Saldos nicht auf ein böswilliges oder missbräuchliches Verhalten des Kunden zurückzuführen ist und nicht absichtlich vom Kunden verursacht wurde.</p></div>",
      },
    },
    "Metalle und CFDs": {
      0: {
        label:
          "Wie hoch ist die Mindestlosgröße für den Handel mit Metallen und CFDs?",
        content:
          '<div class="content"><p>Die Mindestlosgröße für Metalle und CFDs beträgt 1 Standardlos.</p></div>',
      },
      1: {
        label:
          "Was entspricht einem Standardlot Gold (XAU/USD) und Silber (XAG/USD)?",
        content:
          '<div class="content"><p>1 Standard Lot Gold (XAU/USD) entspricht 1 Unze (oz) Gold und 1 Standard Lot Silber (XAG/USD) entspricht 50 Unzen (oz) Silber.</p></div>',
      },
      2: {
        label:
          "Wie hoch ist die erforderliche Marge für den Handel mit CFDs und wie sind die Handelszeiten?",
        content:
          '<div class="content"><p>Sie finden alle Informationen über CFDs im Glossar, Abschnitt CFDs.</p></div>',
      },
      3: {
        label:
          "Wie hoch ist die erforderliche Marge für den Handel mit Gold (XAU/USD) und Silber (XAG/USD) auf meinem AAAFx-Konto?",
        content:
          '<div class="content"><p>Die erforderliche Marge für Gold (XAU/USD) beträgt 100% des aktuellen Preises und der Pip-Wert ist $0,01. Die erforderliche Marge für Silber (XAG/USD) beträgt 200% des aktuellen Preises multipliziert mit der Kontraktgröße (Multiplikator) und der Pip-Wert beträgt $0,5.</p></div>',
      },
      4: {
        label:
          "Warum wurde mein USOilSpot/UKOil/NGAS/BUND/Copper-Handel geschlossen? Der Stop oder das Limit wurde nicht erreicht und ich habe auch keinen Margin Call erhalten.",
        content:
          '<div class="content"><p>Deutsche Anleihen haben Verfallsdaten, wie in der Tabelle im Abschnitt Rohstoffe und Aktien, Verfallsdaten, angegeben. Infolgedessen realisieren die Kunden alle variablen Gewinne und Verluste zu dem Zeitpunkt, an dem die Position aufgrund des Verfalls geschlossen wird.</p></div>',
      },
      5: {
        label:
          "Wie hoch ist die erforderliche Marge für den Handel mit BTC/USD auf meinem AAAFx-Konto?",
        content:
          '<div class="content"><p>Die erforderliche Marge für Bitcoin (BTC/USD) beträgt 1000% des aktuellen Preises und der Pip-Wert ist $0,01.</p></div>',
      },
      6: {
        label: "Wie hoch ist die Provision für einen BTC/USD-Kontrakt?",
        content:
          '<div class="content"><p>Die Provision beträgt 0,0008*Preis im ECN Plus Konto.</p></div>',
      },
      7: {
        label: "Was ist die Mindestkontraktgröße für den Handel mit BTC/USD?",
        content:
          '<div class="content"><p>Es gibt ein Minimum von 1 Kontraktgröße = 1 BTC. Das bedeutet, dass Sie bei einem Kurs von ca. 35.000 $ BTC/USD eine Marge von 7.000 $ benötigen, um den Mindestauftrag zu eröffnen (Kauf oder Verkauf).</p></div>',
      },
      8: {
        label:
          "Wie hoch ist die erforderliche Marge für den Handel mit ETH/USD auf meinem AAAFx-Konto?",
        content:
          '<div class="content"><p>Die erforderliche Marge für Ethereum (ETH/USD) beträgt 1000% des aktuellen Kurses.</p></div>',
      },
      9: {
        label:
          "Wie hoch ist die maximale Anzahl von ETH/USD-Kontrakten pro Kunde?",
        content:
          '<div class="content"><p>Es gibt ein Limit von 1000 Kontrakten des Gesamtengagements (z.B. 500 Kauf und 500 Verkauf = 1K) pro Kunde.</p></div>',
      },
      10: {
        label:
          "Wie hoch ist die erforderliche Marge für den Handel mit LTC/USD auf meinem AAAFx-Konto?",
        content:
          '<div class="content"><p>Die erforderliche Marge für Litecoin (LTC/USD) beträgt 1000% des aktuellen Kurses.</p></div>',
      },
      11: {
        label:
          "Wie hoch ist die maximale Anzahl von LTC/USD-Kontrakten pro Kunde?",
        content:
          '<div class="content"><p>Es gibt ein Limit von 1000 Kontrakten für das Gesamtengagement (z.B. 500 kaufen und 500 verkaufen = 1K) pro Kunde.</p></div>',
      },
    },
    "Grundlegende Forex-Informationen": {
      0: {
        label: "Was ist Forex?",
        content:
          '<div class="content"><p>Der Devisenmarkt (Forex, FX oder Währungsmarkt) ist eine Form des Austauschs für den globalen dezentralen Handel von Währungen. Finanzzentren auf der ganzen Welt fungieren als Ankerpunkte für den Handel zwischen einer Vielzahl von verschiedenen Arten von Käufern und Verkäufern rund um die Uhr, mit Ausnahme der Wochenenden. Der Devisenmarkt bestimmt die relativen Werte der verschiedenen Währungen</p></div>',
      },
      1: {
        label: "Wie groß ist der Devisenmarkt?",
        content:
          '<div class="content"><p>Der Devisenmarkt ist der liquideste Finanzmarkt der Welt. Der durchschnittliche Tagesumsatz an den globalen Devisen- und verwandten Märkten steigt kontinuierlich an. Laut dem 2010 Triennial Central Bank Survey, der von der Bank für Zahlungsausgleich koordiniert wird, lag der durchschnittliche Tagesumsatz im April 2010 bei 3,98 Billionen USD (gegenüber 1,7 Billionen USD im Jahr 1998). Von diesen 3,98 Billionen Dollar entfielen 1,5 Billionen Dollar auf Kassageschäfte und 2,5 Billionen Dollar auf den Handel mit Termingeschäften, Swaps und anderen Derivaten.</p></div>',
      },
      2: {
        label: "Wo befindet sich der Devisenmarkt?",
        content:
          '<div class="content"><p>Es gibt keinen einheitlichen oder zentral abgerechneten Markt für die meisten Geschäfte, und es gibt nur sehr wenig grenzüberschreitende Regulierung. Aufgrund des außerbörslichen Charakters der Devisenmärkte gibt es vielmehr eine Reihe miteinander verbundener Marktplätze, auf denen verschiedene Währungsinstrumente gehandelt werden. Das bedeutet, dass es nicht einen einzigen Wechselkurs gibt, sondern eine Reihe unterschiedlicher Kurse (Preise), je nachdem, welche Bank oder welcher Market Maker handelt und wo er sich befindet.</p></div>',
      },
      3: {
        label: "Wer nimmt an dem Markt teil?",
        content:
          '<div class="content"><p>Im Gegensatz zu einem Aktienmarkt ist der Devisenmarkt in verschiedene Zugangsebenen unterteilt. An der Spitze steht der Interbankenmarkt, der sich aus den größten Geschäftsbanken und Wertpapierhändlern zusammensetzt. Auf den Interbankenmarkt der obersten Stufe entfallen 53% aller Transaktionen. Danach folgen die Transaktionen kleinerer Banken, gefolgt von großen multinationalen Unternehmen, großen Hedgefonds und sogar einigen Retail Market Makern. Der Anteil anderer Marktteilnehmer wie Makler, multinationale Unternehmen, registrierte Händler sowie Privatanleger nimmt jedoch rasch zu.</p></div>',
      },
      4: {
        label: "Was ist ein Lot?",
        content:
          '<div class="content"><p>Ein Lot ist die Standard-Einheitsgröße einer Transaktion. Bei Forex-Währungen entspricht ein Standard-Lot in der Regel 100.000 Einheiten der Basiswährung, 10.000 Einheiten, wenn es sich um ein Mini-Lot handelt, oder 1.000 Einheiten, wenn es sich um ein Micro-Lot handelt.</p></div>',
      },
      5: {
        label: "Wie hoch ist der Spread?",
        content:
          '<div class="content"><p>Die Differenz zwischen dem Geld- und dem Briefkurs wird als Spread bezeichnet. AAAFx bietet mit die niedrigsten Spreads auf dem Devisenmarkt.</p></div>',
      },
      6: {
        label: "Was ist ein Pip/Tick?",
        content:
          '<div class="content"><p>Ein Pip (oder Tick) ist der kleinste Preisschritt, den eine Währung machen kann. Es ist die vierte Ziffer in allen Währungspaaren mit Ausnahme des japanischen Yen (JPY), wo es die zweite Ziffer ist (z.B. 1 Pip = 0,0001 für EUR/USD oder 0,01 für USD/JPY)</p></div>',
      },
      7: {
        label: "Wie kann ich den Wert von 1 Pip berechnen?",
        content:
          '<div class="content">\n\t\t  <p>Um den Wert in der Währung auszudrücken, multiplizieren Sie 1 Pip mit der Lotgröße.</p>\n\t\t  <ul>\n\t\t  <li>EUR/USD pip = 0,0001 X 100.000 = $10,00 (für Standard-Lots)</li>\n\t\t  <li>EUR/USD Pip = 0,0001 X 10.000 = $1,00 (für Mini-Lots)</li>\n\t\t  <li>EUR/USD Pip = 0,0001 X 1.000 = $0,1 (für Mikro-Lots)</li>\n\t\t  <li>GBP/JPY pip = 0,01 X 100.000 = 1000 ¥ (für Standard-Lots)</li>\n\t\t  </ul>\n\t\t  <p>Zur Umrechnung in die Basiswährung dividieren Sie durch den Wechselkurs:</p>\n\t\t  <p>Sagen wir EUR/USD Wechselkurs = 1,4750, dann $10,00 / 1,4750 = 6,78€</p>\n\t\t  <p>Um in die Währung eines Kontos (z.B. USD) umzurechnen, teilen Sie durch den Wechselkurs $/¥:</p>\n\t\t  <p>Wenn $/¥ = 82,12 dann 1000 ¥ / 82,12 = 12,17$</p>\n\t\t  </div>',
      },
      8: {
        label: "Was sind die sieben wichtigsten Währungspaare?",
        content:
          '<div class="content">\n\t\t  <p>Die sieben liquidesten Paare werden gegen den US-Dollar gehandelt, wobei die ersten vier Paare die Hauptwährungen sind, gefolgt von drei Rohstoffpaaren. Die anderen Währungspaare sind besser bekannt als Währungspaare, wobei die beliebtesten Paare diejenigen sind, die den Euro beinhalten: EUR/JPY, EUR/GBP und EUR/CHF.</p>\n\t\t  <p>Die wichtigsten Währungspaare sind:</p>\n\t\t  <ul>\n\t\t  <li>EUR/USD</li>\n\t\t  <li>USD/JPY</li>\n\t\t  <li>USD/CHF</li>\n\t\t  <li>GBP/USD</li>\n\t\t  </ul>\n\t\t  <p>Die Rohstoff-Währungspaare sind:</p>\n\t\t  <ul>\n\t\t  <li>AUD/USD</li>\n\t\t  <li>NZD/USD</li>\n\t\t  <li>USD/CAD</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      9: {
        label: "Was ist Leverage?",
        content:
          '<div class="content"><p>Forex Leverage oder Hebelwirkung bedeutet einfach den prozentualen Geldbetrag, den Sie sich vom Broker leihen dürfen, wenn Sie eine Position eröffnen. Der Leverage bestimmt den Prozentsatz des Nominalwerts eines Handels, der als Margin erforderlich ist. Einfach ausgedrückt, können Sie sich Leverage als einen Kredit vorstellen, der Ihnen zum Kauf von Währungen zur Verfügung gestellt wird.</p></div>',
      },
      10: {
        label: "Was ist eine Marge?",
        content:
          '<div class="content"><p>Typischerweise verlangen die Broker, dass für jede gehandelte Position (Lot) ein bestimmter Betrag des tatsächlichen Kontos zur Verfügung gestellt wird, damit der Leverage freigegeben werden kann. Die Marge ist also der Mindestbetrag, der hinterlegt werden muss, um eine Position zu eröffnen. Die Marge hängt vom Hebel des Kontos ab. Wenn der Hebel beispielsweise 1:30 beträgt, können Sie eine Position handeln, die dreißigmal größer ist als der hinterlegte Betrag. Einfach ausgedrückt können Sie sich die Margin als eine gutgläubige Einlage vorstellen, die für die Freigabe des Kredits (Leverage) erforderlich ist.</p><p>Bei einem Leverage von 100:1 (oder 1% der erforderlichen Position) können Sie beispielsweise eine Position im Wert von $100.000 mit einem Eigenkapital von nur $5.000 handeln. Dies wäre möglich, da der Broker 1.000 $ als Anzahlung oder "Marge" beiseite legt und Ihnen den Rest "leiht". Natürlich werden etwaige Verluste oder Gewinne vom verbleibenden Barguthaben Ihres Kontos abgezogen oder diesem hinzugefügt.</p></div>',
      },
    },
    "Aktien-CFDs": {
      0: {
        label: "Wie funktionieren Aktien-CFDs?",
        content:
          '<div class="content"><p>Mit Aktien (oder Anteilen) von börsennotierten Unternehmen kann spekuliert werden. Online-Broker können Contracts for Difference (CFDs) mit Aktien verschiedener Unternehmen als Basiswerte für diese CFDs anbieten. Wenn ein Aktien-CFD gekauft wird, besitzt der Käufer die Aktie selbst nicht, sondern spekuliert mit dem CFD lediglich auf die Kursentwicklung dieser Aktie.</p><p>Mit Aktien-CFDs (Differenzkontrakten) können Anleger long (kaufen) oder short (verkaufen) gehen. Bei einer Long-Position führt ein Kursanstieg zu einem Gewinn. Eine Short-Position hingegen bringt Geld, wenn der Kurs einer Aktie sinkt.</p></div>',
      },
      1: {
        label: "Was bewegt den Aktienmarkt?",
        content:
          '<div class="content"><p>Der Kurs einer Aktie wird durch Angebot und Nachfrage beeinflusst. Die Kräfte, die Angebot und Nachfrage beeinflussen, sind vielfältig - fundamentale Faktoren (z.B. der Gewinn pro Aktie), die Stimmung unter den Anlegern, technische Faktoren, Nachrichten über das jeweilige Unternehmen oder seine Branche usw.</p></div>',
      },
      2: {
        label:
          "Was ist der Unterschied zwischen dem Handel mit Aktien und Aktien-CFDs?",
        content:
          "<div class=\"content\"><p>Der CFD-Handel ähnelt dem Aktienhandel mit der Ausnahme, dass Sie bei einem Differenzkontrakt den zugrunde liegenden Vermögenswert nicht besitzen, im Gegensatz zu Unternehmensaktien, bei denen Sie dies tun. Beim CFD-Handel kaufen Sie im Wesentlichen einen Vertrag zwischen Ihnen und dem CFD-Anbieter, der je nach Ihrer Position (entweder 'Leerverkauf' oder 'Kauf') einen Einstiegskurs hat, wenn Sie in den Handel einsteigen, und einen Ausstiegskurs, wenn Sie Ihren Handel mit einer gleichwertigen Gegenposition beenden.</p><p>Einer der wichtigsten Unterschiede zwischen dem Handel mit einem CFD und dem Kauf eines Wertpapiers besteht darin, dass Sie eine größere Hebelwirkung nutzen können. Differenzkontrakte werden auf Marge gehandelt, was bedeutet, dass Sie nicht den vollen Marktwert des Kaufs der entsprechenden Aktienposition binden müssen.</p><p>Es gibt auch eine Reihe von wichtigen Unterschieden zwischen dem Handel mit einem Basiswert und einem CFD:</p>\n\t\t  <ul>\n\t\t  <li>CFDs auf Aktien können sowohl long als auch short gehandelt werden, und im Falle eines Leerverkaufs sind Sie nicht verpflichtet, den Basiswert zu liefern.</li>\n\t\t  <li>Der Anleger besitzt den Basiswert, auf den sich der CFD bezieht, nicht, sondern geht eine vertragliche Vereinbarung mit dem CFD-Broker ein, um die Bargelddifferenz zwischen dem Eröffnungs- und dem Schlusskurs des Kontrakts auszutauschen.</li>\n\t\t  <li>Im Gegensatz zum Besitz des zugrundeliegenden Vermögenswerts wird ein CFD auf Marge gehandelt, was bedeutet, dass eine anfängliche Einlage beim CFD-Broker hinterlegt wird, die es dem Anleger ermöglicht, eine Reihe von CFDs entsprechend den Margenberechnungen zu kaufen oder zu verkaufen, die im Allgemeinen eine zusätzliche Hebelwirkung gegenüber dem Aktienkauf selbst ermöglichen.</li>\n\t\t  </ul>\n\t\t  </div>",
      },
      3: {
        label: "Wie hoch ist die Hebelwirkung bei Aktien-CFDs?",
        content:
          '<div class="content"><p>Wie bei allen anderen Aktien-CFDs liegt die Hebelwirkung bei 1:5. Beispiel: Nehmen wir an, Sie kaufen 5 Facebook-CFDs zu $400. Die Margin-Anforderung beträgt 20%, Sie müssten also nur $100 aufwenden, so dass Ihnen mehr Geld für andere Geschäfte zur Verfügung steht.</p></div>',
      },
      4: {
        label: "Welche Aktien-CFDs bieten Sie an?",
        content:
          '<div class="content"><p>Zurzeit bieten wir die beliebtesten Aktien von DOW30 und Nasdaq an, eine vollständige Liste finden Sie <a href="/aktien">hier</a></p></div>',
      },
      5: {
        label: "Wie sind die Handelszeiten für den Handel mit Aktien-CFDs?",
        content:
          '<div class="content"><p>Im Gegensatz zum Devisenmarkt, der grundsätzlich 24 Stunden am Tag, 5 Tage die Woche gehandelt werden kann, sind die weltweiten Aktienmärkte je nach Börse nur etwa 6,5 bis 8,5 Stunden am Tag, 5 Tage die Woche geöffnet. Die Zeiten, zu denen die Aktien der verschiedenen Länder gehandelt werden können, unterscheiden sich auch je nach Zeitzone des jeweiligen Landes.</p><p>Wir unterstützen US-Aktienmarkt-CFDs und folgen daher den regulären Handelszeiten des US-Aktienmarktes (NASDAQ, Dow 30): Werktags 09:30 Uhr bis 16:00 Uhr (Eastern Standard Time - EST).</p><p>Für griechische Aktien-CFDs sind die Handelszeiten: Werktags 08:35-15"00 (UTC)</p></div>',
      },
      6: {
        label: "Was sind Corporate Actions?",
        content:
          '<div class="content"><p>Unternehmensaktionen sind Ereignisse, die von einem börsennotierten Unternehmen initiiert werden und sich in der Regel direkt oder indirekt auf die Aktionäre auswirken und zu wesentlichen Veränderungen der Aktie führen, indem sie den Preis, die Anzahl der gehandelten Aktien oder andere Merkmale (z.B. den Tickernamen) beeinflussen. Zu den Kapitalmaßnahmen gehören Aktiensplits, Dividenden, Fusionen, Übernahmen, Bezugsrechtsemissionen und Spin-offs. All dies sind wichtige Entscheidungen, die in der Regel vom Vorstand des Unternehmens genehmigt und von den Aktionären autorisiert werden müssen. Corporate Actions sind öffentliche Informationen und die entsprechenden Daten sind in verschiedenen Online-Quellen verfügbar.</p></div>',
      },
      7: {
        label: "Was ist eine Aktiendividende?",
        content:
          '<div class="content"><p>Eine Dividende ist eine Vergütung, die Unternehmen an ihre Aktionäre ausschütten und die aus dem Nettogewinn des Unternehmens stammt. Solche Belohnungen können entweder in Form von Bargeld, Bargeldäquivalenten, Aktien usw. erfolgen und werden meist aus dem verbleibenden Anteil des Gewinns gezahlt, sobald die wesentlichen Ausgaben gedeckt sind. Vereinfacht ausgedrückt ist eine Dividende der Anteil eines Investors am Gewinn eines Unternehmens.</p></div>',
      },
      8: {
        label: "Wer ist berechtigt, Dividenden zu erhalten?",
        content:
          '<div class="content"><p>Wenn Sie Aktien-CFDs auf ein Unternehmen kaufen, profitieren Sie in der Regel von allen Dividenden, die das Unternehmen für diese Aktien ausschüttet. Aktien-CFD-Anleger haben Anspruch auf die Dividenden, wenn sie die Aktien bis zum Ex-Dividenden-Termin halten. Je nach Art der Position (Long/Short) erhalten sie die Dividenden am Tag der Zahlung oder werden mit ihnen belastet.</p><p>Wenn Sie einen Aktien-CFD am Ex-Dividenden-Tag oder danach kaufen, erhalten Sie die anstehende Dividendenzahlung nicht. Stattdessen erhält in diesem Fall der Verkäufer die Dividende.</p><p>Bitte beachten Sie, dass die Aktiendividenden auf Ihr Konto überwiesen werden, wobei alle anfallenden Quellensteuern abgezogen werden. Die Zahlung wird auf Ihrem Konto als zusätzliches Bargeld erscheinen.</p></div>',
      },
      9: {
        label: "Was ist ein Aktiensplit?",
        content:
          '<div class="content"><p>Wenn ein Unternehmen einen Aktiensplit ankündigt, erhöht sich die Anzahl der Aktien dieses Unternehmens, aber die Marktkapitalisierung bleibt gleich. Diese Aktion, die eine vorherige Genehmigung durch den Vorstand des Unternehmens erfordert, beinhaltet in der Regel die Ausgabe zusätzlicher Aktien an die bestehenden Aktionäre.</p><p>Angenommen, das Unternehmen ABC hat 4 Millionen Aktien im Umlauf und jede Aktie hat einen Wert von 10 $. In diesem Fall beträgt der gesamte Marktwert des Unternehmens 40 Millionen Dollar (4 Millionen x 10 Dollar/Aktie). Nach einem Aktiensplit im Verhältnis 1:2 verdoppelt sich die Anzahl der Aktien des Unternehmens auf 8 Millionen, während sich der Wert dieser Aktien auf 5 $ halbiert. Der Gesamtmarktwert des Unternehmens bleibt jedoch unverändert bei nur 40 Millionen $ (8 Millionen * 5 $/Aktie).</p></div>',
      },
      10: {
        label: "Bekomme ich Dividenden aus Aktien-CFDs?",
        content:
          '<div class="content"><p>Aktien-CFD-Investoren haben je nach Art der Position (Long/Short) Anspruch auf eine Gutschrift oder Belastung der Dividendenzahlung, wenn sie eine Aktienposition nach dem Ende des Ex-Dividenden-Termins halten. Dividenden sind öffentliche Informationen und die Termine können leicht online gefunden werden.</p></div>',
      },
      11: {
        label: "Wie hoch ist die Mindesthandelsgröße?",
        content:
          '<div class="content"><p>Die Mindesthandelsgröße beträgt 1 Lot pro Auftrag, was einer Aktie entspricht.</p></div>',
      },
      12: {
        label: "Welches ist der offizielle Feiertagskalender für US-Aktien?",
        content:
          '<div class="content"><p>Bitte sehen Sie unten die Tage, an denen der US-Markt offiziell geschlossen ist:</p>\n\t\t  <ul>\n\t\t  <li>Karfreitag</li>\n\t\t  <li>Gedenktag</li>\n\t\t  <li>Unabhängigkeitstag</li>\n\t\t  <li>Tag der Arbeit</li>\n\t\t  <li>Danksagungstag</li>\n\t\t  <li>Weihnachtsfreitag</li>\n\t\t  </ul>\n\t\t  </div>',
      },
    },
    "Handelsplattformen – Allgemein": {
      0: {
        label: "Welche Kurse zeigt der Chart auf der Handelsplattform an?",
        content:
          '<div class="content"><p>Die Charts auf der Handelsplattform zeigen standardmäßig Geldkurse an. Sie können jedoch die Briefkurse anzeigen, indem Sie die folgenden Schritte ausführen:</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie mit der rechten Maustaste irgendwo auf Ihren Chart und wählen Sie Eigenschaften.</li>\n\t\t  <li>Klicken Sie auf die Registerkarte Allgemein und aktivieren Sie das Kontrollkästchen Ask-Linie anzeigen.</li>\n\t\t  <li>Klicken Sie auf die Schaltfläche OK und Sie werden sehen, dass die Ask-Linie im MT4-Chart erscheint.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      1: {
        label:
          "Wie kann ich meinen Kontoauszug auf der Handelsplattform erstellen?",
        content:
          '<div class="content"><p>Folgen Sie bitte den folgenden Schritten, um den Handelskontoauszug von der Handelsplattform herunterzuladen:</p>\n\t\t  <ul>\n\t\t  <li>Loggen Sie sich in Ihr Handelskonto ein</li>\n\t\t  <li>Klicken Sie auf die Registerkarte "Kontoverlauf"</li>\n\t\t  <li>Klicken Sie mit der rechten Maustaste auf den leeren Bereich und klicken Sie dann auf "Alle Historie"</li>\n\t\t  <li>Sobald der gesamte Verlauf angezeigt wird, klicken Sie mit der rechten Maustaste auf "Als detaillierten Bericht speichern"</li>\n\t\t  </ul>\n\t\t  <p>Der Bericht wird auf Ihr Gerät heruntergeladen.</p>\n\t\t  </div>',
      },
      2: {
        label:
          "Wie kann ich mehr Paare/Instrumente im Marktbeobachtungsfenster anzeigen oder ausblenden?",
        content:
          '<div class="content">\n\t\t  <ul>\n\t\t  <li>Klicken Sie mit der rechten Maustaste auf ein beliebiges Instrument</li>\n\t\t  <li>Wählen Sie die Option "Symbole"</li>\n\t\t  </ul>\n\t\t  <p>Wählen Sie aus der Liste der Devisen, Indizes und Rohstoffe das Paar aus, das Sie ein- oder ausblenden möchten.(Shortcut: Strg U)</p>\n\t\t  </div>',
      },
      3: {
        label: "Wie kann ich Details zu einem Handelsinstrument sehen?",
        content:
          '<div class="content"><p>Um die Details zu einem Handelsinstrument zu sehen:</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie mit der rechten Maustaste auf das Handelsinstrument</li>\n\t\t  <li>Wählen Sie "Spezifikation".</li>\n\t\t  </ul>\n\t\t  <p>Sie können im Dialogfeld "Kontraktspezifikation" relevante Informationen wie Spread, Kontraktgröße, Swap-Punkte usw. einsehen</p>\n\t\t  </div>',
      },
      4: {
        label:
          "Wie kann ich den One-Click-Handel auf der Plattform aktivieren?",
        content:
          '<div class="content"><p>Kurzbefehl: Alt T oder Rechtsklick auf den Chart und One-Click-Trading aktivieren</p></div>',
      },
      5: {
        label: "Was ist ein Anleger-Passwort? Warum brauche ich es?",
        content:
          "<div class=\"content\"><p>Das Anleger-Passwort ist ein anderer Name für ein \"Nur-Lese-Passwort\". Das Anleger-Passwort kommt ins Spiel, wenn Sie möchten, dass ein Dritter die Geschäfte auf Ihrem Konto einsehen kann, ohne andere Aktivitäten auszuführen. Um das Anlegerpasswort zu erstellen, melden Sie sich bei Ihrem Handelskonto an. Klicken Sie auf Extras>Optionen>Server und wählen Sie dann Ändern.</p><p>Sie können das Anlegerpasswort auch direkt von Ihrem Webkonto aus ändern/erzeugen. Führen Sie dazu die folgenden Schritte aus:</p><ol><li>Loggen Sie sich in Ihr Web-Konto ein</li><li>Wählen Sie auf der linken Seite 'Konten verwalten'</li><li>Klicken Sie auf 'Trading-Passwort zurücksetzen' > 'Anleger-Passwort'</li></ol></div>",
      },
      6: {
        label:
          "Gibt es eine Möglichkeit, die Zeit auf meinen Karten zu ändern?",
        content:
          '<div class="content"><p>Die Zeitangaben auf den Charts der Handelsplattformen richten sich nach der Serverzeit. Bei AAAFx ist die Serverzeit abhängig von der Sommerzeit auf UTC ODER UTC+1 eingestellt.</p></div>',
      },
      7: {
        label:
          "Kann ich meine Charts auf der Handelsplattform individuell anpassen? Wenn ja, wie?",
        content:
          "<div class=\"content\"><p>Ja, Diagramme können mit den folgenden Schritten angepasst werden:</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie mit der rechten Maustaste auf das Diagrammfenster.</li>\n\t\t  <li>Wählen Sie die Option 'Eigenschaften'</li>\n\t\t  <li>Sie können die Farben des Diagramms nach Ihren Wünschen ändern.</li>\n\t\t  </ul>\n\t\t  <p>Für weitere Änderungen wählen Sie die Registerkarte 'Allgemein'.</p>\n\t\t  </div>",
      },
      8: {
        label:
          "Kann ich mich bei mehr als einem Handelskonto gleichzeitig anmelden?",
        content:
          '<div class="content"><p>Ja, Sie können sich bei mehreren Handelskonten auf einer einzigen Handelsplattform anmelden. Allerdings kann der Handel nur auf einem Handelskonto gleichzeitig stattfinden.</p></div>',
      },
    },
    "Handelsplattformen – MT4": {
      0: {
        label: "Wie melde ich mich bei meinem MT4 Handelskonto an?",
        content:
          '<div class="content"><p>Um sich bei der MT4-Plattform anzumelden, folgen Sie bitte diesen Schritten</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie auf die Option "Datei" in der Menüleiste</li>\n\t\t  <li>Wählen Sie die Option "Zum Handelskonto anmelden"</li>\n\t\t  <li>Geben Sie Ihre Handelskennung und Ihr Passwort ein</li>\n\t\t  <li>Wählen Sie den Servernamen: AAAFx-FX-Demo (für das Demokonto) / AAAFx-FX-Real (für das Realkonto)</li>\n\t\t  <li>Klicken Sie auf Anmelden</li>\n\t\t  </ul>\n\t\t  <p>Sie werden bei Ihrem Handelskonto angemeldet</p>\n\t\t  </div>',
      },
      1: {
        label: "Wie melde ich mich bei einem echten Konto auf MT4 an?",
        content:
          '<div class="content"><p>Um sich in ein echtes Konto auf der MT4-Plattform einzuloggen, folgen Sie bitte diesen Schritten:</p>\n\t\t  <p>Zunächst müssen Sie ein echtes Konto auf dem Portal erstellen. Um ein Live-Konto zu erstellen, folgen Sie bitte diesen Schritten:</p>\n\t\t  <ul>\n\t\t  <li>Registrieren: Klicken Sie auf die Option "Jetzt anmelden" auf dem Portal</li>\n\t\t  <li>Geben Sie Ihre Daten ein: Name, E-Mail-ID, Telefonnummer</li>\n\t\t  <li>Geben Sie den Verifizierungscode ein, den Sie in Ihrer Mail erhalten haben</li>\n\t\t  <li>Wählen Sie die Plattform, den Kontotyp, die Basiswährung des Kontos, die Hebelwirkung und legen Sie schließlich das Passwort für das Konto fest.</li>\n\t\t  <li>Ferner müssen Sie Dokumente hochladen</li>\n\t\t  <li>Nun Geld einzahlen</li>\n\t\t  </ul>\n\t\t  <p>Danach folgen Sie diesen Schritten, um sich bei der Plattform anzumelden:</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie auf die Option "Datei" in der Menüleiste</li>\n\t\t  <li>Wählen Sie "Bei einem Handelskonto anmelden"</li>\n\t\t  <li>Geben Sie Ihre Handels-ID und Ihr Passwort ein</li>\n\t\t  <li>Wählen Sie Server: AAA Fx-FX-Real</li>\n\t\t  <li>Klicken Sie auf \'Anmelden\'</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      2: {
        label: "Wie erstelle ich ein Demokonto bzw. melde mich bei diesem an?",
        content:
          '<div class="content"><p>Um ein Demokonto zu erstellen, folgen Sie bitte diesen Schritten:</p>\n\t\t  <ol>\n\t\t  <li>Melden Sie sich bei Ihrem Web-Konto an.</li>\n\t\t  <li>Gehen Sie zu "Konten verwalten"</li>\n\t\t  <li>Klicken Sie auf "Demokonto erstellen"</li>\n\t\t  <li>Wählen Sie die Handelsplattform, die Hebelwirkung Ihres Kontos, die Basiswährung Ihres Kontos und legen Sie ein Passwort fest.</li>\n\t\t  </ol>\n\t\t  <p>Jetzt ist ein Demokonto für Sie erstellt worden.</p>\n\t\t  </div>',
      },
      3: {
        label: "Wo kann ich meine Provisionen einsehen?",
        content:
          '<div class="content"><p>Um die Provision zu sehen, folgen Sie bitte diesen Schritten:</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie auf die Option "Ansicht" in der Menüleiste</li>\n\t\t  <li>Wählen Sie "Terminal"</li>\n\t\t  <li>Wählen Sie "Handelsbereich"</li>\n\t\t  <li>Klicken Sie mit der rechten Maustaste auf den platzierten Handel</li>\n\t\t  <li>Kommissionen aktivieren</li>\n\t\t  </ul>\n\t\t  <p>Sie können nun die Provisionen in einer separaten Spalte sehen</p>\n\t\t  </div>',
      },
      4: {
        label:
          "Wie kann ich das Passwort meines Handelskontos über die Plattform ändern?",
        content:
          '<div class="content"><p>Folgen Sie diesen Schritten, um das Kontopasswort von MT4 zu ändern:</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie auf "Extras" in der Menüleiste</li>\n\t\t  <li>Wählen Sie "Optionen" > Es erscheint ein Dialogfenster</li>\n\t\t  <li>Neues Passwort eingeben > Okay</li>\n\t\t  </ul>\n\t\t  <p>Oder</p>\n\t\t  <ul>\n\t\t  <li>Im Navigationsfenster unter Konten > Klicken Sie mit der rechten Maustaste auf das Konto, für das Sie das Passwort ändern möchten</li>\n\t\t  <li>Geben Sie das aktuelle Passwort und das neue Passwort ein > Klicken Sie auf Okay</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      5: {
        label:
          "Wie kann ich mein Konto auf der MT4-Plattform löschen/entfernen?",
        content:
          '<div class="content"><p>Um Ihr Konto von der MT4-Plattform zu entfernen oder zu löschen, klicken Sie mit der rechten Maustaste auf das Konto, das Sie entfernen möchten, und wählen Sie einfach die Option "Löschen".</p></div>',
      },
      6: {
        label: "Woher kann ich die MT4-Plattform herunterladen?",
        content:
          '<div class="content"><p>Um die Plattform herunterzuladen, folgen Sie bitte diesen Schritten:</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie auf die Registerkarte "Plattform" im Portal</li>\n\t\t  <li>Klicken Sie auf "Hier herunterladen"</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      7: {
        label: "Darf ich einen EA/ BOT/ Trading Robot verwenden?",
        content:
          '<div class="content"><p>Sie können definitiv einen Expert Advisor in MT4 verwenden. Schauen Sie nach denjenigen, die im Navigationsfenster frei verfügbar sind. Wenn Sie möchten, können Sie auch EAs von der MQL 5 Website kaufen.</p></div>',
      },
      8: {
        label: "Wie kann ich EA in MT4 anhängen?",
        content:
          '<div class="content"><p>Um einen EA anzuhängen, gehen Sie bitte folgendermaßen vor:</p>\n\t\t  <ul>\n\t\t  <li>Navigatorbox öffnen (Strg N)</li>\n\t\t  <li>Expertenratgeber</li>\n\t\t  <li>Klicken Sie mit der rechten Maustaste auf den EA, den Sie verwenden möchten</li>\n\t\t  <li>An den Chart anhängen</li>\n\t\t  </ul>\n\t\t  <p>Und für den Fall, dass Sie einen gekauften EA von der MQL-Website verwenden möchten, gehen Sie bitte wie folgt vor:</p>\n\t\t  <ul>\n\t\t  <li>Gehen Sie auf die Registerkarte "Datei" in der Menüleiste</li>\n\t\t  <li>Klicken Sie auf "Datenordner öffnen"</li>\n\t\t  <li>Öffnen Sie den Ordner "Experten" in der Datei "MQL".</li>\n\t\t  <li>Öffnen Sie den Ordner "Experts" in der "MQL"-Datei.</li>\n\t\t  <li>Öffnen Sie die MT4-Plattform erneut.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      9: {
        label: "Wie richte ich Standard-Charts mit Indikatoren auf MT4 ein?",
        content:
          '<div class="content"><p>Bitte folgen Sie den nachstehenden Schritten:</p>\n\t\t  <p><b>So speichern Sie ein Profil:</b></p>\n\t\t  <p>Wenn Sie alles so positioniert haben, wie Sie es wünschen, gehen Sie bitte zu Datei - Profile und klicken Sie auf "Speichern unter" Geben Sie einen Profilnamen ein und drücken Sie dann auf "Ok"</p>\n\t\t  <p>Um ein gespeichertes Profil zu laden, gehen Sie bitte auf Datei - Profile und wählen Sie das Profil aus der Liste der Profile aus, die angezeigt wird. Das Profil sollte geladen werden.</p>\n\t\t  <p><b>So speichern Sie eine Vorlage:</b></p>\n\t\t  <p>Wenn Sie alles in Ihrem Diagramm so eingerichtet haben, wie Sie es wünschen, gehen Sie bitte auf Diagramme - Vorlage - Vorlage speichern, um die Vorlage zu speichern. Geben Sie einen Namen für die Vorlage ein und drücken Sie auf Speichern.\n\t\t  </p>\n\t\t  </div>',
      },
      10: {
        label: "Kann ich mehrere Handelskonten in MT4 verwenden?",
        content:
          '<div class="content"><p>Ja, Sie können mehrere Handelskonten in MT4 verwenden. Um ein Konto hinzuzufügen, folgen Sie diesen Schritten:</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie mit der rechten Maustaste auf Konten in der Navigationsbox</li>\n\t\t  <li>Wählen Sie "Anmeldung zum Handelskonto"</li>\n\t\t  <li>Geben Sie Ihre Handels-ID und Ihr Passwort ein</li>\n\t\t  </ul>\n\t\t  <p>Ihr Handelskonto wird in MT4 eingefügt.</p>\n\t\t  </div>',
      },
      11: {
        label:
          "Wo kann ich den Verbindungsstatus meines Handelskontos überprüfen?",
        content:
          '<div class="content"><p>Den Verbindungsstatus können Sie in der rechten unteren Ecke unterhalb des Terminalfensters überprüfen.</p><p>Um den Verbindungsstatus sichtbar zu machen, klicken Sie auf "Ansicht" > Statusleiste aktivieren</p></div>',
      },
    },
    "Handelsplattformen – MT5": {
      0: {
        label: "Wie melde ich mich bei meinem MT5 Handelskonto an?",
        content:
          '<div class="content"><p>Um sich bei der MT5-Plattform anzumelden, folgen Sie bitte diesen Schritten</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie auf die Option "Datei" in der Menüleiste</li>\n\t\t  <li>Wählen Sie die Option "Zum Handelskonto anmelden"</li>\n\t\t  <li>Geben Sie Ihre Handelskennung und Ihr Passwort ein</li>\n\t\t  <li>Wählen Sie den Servernamen: AAAFx-FX-Demo (für das Demokonto) / AAAFx-FX-Real (für das Realkonto)</li>\n\t\t  <li>Klicken Sie auf Anmelden</li>\n\t\t  <p>Sie werden bei Ihrem Handelskonto angemeldet</p>\n\t\t  </ul>\n\t\t  </div>',
      },
      1: {
        label: "Wie melde ich mich bei einem echten Konto auf MT5 an?",
        content:
          '<div class="content"><p>Um sich bei einem echten Konto auf der MT5-Plattform anzumelden, folgen Sie bitte diesen Schritten</p>\n\t\t  <p>Zunächst müssen Sie ein echtes Konto auf dem Portal erstellen. Um ein Live-Konto zu erstellen, folgen Sie bitte diesen Schritten:</p>\n\t\t  <ul>\n\t\t  <li>Registrieren: Klicken Sie auf die Option "Jetzt anmelden" auf dem Portal</li>\n\t\t  <li>Geben Sie Ihre Daten ein: Name, E-Mail-ID, Telefonnummer</li>\n\t\t  <li>Geben Sie den Verifizierungscode ein, den Sie in Ihrer Post erhalten haben</li>\n\t\t  <li>Wählen Sie die Kontobasiswährung und die Handelsplattform</li>\n\t\t  <li>Ferner müssen Sie Dokumente hochladen</li>\n\t\t  <li>Nun Geld einzahlen.</li>\n\t\t  </ul>\n\t\t  <p>Danach folgen Sie diesen Schritten, um sich bei der Plattform anzumelden:</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie auf die Option "Datei" in der Menüleiste</li>\n\t\t  <li>Wählen Sie "Bei einem Handelskonto anmelden"</li>\n\t\t  <li>Geben Sie Ihre Handels-ID und Ihr Passwort ein</li>\n\t\t  <li>Wählen Sie Server: AAA Fx-FX-Real</li>\n\t\t  <li>Klicken Sie auf \'Anmelden\'</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      2: {
        label: "Wie erstelle ich ein Demokonto bzw. melde mich bei diesem an?",
        content:
          '<div class="content"><p>Um ein Demokonto zu erstellen, folgen Sie bitte diesen Schritten:</p>\n\t\t  <ol>\n\t\t  <li>Melden Sie sich bei Ihrem Web-Konto an.</li>\n\t\t  <li>Gehen Sie zu "Konten verwalten"</li>\n\t\t  <li>Klicken Sie auf "Demokonto erstellen"</li>\n\t\t  <li>Wählen Sie die Handelsplattform, die Hebelwirkung Ihres Kontos, die Basiswährung Ihres Kontos und legen Sie ein Passwort fest.</li>\n\t\t  </ol>\n\t\t  <p>Jetzt ist ein Demokonto für Sie erstellt worden.</p>\n\t\t  </div>',
      },
      3: {
        label: "Wo kann ich meine Provisionen einsehen?",
        content:
          '<div class="content"><p>Um die Provision zu sehen, folgen Sie bitte diesen Schritten:</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie auf die Option "Ansicht" in der Menüleiste</li>\n\t\t  <li>Wählen Sie "Terminal"</li>\n\t\t  <li>Wählen Sie "Handelsbereich"</li>\n\t\t  <li>Klicken Sie mit der rechten Maustaste auf den platzierten Handel</li>\n\t\t  <li>Kommissionen aktivieren</li>\n\t\t  </ul>\n\t\t  <p>Sie können nun die Provisionen in einer separaten Spalte sehen</p>\n\t\t  </div>',
      },
      4: {
        label:
          "Wie kann ich das Passwort meines Handelskontos über die Plattform ändern?",
        content:
          '<div class="content"><p>Folgen Sie diesen Schritten, um das Kontopasswort von MT5 zu ändern:</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie auf "Extras" in der Menüleiste</li>\n\t\t  <li>Wählen Sie "Optionen" > Es erscheint ein Dialogfenster</li>\n\t\t  <li>Neues Passwort eingeben > Okay</li>\n\t\t  </ul>\n\t\t  <p>Oder</p>\n\t\t  <ul>\n\t\t  <li>Im Navigationsfenster unter Konten > Klicken Sie mit der rechten Maustaste auf das Konto, für das Sie das Passwort ändern möchten</li>\n\t\t  <li>Geben Sie das aktuelle Passwort und das neue Passwort ein > Klicken Sie auf Okay</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      5: {
        label:
          "Wie kann ich mein Konto auf der MT5-Plattform löschen/entfernen?",
        content:
          '<div class="content"><p>Um Ihr Konto von der MT5-Plattform zu entfernen oder zu löschen, klicken Sie mit der rechten Maustaste auf das Konto, das Sie entfernen möchten, und wählen Sie einfach die Option "Löschen".</p></div>',
      },
      6: {
        label: "Woher kann ich die MT5-Plattform herunterladen?",
        content:
          '<div class="content"><p>Um die Plattform herunterzuladen, folgen Sie bitte diesen Schritten:</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie auf die Registerkarte "Plattform" im Portal</li>\n\t\t  <li>Klicken Sie auf "Hier herunterladen"</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      7: {
        label: "Darf ich einen EA/ BOT/ Trading Robot verwenden?",
        content:
          '<div class="content"><p>Sie können definitiv einen Expert Advisor in MT5 verwenden. Schauen Sie nach denjenigen, die im Navigationsfenster frei verfügbar sind. Wenn Sie möchten, können Sie auch EAs von der MQL 5 Website kaufen.</p></div>',
      },
      8: {
        label: "Wie kann ich EA in MT5 anhängen?",
        content:
          '<div class="content"><p>Um einen EA anzuhängen, gehen Sie bitte folgendermaßen vor:</p>\n\t\t  <ul>\n\t\t  <li>Navigatorbox öffnen (Strg N)</li>\n\t\t  <li>Expertenratgeber</li>\n\t\t  <li>Klicken Sie mit der rechten Maustaste auf den EA, den Sie verwenden möchten</li>\n\t\t  <li>An den Chart anhängen</li>\n\t\t  </ul>\n\t\t  <p>Und für den Fall, dass Sie einen gekauften EA von der MQL-Website verwenden möchten, gehen Sie bitte wie folgt vor:</p>\n\t\t  <ul>\n\t\t  <li>Gehen Sie auf die Registerkarte "Datei" in der Menüleiste</li>\n\t\t  <li>Klicken Sie auf "Datenordner öffnen"</li>\n\t\t  <li>Öffnen Sie den Ordner "Experten" in der Datei "MQL".</li>\n\t\t  <li>Öffnen Sie den Ordner "Experts" in der "MQL"-Datei.</li>\n\t\t  <li>Öffnen Sie die MT4-Plattform erneut.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      9: {
        label: "Wie richte ich Standard-Charts mit Indikatoren auf MT5 ein?",
        content:
          '<div class="content"><p>Bitte folgen Sie den nachstehenden Schritten:</p>\n\t\t  <p><b>So speichern Sie ein Profil:</b></p>\n\t\t  <p>Wenn Sie alles so positioniert haben, wie Sie es wünschen, gehen Sie bitte zu Datei - Profile und klicken Sie auf "Speichern unter" Geben Sie einen Profilnamen ein und drücken Sie dann auf "Ok"</p>\n\t\t  <p>Um ein gespeichertes Profil zu laden, gehen Sie bitte auf Datei - Profile und wählen Sie das Profil aus der Liste der Profile aus, die angezeigt wird. Das Profil sollte geladen werden.</p>\n\t\t  <p><b>So speichern Sie eine Vorlage:</b></p>\n\t\t  <p>Wenn Sie alles in Ihrem Diagramm so eingerichtet haben, wie Sie es wünschen, gehen Sie bitte auf Diagramme - Vorlage - Vorlage speichern, um die Vorlage zu speichern. Geben Sie einen Namen für die Vorlage ein und drücken Sie auf Speichern.\n\t\t  </p>\n\t\t  </div>',
      },
      10: {
        label: "Kann ich mehrere Handelskonten in MT5 verwenden?",
        content:
          '<div class="content"><p>Ja, Sie können mehrere Handelskonten in MT5 verwenden. Um ein Konto hinzuzufügen, folgen Sie diesen Schritten:</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie mit der rechten Maustaste auf Konten in der Navigationsbox</li>\n\t\t  <li>Wählen Sie "Anmeldung zum Handelskonto"</li>\n\t\t  <li>Geben Sie Ihre Handels-ID und Ihr Passwort ein</li>\n\t\t  </ul>\n\t\t  <p>Ihr Handelskonto wird in MT5 eingefügt.</p>\n\t\t  </div>',
      },
      11: {
        label:
          "Wo kann ich den Verbindungsstatus meines Handelskontos überprüfen?",
        content:
          '<div class="content"><p>Den Verbindungsstatus können Sie in der rechten unteren Ecke unterhalb des Terminalfensters überprüfen.</p><p>Um den Verbindungsstatus sichtbar zu machen, klicken Sie auf "Ansicht" > Statusleiste aktivieren</p></div>',
      },
    },
    "Handelsplattformen – ActTrader": {
      0: {
        label:
          "Wie melde ich mich bei meinem Handelskonto auf dem ACT auf dem Desktop an?",
        content:
          "<div class=\"content\"><p>Bitte folgen Sie den folgenden Schritten, um sich in Ihr Handelskonto einzuloggen:</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie auf den <a href=\"https://aaafx.com/act-trader\" target=\"_blank\">Link</a>, um die Handelsplattform herunterzuladen.</li>\n\t\t  <li>Ein Setup wird auf Ihr System heruntergeladen. Klicken Sie auf das Setup und die Plattform wird installiert.</li>\n\t\t  <li>Nachdem die Plattform installiert ist, geben Sie den Benutzernamen und das Passwort für das Handelskonto ein.</li>\n\t\t  <li>Wählen Sie den Server - 'Demo' für ein Demokonto und 'Real' für ein Live-Konto.</li>\n\t\t  <li>Klicken Sie auf 'Anmelden'. Sie sind bei Ihrem Konto eingeloggt.</li>\n\t\t  </ul>\n\t\t  </div>",
      },
      1: {
        label:
          "Wie melde ich mich bei meinem Handelskonto im ACT on web trader an?",
        content:
          '<div class="content"><p>Befolgen Sie bitte die folgenden Schritte, um sich bei Ihrem Handelskonto im Webtrader anzumelden:</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie auf den <a href="https://aaafx.com/act-trader" target="_blank">Link</a>, um den Webtrader zu öffnen</li>\n\t\t  <li>Eine neue Registerkarte wird angezeigt.</li>\n\t\t  <li>Geben Sie den Benutzernamen und das Passwort für das Handelskonto ein.</li>\n\t\t  <li>Klicken Sie auf \'Anmelden\'. Sie sind bei Ihrem Konto eingeloggt.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      2: {
        label:
          "Ich weiß nicht, wie ich die ACT-Anwendung auf meinem mobilen Gerät installieren kann. Bitte helfen Sie mir.",
        content:
          "<div class=\"content\"><p>Befolgen Sie bitte die folgenden Schritte, um die Anwendung auf Ihrem mobilen Gerät zu installieren:</p>\n\t\t  <p><b>ANDROID</b></p>\n\t\t  <ul>\n\t\t  <li>Loggen Sie sich auf Ihrem mobilen Gerät in Ihr Kundenportal ein.</li>\n\t\t  <li>Klicken Sie auf den <a href=\"https://aaafx.com/act-trader\" target=\"_blank\">Link</a></li>\n\t\t  <li>Scrollen Sie zum unteren Rand des Fensters und klicken Sie auf 'ACT ANDROID'.</li>\n\t\t  <li>Google Store öffnet sich und eine Anwendung namens 'ActDroid' erscheint.</li>\n\t\t  <li>Klicken Sie auf 'Installieren' und die Anwendung wird auf Ihrem Gerät installiert.</li>\n\t\t  </ul>\n\t\t  <p><b>IOS</b></p>\n\t\t  <ul>\n\t\t  <li>Loggen Sie sich auf Ihrem mobilen Gerät in Ihr Kundenportal ein.</li>\n\t\t  <li>Klicken Sie auf den <a href=\"https://aaafx.com/act-trader\" target=\"_blank\">Link</a></li>\n\t\t  <li>Scrollen Sie zum unteren Rand des Fensters und klicken Sie auf ACT IOS.</li>\n\t\t  <li>Google Store öffnet sich und eine Anwendung namens 'ActPhone' erscheint.</li>\n\t\t  <li>Klicken Sie auf 'Installieren' und die Anwendung wird auf Ihrem Gerät installiert.</li>\n\t\t  </ul>\n\t\t  </div>",
      },
      3: {
        label:
          "Wie melde ich mich mit meinem mobilen Gerät bei meinem Handelskonto an?",
        content:
          "<div class=\"content\"><p>Befolgen Sie bitte die folgenden Schritte, um sich auf Ihrem mobilen Gerät in Ihr Handelskonto einzuloggen:</p>\n\t\t  <p><b>ANDROID</b></p>\n\t\t  <ul>\n\t\t\t<li>Klicken Sie auf die ActDroid Anwendung auf Ihrem Gerät.</li>\n\t\t\t<li>Klicken Sie auf 'Zustimmen' in der Lizenzvereinbarung.</li>\n\t\t\t<li>Geben Sie den Benutzernamen und das Passwort für das Handelskonto ein.</li>\n\t\t\t<li>Wählen Sie unter Kontotyp den Server entsprechend dem Kontotyp - 'AAAFx-FX-Demo' für ein Demokonto und 'AAAFx-FX-Real' für ein Live-Konto.</li>\n\t\t\t<li>Klicken Sie auf 'Anmelden'. Sie sind jetzt bei Ihrem Konto angemeldet.</li>\n\t\t  </ul>\n\t\t  <p><b>IOS</b></p>\n\t\t  <ul>\n\t\t\t<li>Klicken Sie auf die ActPhone Anwendung auf Ihrem Gerät.</li>\n\t\t\t<li>Geben Sie den Benutzernamen und das Passwort für das Handelskonto ein.</li>\n\t\t\t<li>Wählen Sie unter Kontotyp den Server entsprechend dem Kontotyp - 'AAAFx-FX-Demo' für ein Demokonto und 'AAAFx-FX-Real' für ein Live-Konto.</li>\n\t\t\t<li>Klicken Sie auf 'Anmelden'. Sie sind jetzt bei Ihrem Konto angemeldet.</li>\n\t\t  </ul>\n\t\t  </div>",
      },
      4: {
        label: "Wie kann ich eine Bestellung aufgeben?",
        content:
          '<div class="content"><p>Sie können ganz einfach einen Handel abschließen, indem Sie auf die Schaltflächen Verkaufen oder Kaufen unter der Registerkarte Home in der FXVoyager-Symbolleiste klicken.</p><p>Sie können auch direkt aus dem Fenster Dealing Rates, dem Fenster Instrumente oder der Tabelle Dealing Rates eine Market Order erteilen. Klicken Sie einfach mit der linken Maustaste auf den Geld- oder Briefkurs oder mit der rechten Maustaste auf den Kurs und wählen Sie Marktauftrag.</p></div>',
      },
      5: {
        label:
          "Wie kann ich den Stand meines Handelskontos auf der Handelsplattform überprüfen?",
        content:
          "<div class=\"content\"><p>Sie können den Kontostand auf folgende Weise überprüfen:</p>\n\t\t  <ul>\n\t\t  <li>Melden Sie sich bei Ihrem Handelskonto an.</li>\n\t\t  </li>Klicken Sie auf die Registerkarte 'Zusammenfassung'.\n\t\t  </ul>\n\t\t  <p>Alle Kontoinformationen einschließlich des Saldos werden angezeigt.</p>\n\t\t  <p>Oder</p>\n\t\t  <p>Den Kontostand können Sie in der linken unteren Ecke der Plattform überprüfen.</p>\n\t\t  </div>",
      },
      6: {
        label:
          "Kann ich mich auf dem ACT bei mehreren Konten gleichzeitig anmelden?",
        content:
          '<div class="content"><p>Nein, ACT erlaubt es dem Benutzer nicht, sich bei mehreren Handelskonten gleichzeitig anzumelden.</p></div>',
      },
      7: {
        label: "Wie kann ich den Ein-Klick-Handel aktivieren?",
        content:
          '<div class="content">\n\t\t  <ul>\n\t\t  <li>Klicken Sie auf das Symbol der Einstellung in der oberen linken Ecke</li>\n\t\t  <li>Wählen Sie "Haupteinstellung"</li>\n\t\t  <li>Kreuzen Sie "Handel mit einem Klick"</li>\n\t\t  <li>Klicken Sie auf Anwenden</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      8: {
        label: "Kann ich Indikatoren auf meinen Chart anwenden? Wie?",
        content:
          '<div class="content"><p>Befolgen Sie bitte die folgenden Schritte, um Indikatoren auf Ihren Chart anzuwenden:</p>\n\t\t  <ul>\n\t\t  <li>Öffnen Sie den Chart, auf den Sie den Indikator anwenden möchten.</li>\n\t\t  <li>Bewegen Sie den Mauszeiger auf den Chart. Klicken Sie mit der rechten Maustaste auf den Chartbereich.</li>\n\t\t  <li>Wählen Sie \'Indikatoren einrichten\'.</li>\n\t\t  <li>Ein Fenster mit verschiedenen Indikatoren öffnet sich.</li>\n\t\t  <li>Wählen Sie den Indikator und drücken Sie die Vorwärts-Taste " >"</li>\n\t\t  <li>Sie können die Einstellungen des ausgewählten Indikators im Hüllkurvenbereich vor der Anwendung ändern.</li>\n\t\t  <li>Klicken Sie auf "Anwenden" und dann auf "Ok".</li>\n\t\t  </ul>\n\t\t  <p>Sie werden sehen, dass der Indikator auf Ihren Chart angewendet wurde.</p>\n\t\t  </div>',
      },
      9: {
        label: "Wie kann ich einen Indikator aus meinem Chart entfernen?",
        content:
          '<div class="content"><p>Folgen Sie bitte den folgenden Schritten, um Indikatoren in Ihrem Chart zu entfernen:</p>\n\t\t  <ul>\n\t\t  <li>Öffnen Sie den Chart, in dem Sie den Indikator entfernen möchten.</li>\n\t\t  <li>Bewegen Sie den Mauszeiger auf den Chart. Klicken Sie mit der rechten Maustaste auf den Chartbereich.</li>\n\t\t  <li>Wählen Sie \'Indikatoren einrichten\'.</li>\n\t\t  <li>Ein Fenster mit verschiedenen Indikatoren öffnet sich.</li>\n\t\t  <li>Sie können die Liste aller angewandten Indikatoren unter "Aktive Indikatoren" sehen.</li>\n\t\t  <li>Wählen Sie den Indikator aus und drücken Sie die Umschalttaste " <"</li>\n\t\t  <li>Klicken Sie auf "Anwenden" und dann auf "Ok".</li>\n\t\t  </ul>\n\t\t  <p>Sie werden sehen, dass der Indikator aus dem Chart entfernt wurde.</p>\n\t\t  </div>',
      },
      10: {
        label: "Kann ich mehrere Indikatoren aus dem Diagramm entfernen?",
        content:
          '<div class="content"><p>Ja, das können Sie sicher tun.</p>\n\t\t  <ul>\n\t\t  <li>Öffnen Sie den Chart, in dem Sie den Indikator entfernen möchten.</li>\n\t\t  <li>Bewegen Sie den Mauszeiger auf den Chart. Klicken Sie mit der rechten Maustaste auf den Chartbereich.</li>\n\t\t  <li>Wählen Sie \'Indikatoren einrichten\'.</li>\n\t\t  <li>Ein Fenster mit verschiedenen Indikatoren öffnet sich.</li>\n\t\t  <li>Sie können die Liste aller angewandten Indikatoren unter "aktive Indikatoren" sehen.</li>\n\t\t  <li>Klicken Sie auf die Schnellrücklauftaste " << ", um alle Indikatoren zu entfernen</li>\n\t\t  <li>Klicken Sie auf "Anwenden" und dann auf "Ok".</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      11: {
        label: "Von wo aus kann ich das Handelskursfenster öffnen?",
        content:
          '<div class="content"><p>Folgen Sie bitte den nachstehenden Schritten, um das Fenster für den Handelskurs zu öffnen:</p>\n\t\t  <ul>\n\t\t  <li>Melden Sie sich bei Ihrem Handelskonto auf der Plattform an.</li>\n\t\t  <li>Klicken Sie auf die Registerkarte "Instrument".</li>\n\t\t  <li>Bewegen Sie den Mauszeiger auf das jeweilige Instrument.</li>\n\t\t  <li>Klicken Sie mit der rechten Maustaste und wählen Sie das Fenster "Individueller Handelskurs".</li>\n\t\t  <li>Es öffnet sich ein Popup-Fenster mit dem Handelskurs des betreffenden Paares.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      12: {
        label:
          "Wie kann ich einen Auftrag aus dem Handelskursfenster heraus erteilen?",
        content:
          '<div class="content"><p>Folgen Sie bitte den nachstehenden Schritten, um das Fenster für den Handelskurs zu öffnen:</p>\n\t\t  <ul>\n\t\t  <li>Melden Sie sich bei Ihrem Handelskonto auf der Plattform an.</li>\n\t\t  <li>Klicken Sie auf die Registerkarte "Instrument".</li>\n\t\t  <li>Bewegen Sie den Mauszeiger auf das jeweilige Instrument.</li>\n\t\t  <li>Klicken Sie mit der rechten Maustaste und wählen Sie das Fenster "Individueller Handelskurs".</li>\n\t\t  <li>Es öffnet sich ein Popup-Fenster mit dem Handelskurs des betreffenden Paares.</li>\n\t\t  <li>Doppelklicken Sie auf das Pop-up, ändern Sie die gewünschten Einstellungen und klicken Sie auf \'OK\', um die Order zu platzieren.</li>\n\t\t  </ul>\n\t\t  </div>',
      },
      13: {
        label:
          "Kann ich den Auszug meines Handelskontos von der Handelsplattform herunterladen?",
        content:
          "<div class=\"content\"><p>Ja, der Handelskontoauszug kann von der Plattform heruntergeladen werden, indem Sie die folgenden Schritte ausführen:</p>\n\t\t  <ul>\n\t\t  <li>Melden Sie sich bei Ihrem Handelskonto auf der Plattform an.</li>\n\t\t  <li>Klicken Sie auf 'Berichte'.</li>\n\t\t  <li>Wählen Sie 'Kontoauszug'.</li>\n\t\t  <li>Wählen Sie das Zeitformat und klicken Sie auf 'Bericht ausführen'.</li>\n\t\t  <li>Der Bericht wird auf dem Bildschirm geöffnet. Wählen Sie 'Nach Excel exportieren'. Der Bericht wird in einer Excel-Tabelle geöffnet und kann von dort aus gespeichert werden.</li>\n\t\t  </ul>\n\t\t  </div>",
      },
      14: {
        label:
          " Ich möchte meine Verkaufsorder ändern. Wie kann ich Stop Loss und Take Profit auf meine Order anwenden?",
        content:
          "<div class=\"content\"><p>Um einen Auftrag zu ändern, öffnen Sie die Registerkarte 'Handel' in der Symbolleiste und klicken Sie auf die Schaltfläche 'Stop oder Limit'. Sie können einen Stop- oder Limit-Auftrag im Fenster Offene Positionen festlegen. Sie können auch einen vordefinierten Stop oder ein Limit im Dialogfenster Neue Position festlegen.</p></div>",
      },
      15: {
        label: "Wie kann ich einen Handel im Chart schließen?",
        content:
          '<div class="content"><p>Um eine Position zu schließen oder abzusichern, klicken Sie mit der rechten Maustaste auf das Positionsdreieck und wählen den entsprechenden Befehl.</p></div>',
      },
      16: {
        label: "Wie kann ich einen Trailing Stop zu einer Order hinzufügen?",
        content:
          "<div class=\"content\"><p>Befolgen Sie bitte die folgenden Schritte, um Ihrer Order einen Trailing Stop hinzuzufügen:</p>\n\t\t  <ul>\n\t\t  <li>Klicken Sie im Fenster Offene Positionen mit der rechten Maustaste auf die gewünschte Position.</li>\n\t\t  <li>Ein Pop-up-Menü wird auf dem Bildschirm erscheinen.</li>\n\t\t  <li>Wählen Sie das Niveau des Trailing Stop und klicken Sie auf 'OK'.</li>\n\t\t  </ul>\n\t\t  </div>",
      },
      17: {
        label: "Wo kann ich meinen Handelsverlauf einsehen?",
        content:
          '<div class="content"><p>Der Positionsverlauf kann im Fenster Geschlossene Positionen eingesehen werden.</p></div>',
      },
      18: {
        label: "Wie kann ich den Handelsverlauf auf IOS einsehen?",
        content:
          '<div class="content"><p>Um den Verlauf auf Ios anzuzeigen, klicken Sie auf Menü > Verlauf. Standardmäßig können bis zu 15 Positionen angezeigt werden. Die Anzahl der Positionen kann erhöht werden, indem Sie Menü > Einstellungen öffnen.</p></div>',
      },
      19: {
        label: "Wie kann ich einen Chart für ein Handelsinstrument öffnen?",
        content:
          "<div class=\"content\"><p>Um ein Chart-Fenster auf Ihrem Handelsarbeitsplatz zu öffnen, wählen Sie im oberen Panel-Menü 'Charts' und dann 'Neuer Chart'.</p>\n\t\t  <p>Oder</p>\n\t\t  <p>Bitte klicken Sie mit der rechten Maustaste auf ein Instrument im Fenster 'Dealing Rates' und wählen Sie 'Open Chart'. Wählen Sie das Instrument (wenn Sie mit der rechten Maustaste auf ein Instrument geklickt haben, um zum Dialogfenster 'Neuer Chart' zu gelangen, ist dieses Instrument bereits vorausgewählt) und die Zeitskala aus dem Menü 'Neuer Chart' und drücken Sie OK.\n\t\t  </p>\n\t\t  </div>",
      },
      20: {
        label: "Wie kann ich das Diagramm vergrößern und verkleinern?",
        content:
          "<div class=\"content\"><p>Am oberen Rand des Diagramms ermöglichen die Symbole '+' und '-' das Vergrößern, Verkleinern und die Standardanzeige des Diagramms.</p></div>",
      },
      21: {
        label: "Kann ich die Farben des Diagramms ändern?",
        content:
          "<div class=\"content\"><p>Ja, Sie können die Farben des Diagramms ändern. Klicken Sie mit der rechten Maustaste auf das Diagramm und wählen Sie 'Diagrammeinstellungen'. Sie sehen dann das Dropdown-Menü 'Farben'. Die Farben können entsprechend geändert werden.</p></div>",
      },
      22: {
        label: "Wo sehe ich die Kurslinie auf dem Chart?",
        content:
          '<div class="content"><p>Die Kurslinie ist die blau gefärbte Linie im Hintergrund des Charts. Sie bewegt sich entsprechend der Kursbewegung des Instruments.</p></div>',
      },
    },
    Handelsbedingungen: {
      0: {
        label:
          "Gibt es irgendwelche Einschränkungen bei der Übernahme von Handelsstilen? Ich bin ein Scalper.",
        content:
          '<div class="content"><p>Als traderfreundlicher Broker schränken wir keine Handelsstile ein. Sie können Hedging und Scalping betreiben und EAs auf Ihrer Handelsplattform verwenden.</p></div>',
      },
      1: {
        label: "Befolgen Sie die FIFO-Regel für die Handelsausführung?",
        content:
          '<div class="content"><p>Nein, wir halten uns nicht an die FIFO-Regel. Der Händler kann die Trades nach seiner eigenen Strategie schließen.</p></div>',
      },
      2: {
        label: "Welche Art der Handelsausführung bieten Sie an?",
        content:
          '<div class="content"><p>Bei AAAFx wird der Handel sofort ausgeführt.</p></div>',
      },
      3: {
        label:
          "Gibt es ein Limit für die Anzahl der Trades, die monatlich platziert werden können?",
        content:
          '<div class="content"><p>Nein, es gibt keine solchen Grenzen. Sie können nach eigenem Ermessen handeln.</p></div>',
      },
      4: {
        label: "Kann ich über das Wochenende handeln?",
        content:
          '<div class="content"><p>Nein, der Handel ist an den Wochenenden nicht möglich.</p></div>',
      },
      5: {
        label: "Wie lange kann ich meine offenen Positionen halten?",
        content:
          '<div class="content"><p>Es gibt keinen Zwang bezüglich der Dauer, für die ein Handel offen gehalten werden kann. Sie können ihn so lange offen halten, wie Sie eine ausreichende freie Marge auf dem Konto haben.</p></div>',
      },
      6: {
        label:
          "Kann ich beim Handel mit Ihnen mehr verlieren als ich eingezahlt habe?",
        content:
          '<div class="content"><p>Während Sie mit AAAFx handeln, können Sie nicht mehr verlieren als das, was Sie eingezahlt haben, denn wir bieten einen Schutz gegen negative Salden. AAAFx stellt nach eigenem Ermessen und in gutem Glauben fest, dass das Auftreten eines solchen negativen Saldos nicht auf ein böswilliges oder missbräuchliches Verhalten des Kunden zurückzuführen ist und nicht absichtlich vom Kunden verursacht wurde.</p></div>',
      },
      7: {
        label:
          "Was ist, wenn auf meinem Handelskonto keine freie Marge mehr vorhanden ist?",
        content:
          '<div class="content"><p>Wenn keine freie Marge mehr vorhanden ist, können Sie keine weiteren Aufträge erteilen. Sie können auch keinen Abhebungsantrag stellen, denn Sie können immer den Betrag abheben, der als freie Marge auf Ihrem Konto verfügbar ist.</p></div>',
      },
      8: {
        label: "Welche Arten von Spreads bieten Sie bei AAAFx an?",
        content:
          '<div class="content"><p>Wir bieten allen unseren Kunden, unabhängig von den verschiedenen Kontotypen, hauchdünne Spreads. </p></div>',
      },
      9: {
        label: "Welche Hebelwirkung bietet AAAFx?",
        content:
          '<div class="content"><p>Der maximale Hebel, der für AAAFX Europe angeboten wird, ist 30X.</p></div>',
      },
      10: {
        label: "Auf welche Zeitzone sind Ihre Server eingestellt?",
        content:
          '<div class="content"><p>Sie ist auf UTC-Zeit eingestellt [UTC +1 während der Sommerzeit].</p></div>',
      },
      11: {
        label: "Wo befinden sich Ihre Server?",
        content:
          '<div class="content"><p>Unsere Server befinden sich in London und New York.</p></div>',
      },
      12: {
        label: "Bieten Sie Ihren Kunden Handelsberatung an?",
        content:
          '<div class="content"><p>Als Broker bieten wir unseren Kunden keine Handelsberatung an. Für die idealen Handelsstrategien können Sie sich auf der Zulutrade-Website informieren und so viel wie möglich lernen. Darüber hinaus können Sie sich auch über das Verhältnis zwischen Leverage und Margin informieren, um Ihr Geld klug zu investieren. Beim Devisenhandel geht es vor allem darum, Ihre Zeit und Ihr Geld auf vernünftige Weise zu investieren. Beginnen Sie jetzt zu investieren!</p></div>',
      },
    },
  },
};
